export const COLOR_NAMES = {
  '000000': 'black',
  '000044': 'endless-galaxy',
  '000066': 'alone-in-the-dark',
  '000080': 'navy',
  '000088': 'midnight-in-tokyo',
  '00008B': 'dark-blue',
  '00009C': 'duke-blue',
  '0000AA': 'bohemian-blue',
  '0000CD': 'medium-blue',
  '0000EE': 'hyperlink-blue',
  '0000FF': 'blue',
  '00022E': 'illicit-darkness',
  '000435': 'oblivion',
  '000741': 'stratos',
  '000B44': 'storm',
  '000F89': 'phthalo-blue',
  '001000': 'cosmic-bit-flip',
  '001155': 'interstellar-blue',
  '001199': 'space-exploration',
  '0011BB': 'too-dark-tonight',
  '0011EE': 'midsummer-nights',
  '0014A8': 'zaffre',
  '0018A8': 'pantone-blue',
  '001B1C': 'swamp',
  '001B2E': 'oxford-by-night',
  '001F3F': 'midnight-mirage',
  '0020EF': 'blue-overdose',
  '002147': 'oxford-blue',
  '002233': 'midnight-dreams',
  '002266': 'midnight-melancholia',
  '002277': 'long-haul-flight',
  '002299': 'space-dust',
  '0022DD': 'brutally-blue',
  '0022EE': 'slice-of-heaven',
  '002366': 'deep-sea-nightmare',
  '002387': 'resolution-blue',
  '002395': 'imperial-blue',
  '002489': 'lost-in-heaven',
  '002900': 'deep-fir',
  '002D04': 'pcb-green',
  '002E20': 'burnham',
  '002E63': 'cool-black',
  '002FA7': 'international-klein-blue',
  '00308F': 'air-force-blue',
  '003153': 'prussian-blue',
  '003311': 'haunted-hills',
  '003322': 'pitch-black-forests',
  '003344': 'nordic-noir',
  '003366': 'dark-midnight-blue',
  '003368': 'neptunes-dream',
  '003388': 'one-minute-to-midnight',
  '003399': 'smalt',
  '0033AA': 'ua-blue',
  '0033BB': 'blue-screen-of-death',
  '0033CC': 'sapphire-glitter',
  '0034AB': 'blue-hour',
  '003532': 'deep-teal',
  '0038A8': 'royal-azure',
  '003AFF': 'c64-blue',
  '003B6F': 'tardis-blue',
  '003E40': 'cyprus',
  '004040': 'rich-black',
  '004058': 'maniac-mansion',
  '004225': 'british-racing-green',
  '004242': 'warm-black',
  '004400': 'woodland-grass',
  '004477': 'mermaid-blues',
  '004488': 'pacific-depths',
  '0044BB': 'once-in-a-blue-moon',
  '0044FF': 'rare-blue',
  '004620': 'kaitoke-green',
  '0047AB': 'cobalt-blue',
  '004816': 'crusoe',
  '0048BA': 'absolute-zero',
  '004950': 'sherpa-blue',
  '004953': 'eagle-green',
  '004B49': 'deep-jungle-green',
  '004F63': 'raging-thunderstorm',
  '004F98': 'usafa-blue',
  '00507A': 'sea-paint',
  '005511': 'swamp-monster',
  '005522': 'o-tannenbaum',
  '005572': 'night-kite',
  '005588': 'dark-denim',
  '0055DD': 'frosted-blueberries',
  '0055EE': 'opulent-blue',
  '00563B': 'castleton-green',
  '0056A7': 'endeavour',
  '005765': 'abyssal-waters',
  '005784': 'beyond-the-sea',
  '005800': 'duck-hunt',
  '00581A': 'camarone',
  '00586D': 'sea-creature',
  '005A6F': 'deep-lagoon',
  '005F7A': 'blue-collar',
  '006131': 'ficus-elastica',
  '006383': 'harem-silk',
  '006400': 'cucumber',
  '00656E': 'wakame-green',
  '006597': 'wavy-navy',
  '0065AC': 'wing-commander',
  '006600': 'pakistan-green',
  '006663': 'peacock-pride',
  '0066CC': 'science-blue',
  '0066EE': 'epic-blue',
  '0066FF': 'blue-ribbon',
  '0067A5': 'sapphire-blue',
  '006994': 'sea-blue',
  '006995': 'hydra',
  '006A4E': 'bottle-green',
  '006B3C': 'cadmium-green',
  '006C8D': 'copacabana',
  '006DB0': 'honolulu-blue',
  '00703C': 'dartmouth-green',
  '0070B8': 'spanish-blue',
  '0070FF': 'brandeis-blue',
  '00718A': 'waterworld',
  '007290': 'blue-fjord',
  '0072BB': 'french-blue',
  '0073CF': 'true-blue',
  '007474': 'skobeloff',
  '00755E': 'tropical-rain-forest',
  '0075B3': 'brilliant-blue',
  '0076A3': 'allports',
  '007733': 'forestial',
  '007744': 'succulents',
  '007799': 'pristine-seas',
  '0077BE': 'ocean-boat-blue',
  '007844': 'gale-of-the-wind',
  '007894': 'celestial',
  '007AA5': 'cg-blue',
  '007B75': 'emperor-jade',
  '007BA1': 'bleu-ciel',
  '007BA7': 'cerulean',
  '007BB8': 'star-command-blue',
  '007C76': 'wizards-orb',
  '007CAC': 'jacuzzi',
  '007EC7': 'lochmara',
  '007F5C': 'spanish-viridian',
  '007F66': 'generic-viridian',
  '007FFF': 'azure',
  '008000': 'ao',
  '008080': 'teal',
  '00827F': 'teal-green',
  '0082A1': 'ahoy-blue',
  '008400': 'lucky-clover',
  '0087BD': 'ncs-blue',
  '008800': 'fine-pine',
  '008811': 'lush-garden',
  '008833': 'broccoli-paradise',
  '0088BB': 'mermaid-dreams',
  '0088FF': 'too-blue-to-be-true',
  '008A51': 'later-gator',
  '008A7D': 'go-go-green',
  '008AAD': 'corfu-waters',
  '008B56': 'center-field',
  '008B8B': 'dark-cyan',
  '009000': 'islamic-green',
  '009051': 'moss',
  '009150': 'spanish-green',
  '0093AF': 'munsell-blue',
  '0095B6': 'bondi-blue',
  '009698': 'viridian-green',
  '00988E': 'green-dynasty',
  '009922': 'turf-master',
  '009944': 'green-revolution',
  '009966': 'green-cyan',
  '009A70': 'rainforest',
  '009B7D': 'paolo-veronese-green',
  '009DC4': 'blue-ocean',
  '009E60': 'shamrock-green',
  '009F6B': 'ncs-green',
  '00A466': 'jungle',
  '00A550': 'pigment-green',
  '00A693': 'persian-green',
  '00A86B': 'jade',
  '00A877': 'munsell-green',
  '00AA00': 'phosphor-green',
  '00AA11': 'hedged-garden',
  '00AA44': 'fennel-fiasco',
  '00AAE4': 'spanish-sky-blue',
  '00AAEE': 'vivid-cerulean',
  '00AB66': 'go-green',
  '00AD43': 'pantone-green',
  '00AF9F': 'billiard',
  '00B7EB': 'process-cyan',
  '00BAFF': 'codigrate-blue',
  '00BB00': 'green-glimmer',
  '00BB33': 'toxic-sludge',
  '00BB77': 'fennel-fiesta',
  '00BB88': 'slime-girl',
  '00BBEE': 'blue-bikini',
  '00BBFF': 'hawaii-morning',
  '00BFFE': 'tractor-beam',
  '00BFFF': 'deep-sky-blue',
  '00CC00': 'tunic-green',
  '00CC11': 'pressing-my-luck',
  '00CC33': 'vivid-malachite',
  '00CC55': 'alienated',
  '00CC99': 'caribbean-green',
  '00CCBB': 'pristine-oceanic',
  '00CCCC': 'robin-egg-blue',
  '00CCFF': 'vivid-sky-blue',
  '00CED1': 'dark-turquoise',
  '00DE00': 'nuclear-throne',
  '00EEDD': 'frozen-boubble',
  '00EEEE': 'cold-light-of-day',
  '00EEFF': 'brain-freeze',
  '00FA9A': 'medium-spring-green',
  '00FBFF': 'aggressive-aqua',
  '00FCFC': 'arctic-water',
  '00FF00': 'green',
  '00FF11': 'so-sour',
  '00FF22': 'acid',
  '00FF26': 'cyber-neon-green',
  '00FF55': 'cathode-green',
  '00FF7F': 'spring-green',
  '00FFBB': 'minty-paradise',
  '00FFCC': 'plunge-pool',
  '00FFDD': 'ice-ice-baby',
  '00FFE5': 'vibrant-mint',
  '00FFEE': 'master-sword-blue',
  '00FFEF': 'turquoise-blue',
  '00FFFF': 'cyan',
  '010203': 'black-hole',
  '010B13': 'black-knight',
  '010D1A': 'blue-charcoal',
  '011C39': 'naval-night',
  '011D13': 'holly',
  '012253': 'subnautical',
  '012731': 'daintree',
  '013220': 'dark-green',
  '01361C': 'cardin-green',
  '01371A': 'county-green',
  '013E62': 'astronaut-blue',
  '013F6A': 'regal-blue',
  '014420': 'deep-pond',
  '014421': 'up-forest-green',
  '014426': 'lost-in-the-woods',
  '014B43': 'aqua-deep',
  '015482': 'grand-bleu',
  '01554F': 'cape-verde',
  '015E85': 'orient',
  '015F97': 'hyper-blue',
  '016162': 'blue-stone',
  '01697A': 'teal-with-it',
  '016D39': 'fun-green',
  '01796F': 'pine-green',
  '01826B': 'deep-sea',
  '018281': 'windows-95-desktop',
  '018466': 'shadows-of-time',
  '018498': 'cruising',
  '01A368': 'green-haze',
  '01AD8F': 'hobgoblin',
  '01FF01': 'venom-dart',
  '01FF07': 'ega-green',
  '0203E2': 'pure-blue',
  '020F03': 'blacknt',
  '022D15': 'english-holly',
  '02402C': 'sherwood-green',
  '02478E': 'congress-blue',
  '0247FE': 'ryb-blue',
  '024A43': 'tropical-forest',
  '024ACA': 'flying-fish-blue',
  '024E46': 'evening-sea',
  '026395': 'bahama-blue',
  '02866F': 'observatory',
  '02CC02': 'demeter-green',
  '030205': 'ravens-coat',
  '03050A': 'eight-ball',
  '030AA7': 'cobalt',
  '03163C': 'tangaroa',
  '032B52': 'green-vogue',
  '032E0E': 'haunted-forest',
  '03386A': 'lost-in-space',
  '0339F8': 'vibrant-blue',
  '035096': 'medium-electric-blue',
  '035568': 'plunge',
  '036A6E': 'mosque',
  '039578': 'pool-table',
  '03C03C': 'dark-pastel-green',
  '041004': 'midnight-moss',
  '041108': 'jedi-night',
  '041322': 'black-pearl',
  '041330': 'squids-ink',
  '042E4C': 'blue-whale',
  '042E60': 'marine',
  '043927': 'sacramento-state-green',
  '044022': 'zuccini',
  '04CDFF': 'tropical-turquoise',
  '04D9FF': 'neon-blue',
  '050D25': 'void',
  '051040': 'deep-cove',
  '051657': 'gulf-blue',
  '052462': 'black-sea-night',
  '055989': 'venice-blue',
  '056608': 'deep-green',
  '05696B': 'aqua-obscura',
  '056F57': 'watercourse',
  '057BC1': 'star-of-life',
  '059033': 'north-texas-green',
  '060313': 'obsidian-shard',
  '060606': 'black-metal',
  '060929': 'mysterious-depths',
  '060B14': 'dark-rift',
  '062A78': 'catalina-blue',
  '063537': 'tiber',
  '066F6C': 'pine-scented-lagoon',
  '069AF3': 'fresh-blue-of-bel-air',
  '069B81': 'gossamer',
  '06A189': 'niagara',
  '06A9CA': 'gummy-dolphins',
  '071037': 'infinite-night',
  '072688': 'naval-adventures',
  '073A50': 'tarawera',
  '0773AF': 'cloisonn',
  '077F1B': 'poblano',
  '080110': 'jaguar',
  '080813': 'narwhal-grey',
  '082567': 'deep-sapphire',
  '082599': 'deepsea-kraken',
  '08457E': 'dark-cerulean',
  '08690E': 'leafy-lush',
  '087830': 'la-salle-green',
  '087E34': 'pharmaceutical-green',
  '088370': 'elf-green',
  '08E8DE': 'bright-turquoise',
  '08FF08': 'fluorescent-green',
  '091F92': 'indigo-dye',
  '092256': 'downriver',
  '09230F': 'palm-green',
  '09255D': 'madison',
  '095859': 'deep-sea-green',
  '097F4B': 'salem',
  '0A0502': 'liquorice',
  '0A0555': 'ravenclaw',
  '0A2F7C': 'below-the-surface',
  '0A3251': 'beyond-the-stars',
  '0A480D': 'dark-fern',
  '0A6906': 'japanese-laurel',
  '0A6F75': 'atoll',
  '0A7E8C': 'metallic-seaweed',
  '0A91BF': 'swimmer',
  '0ABAB5': 'tiffany-blue',
  '0B0B0B': 'cod-gray',
  '0B0C14': 'midnight-oil',
  '0B0F08': 'marshland',
  '0B1107': 'gordons-green',
  '0B1304': 'black-forest',
  '0B334D': 'sea-of-stars',
  '0B5509': 'forest',
  '0B6207': 'san-felix',
  '0B9D6A': 'prairie',
  '0BDA51': 'malachite',
  '0C0C0C': 'black-wash',
  '0C0D0F': 'woodsmoke',
  '0C121B': 'midnight-edition',
  '0C1793': 'royal',
  '0C1911': 'racing-green',
  '0C6064': 'beau-vert',
  '0C7A79': 'surfie-green',
  '0C8990': 'blue-chill',
  '0CFF0C': 'alien-abduction',
  '0D0332': 'black-rock',
  '0D1117': 'bunker',
  '0D1C19': 'aztec',
  '0D2E1C': 'bush',
  '0D6183': 'blue-velvet',
  '0D6323': 'woodland-wonder',
  '0D6C49': 'into-the-green',
  '0D98BA': 'blue-green',
  '0DACA7': 'teal-me-no-lies',
  '0E0702': 'blackout',
  '0E0E18': 'cinder',
  '0E191C': 'black-stallion',
  '0E1D32': 'trapped-darkness',
  '0E2A30': 'firefly',
  '0E7C61': 'deep-green-cyan-turquoise',
  '0F0707': 'knight-rider',
  '0F084B': 'silent-twilight',
  '0F0D0D': 'black-sheep',
  '0F1012': 'ruined-smores',
  '0F282F': 'black-box',
  '0F2D4D': 'midnight-ocean',
  '0F2D9E': 'torea-bay',
  '0F4D92': 'yale-blue',
  '0F521A': 'mysterious-mixture',
  '0F52BA': 'sapphire',
  '0FC0FC': 'spiro-disco-ball',
  '0FF0FE': 'aqua',
  '0FFEF9': 'kaltes-klares-wasser',
  '100C08': 'smoky-black',
  '10121D': 'vulcan',
  '101405': 'green-waterloo',
  '102030': 'the-counts-black',
  '10252A': 'sunken-ship',
  '1034A6': 'egyptian-blue',
  '105852': 'eden',
  '10F144': 'radiant-hulk',
  '110011': 'glossy-black',
  '110066': 'the-vast-of-night',
  '110077': 'insomniac-blue',
  '110101': 'dark-matter',
  '110C6C': 'arapawa',
  '111111': 'dreamless-sleep',
  '111122': 'corbeau',
  '111144': 'deadly-depths',
  '111166': 'dying-storm-blue',
  '111188': 'galactic-cruise',
  '112211': 'nightmare',
  '112244': 'dark-eclipse',
  '112255': 'dark-soul',
  '112358': 'fibonacci-blue',
  '112473': 'midnight-crest',
  '113311': 'dark-serpent',
  '114411': 'realm-of-the-underworld',
  '114C5A': 'nocturnal-expedition',
  '115500': 'donegal-green',
  '115511': 'jungle-jam',
  '115674': 'moroccan-blue',
  '115A82': 'whales-tale',
  '116356': 'philodendron',
  '1164B4': 'green-blue',
  '116611': 'overgrown-temple',
  '117755': 'greasy-greens',
  '117777': 'prismarine',
  '1177FF': 'hadfield-blue',
  '11875D': 'primal-green',
  '118822': 'asian-spice',
  '1188CC': 'way-beyond-the-blue',
  '119900': 'herbalists-garden',
  '119922': 'pestering-pesto',
  '1199EE': 'out-of-the-blue',
  '11A39E': 'silken-jade',
  '11AA00': 'always-greener-grass',
  '11AA44': 'hanging-gardens-of-babylon',
  '11AA66': 'secret-garden',
  '11BB22': 'spring-forth',
  '11BB33': 'green-goblin',
  '11BB55': 'intoxicate',
  '11CC44': 'walled-garden',
  '11CC55': 'battletoad',
  '11DD55': 'green-priestess',
  '11DD66': 'limonana',
  '11DDDD': 'fish-boy',
  '11FFEE': 'ice-temple',
  '11FFFF': 'looney-blue',
  '12110E': 'sinister',
  '121210': 'glimpse-into-space',
  '123447': 'elephant',
  '123524': 'phthalo-green',
  '12390D': 'melancholia',
  '12403C': 'botanical-night',
  '125B49': 'evergreen',
  '126180': 'blue-sapphire',
  '126B40': 'jewel',
  '127A49': 'woodland-soul',
  '130000': 'diesel',
  '130A06': 'asphalt',
  '130D07': 'balsamico',
  '131313': 'cursed-black',
  '13264D': 'blue-zodiac',
  '133337': 'elite-teal',
  '13336F': 'atlantic-navy',
  '134F19': 'parsley',
  '138808': 'india-green',
  '13EAC9': 'fake-jade',
  '140600': 'nero',
  '141311': 'dark-veil',
  '141414': 'sooty',
  '143C5D': 'poseidon',
  '1450AA': 'tory-blue',
  '145C78': 'saltwater-denim',
  '14BAB4': 'super-rare-jade',
  '150811': 'noir-fiction',
  '150AEC': 'burning-ultrablue',
  '150F5B': 'space-colonisation',
  '151515': 'matt-black',
  '151517': 'dark-void',
  '151931': 'dark-knight',
  '151F4C': 'bunting',
  '152EFF': 'vivid-blue',
  '154250': 'cold-and-dark',
  '1560BD': 'denim',
  '15736B': 'genoa',
  '157954': 'opal-green',
  '15F2FD': 'lightsaber-blue',
  '160435': 'quiet-abyss',
  '161410': 'king-kong',
  '16141C': 'back-in-black',
  '16161D': 'eigengrau',
  '161718': 'dark-moon',
  '161928': 'mirage',
  '161D3B': 'nightwalker',
  '161E34': 'sombre-night',
  '162A40': 'big-stone',
  '163222': 'celtic',
  '16322C': 'timber-green',
  '163531': 'gable-green',
  '166D29': 'enchanted-glen',
  '167D97': 'pacific-pleasure',
  '1682B9': 'mediterranean-blue',
  '16F8FF': 'hey-blue',
  '17171A': 'piano-black',
  '171F04': 'pine-tree',
  '17240B': 'midnight-pines',
  '172808': 'lindworm-green',
  '172B36': 'oceanic-noir',
  '17462E': 'zucchini',
  '175579': 'chathams-blue',
  '177245': 'dark-spring-green',
  '17F9A6': 'hyperpop-green',
  '180614': 'crow',
  '182D09': 'deep-forest-green',
  '18453B': 'msu-green',
  '18587A': 'blumine',
  '188BC2': 'cyan-cornflower-blue',
  '191916': 'twilight-zone',
  '191970': 'midnight-blue',
  '19330E': 'palm-leaf',
  '193751': 'nile-blue',
  '195905': 'lincoln-green',
  '1959A8': 'fun-blue',
  '1974D2': 'bright-navy-blue',
  '1A1110': 'licorice',
  '1A161D': 'violet-void',
  '1A1A68': 'lucky-point',
  '1A2421': 'dark-jungle-green',
  '1A4157': 'capital-blue',
  '1AC1DD': 'caribbean-blue',
  '1B0245': 'tolopea',
  '1B1035': 'haiti',
  '1B1404': 'acadia',
  '1B150D': 'soulless',
  '1B1B1B': 'eerie-black',
  '1B2431': 'dark',
  '1B2F11': 'seaweed',
  '1B3162': 'biscay',
  '1B416F': 'aegean-blue',
  '1B4D3E': 'brunswick-green',
  '1B659D': 'matisse',
  '1B6634': 'bucolic',
  '1B8A6B': 'elf',
  '1C0F33': 'midnight-monarch',
  '1C1208': 'crowshead',
  '1C1C1A': 'cocos-black',
  '1C1CF0': 'bluebonnet',
  '1C1E13': 'rangoon-green',
  '1C1E21': 'satin-deep-black',
  '1C1E4D': 'fly-by-night',
  '1C2841': 'yankees-blue',
  '1C2E63': 'mythical-night',
  '1C3378': 'twilight-express',
  '1C352D': 'medium-jungle-green',
  '1C39BB': 'persian-blue',
  '1C3B42': 'royal-neptune',
  '1C3D44': 'sunken-harbour',
  '1C401F': 'queen-of-trees',
  '1C402E': 'everglade',
  '1C4C8C': 'olympian-blue',
  '1C4D8F': 'dancing-sea',
  '1C7C7D': 'elm',
  '1CA9C9': 'pacific-blue',
  '1CAC78': 'crayola-green',
  '1D0200': 'dwarf-fortress',
  '1D0D1D': 'shot-in-the-dark',
  '1D2951': 'space-cadet',
  '1D5699': 'blue-chip',
  '1D5C83': 'oceanic-motion',
  '1D6142': 'green-pea',
  '1DACD6': 'bright-cerulean',
  '1E0F04': 'creole',
  '1E1609': 'karaka',
  '1E1708': 'el-paso',
  '1E1E21': 'inkwell-inception',
  '1E231C': 'underworld',
  '1E2433': 'moonless-mystery',
  '1E3642': 'into-the-night',
  '1E385B': 'cello',
  '1E433C': 'te-papa-green',
  '1E4581': 'maritime-outpost',
  '1E488F': 'nuit-blanche',
  '1E4D2B': 'cal-poly-green',
  '1E8CAB': 'mediterranean-sea',
  '1E90FF': 'dodger-blue',
  '1E9AB0': 'eastern-blue',
  '1F120F': 'night-rider',
  '1F1518': 'bats-cloak',
  '1F180A': 'noir-mystique',
  '1F2133': 'eclipse-elixir',
  '1F22D2': 'lapis-on-neptune',
  '1F262A': 'dark-gunmetal',
  '1F5429': 'moor-monster',
  '1F66FF': 'bluerocratic',
  '1F75FE': 'crayola-blue',
  '1FC2C2': 'java',
  '201B20': 'night-demons',
  '20208D': 'jacksons-purple',
  '202124': 'noble-black',
  '202E54': 'cloud-burst',
  '203943': 'astral-nomad',
  '204852': 'blue-dianne',
  '204D68': 'seafarer',
  '20586D': 'night-edition',
  '206874': 'persian-mosaic',
  '20B2AA': 'light-sea-green',
  '211A0E': 'eternity',
  '211D49': 'azulado',
  '211E1F': 'umbra',
  '212121': 'lead',
  '21263A': 'midnight-express',
  '21421E': 'myrtle',
  '214FC6': 'new-car',
  '216987': 'sea-goddess',
  '2188FF': 'pool-water',
  '218BA0': 'waikiki',
  '21ABCD': 'ball-blue',
  '21C40E': 'crude-banana',
  '220011': 'belladonna',
  '220022': 'black-sabbath',
  '220033': 'coal-mine',
  '220044': 'your-darkness',
  '220077': 'child-of-the-night',
  '220088': 'orbital-kingdom',
  '220878': 'deep-blue',
  '221111': 'italian-roast',
  '221188': 'nightly-expedition',
  '222233': 'black-velvet',
  '222244': 'black-market',
  '222255': 'spacescape',
  '222266': 'intergalactic-cowboy',
  '222831': 'infinity',
  '223311': 'darkest-forest',
  '223382': 'deep-space-royal',
  '224347': 'emerald-forest',
  '2243B6': 'denim-blue',
  '225599': 'fist-of-the-north-star',
  '228800': 'green-bell-pepper',
  '228B22': 'forest-green',
  '229911': 'sacro-bosco',
  '229955': 'militant-vegan',
  '2299DD': 'homeworld',
  '22AA00': 'vegetarian',
  '22BB22': 'lush-plains',
  '22BB33': 'green-with-envy',
  '22CC11': 'monstrous-green',
  '22CC88': 'magical-malachite',
  '22DDFF': 'vaporwave-blue',
  '22EEFF': 'sparky-blue',
  '22FF00': 'green-screen',
  '22FF22': 'plastic-veggie',
  '231C4D': 'silent-orbit',
  '232323': 'young-night',
  '23297A': 'st-patricks-blue',
  '232B2B': 'charleston-green',
  '233418': 'mallard',
  '234893': 'cascade-twilight',
  '234E86': 'night-mode',
  '23505A': 'sunken-mystery',
  '240093': 'dramatic-blue',
  '240C02': 'kilamanjaro',
  '241F20': 'velvet-black',
  '242124': 'raisin-black',
  '2425B9': 'sapphire-splendour',
  '242A1D': 'log-cabin',
  '243640': 'petrol-slumber',
  '244E94': 'le-grand-bleu',
  '24500F': 'green-house',
  '24646B': 'pacific',
  '247E81': 'jade-jewel',
  '24A6C2': 'true-sky-blue',
  '24DD7E': 'shivering-green',
  '251607': 'graphite',
  '251706': 'cannon-black',
  '251B19': 'dark-orchestra',
  '251F4F': 'port-gore',
  '252024': 'ink-black',
  '25272C': 'shark',
  '25311C': 'green-kelp',
  '253529': 'black-leather-jacket',
  '253F4E': 'depths-of-the-nile',
  '254770': 'pretty-twilight-night',
  '25488A': 'pacific-navy',
  '255367': 'juggernaut',
  '255C61': 'deep-sea-diver',
  '256D8D': 'chill-of-the-night',
  '2596D1': 'curious-blue',
  '25A26F': 'bejewelled',
  '25E2CD': 'ice-climber',
  '260368': 'paua',
  '26056A': 'paris-m',
  '261105': 'wood-bark',
  '261414': 'gondola',
  '262335': 'steel-gray',
  '262926': 'bitter-liquorice',
  '262A2B': 'graphite-black',
  '264348': 'japanese-indigo',
  '26619C': 'lapis-lazuli',
  '26B467': 'green-mana',
  '26FF2A': 'electric-laser-lime',
  '271B10': 'burnt-coffee',
  '27252A': 'darth-vader',
  '273287': 'intergalactic-highway',
  '273A81': 'bay-of-many',
  '273BE2': 'palatinate-blue',
  '273C5A': 'nautilus',
  '27426B': 'nightlife',
  '27454A': 'mysterious-waters',
  '27504B': 'plantation',
  '276757': 'terrestrial',
  '277ABA': 'haddocks-sweater',
  '277B74': 'ivy',
  '279D9F': 'baltic',
  '281E15': 'oil',
  '282828': 'dire-wolf',
  '28282D': 'anthracite',
  '283A77': 'astronaut',
  '28589C': 'cyan-cobalt-blue',
  '28615D': 'verdant-forest',
  '286492': 'starry-night',
  '286ACD': 'mariner',
  '290C5E': 'violent-violet',
  '292130': 'bastille',
  '292319': 'zeus',
  '292937': 'charade',
  '292B31': 'night-sky',
  '293135': 'nightmare-fuel',
  '29465B': 'one-year-of-rain',
  '295C7A': 'nautical-creatures',
  '299617': 'slimy-green',
  '29AB87': 'jungle-green',
  '2A0359': 'cherry-pie',
  '2A140E': 'coffee-bean',
  '2A2243': 'midnight-velvet',
  '2A2630': 'baltic-sea',
  '2A2A2A': 'the-end',
  '2A3439': 'gunmetal',
  '2A380B': 'turtle-green',
  '2A4F61': 'shadow-of-night',
  '2A52BE': 'cerulean-blue',
  '2A5C6A': 'night-shift',
  '2A603B': 'midori',
  '2A8000': 'napier-green',
  '2A814D': 'bold-irish',
  '2AF589': 'emerald-ice-palace',
  '2B0202': 'sepia-black',
  '2B0F2E': 'dark-prom-queen',
  '2B194F': 'valhalla',
  '2B2C30': 'caviar',
  '2B3191': 'royal-night',
  '2B3228': 'heavy-metal',
  '2B322D': 'terminal-black',
  '2B3458': 'midnight-escapade',
  '2B5D34': 'pine',
  '2B8478': 'emerald-whispers',
  '2B888D': 'turkish-jade',
  '2C0E8C': 'blue-gem',
  '2C1608': 'zinnwaldite-brown',
  '2C1620': 'black-cherry',
  '2C1632': 'revolver',
  '2C2133': 'bleached-cedar',
  '2C2C57': 'deep-sea-base',
  '2C2E47': 'midnight-masquerade',
  '2C319B': 'depths-of-night',
  '2C4170': 'napoleonic-blue',
  '2C4364': 'black-turmeric',
  '2C6FBB': 'matt-blue',
  '2C8C84': 'lochinvar',
  '2CE335': 'alarming-slime',
  '2CED2B': 'out-of-left-field',
  '2D135F': 'voldemort',
  '2D1403': 'shadow-play',
  '2D2510': 'mikado',
  '2D3796': 'liquid-denim',
  '2D4470': 'blue-funk',
  '2D454A': 'little-mermaid',
  '2D4F83': 'assassin',
  '2D517C': 'slumber',
  '2D5284': 'galaxy-blue',
  '2D569B': 'st-tropaz',
  '2DB0CE': 'aquarius',
  '2DD78D': 'envys-love',
  '2E0329': 'jacaranda',
  '2E1905': 'jacko-bean',
  '2E2364': 'indie-go',
  '2E2D88': 'cosmic-cobalt',
  '2E2E2E': 'carbon-fibre',
  '2E305E': 'galaxea',
  '2E3222': 'rangitoto',
  '2E3858': 'mediaeval-blue',
  '2E3F62': 'rhino',
  '2E4A7D': 'nautical',
  '2E5090': 'nightly-activities',
  '2E5894': 'bdazzled-blue',
  '2E5C58': 'lacrosse',
  '2E7D32': 'lush-paradise',
  '2E8B57': 'sea-green',
  '2EBFD4': 'scooter',
  '2F1064': 'infinite-inkwell',
  '2F270E': 'onion',
  '2F3434': 'phantom-ship',
  '2F3CB3': 'governor-bay',
  '2F441F': 'forestry',
  '2F4A15': 'treetop-cathedral',
  '2F4F4F': 'dark-slate-gray',
  '2F5A57': 'spectra',
  '2F6168': 'casal',
  '2F8351': 'monster-monstera',
  '2F847C': 'celadon-green',
  '2FEF10': 'vivid-green',
  '300529': 'melanzane',
  '301885': 'indiglow',
  '301934': 'dark-purple',
  '302A0F': 'woodrush',
  '303543': 'total-eclipse',
  '303A40': 'tempest-in-a-teapot',
  '304B6A': 'san-juan',
  '306030': 'mughal-green',
  '306A78': 'oceans-embrace',
  '307DD3': 'soothing-sapphire',
  '309CD0': 'blue-burst',
  '30A877': 'cosmic-green',
  '30BA8F': 'mountain-meadow',
  '311C17': 'eclipse',
  '312297': 'gentian-blue',
  '312B27': 'noir',
  '313337': 'ebony',
  '313390': 'perfect-dark',
  '314459': 'pickled-bluewood',
  '314662': 'stay-the-night',
  '314A76': 'dragonfly',
  '315955': 'enchanting-ivy',
  '31728D': 'calypso',
  '317362': 'nordic-forest',
  '317873': 'myrtle-green',
  '317D82': 'paradiso',
  '318CE7': 'bleu-de-france',
  '319177': 'illuminating-emerald',
  '32127A': 'persian-indigo',
  '32293A': 'blackcurrant',
  '322C56': 'purple-noir',
  '323232': 'mine-shaft',
  '324471': 'space-missions',
  '32496F': 'midnight-interlude',
  '324AB2': 'violet-blue',
  '324C64': 'bluedgeons',
  '325D52': 'stromboli',
  '327A88': 'panorama',
  '327C14': 'bilbao',
  '327DA0': 'astral',
  '32C6A6': 'pearl-mystic-turquoise',
  '32CD32': 'lime-green',
  '330022': 'vienna-roast',
  '330055': 'hollow-knight',
  '330066': 'deep-violet',
  '330077': 'galactic-federation',
  '3300CC': 'busty-blue',
  '33036B': 'christalle',
  '3311BB': 'galactic-highway',
  '332266': 'dark-dreams',
  '332277': 'deep-space-rodeo',
  '33292F': 'thunder',
  '332F2C': 'holy-crow',
  '333232': 'dark-charcoal',
  '333300': 'wasabi-nori',
  '333333': 'carbon',
  '333344': 'shuriken',
  '333366': 'deep-koamaru',
  '333399': 'pigment-blue',
  '333C76': 'good-karma',
  '334D41': 'pine-needle',
  '33534B': 'hunter',
  '335500': 'deep-forestial-escapade',
  '335588': 'glimpse-of-void',
  '3356AA': 'blasphemous-blue',
  '33616A': 'after-the-storm',
  '336644': 'forest-serenade',
  '337766': 'majorelle-gardens',
  '3377CC': 'fading-night',
  '3399FF': 'brilliant-azure',
  '33BB00': 'sour-apple-rings',
  '33CC00': 'candy-green',
  '33CC99': 'shamrock',
  '33EE00': 'satin-lime',
  '33FF00': 'signal-green',
  '33FF11': 'mcnuke',
  '340059': 'cotinga-purple',
  '341515': 'tamarind',
  '341758': 'fabric-of-space',
  '34282C': 'smoky-charcoal',
  '343434': 'jet',
  '34466C': 'forlorn-cruise',
  '344D58': 'nocturne',
  '345C61': 'arctic-nights',
  '3473B7': 'campanula',
  '34B334': 'try-your-luck',
  '350E42': 'valentino',
  '350E57': 'jagger',
  '352B30': 'mystical-shadow',
  '353337': 'jet-black',
  '35343F': 'witches-cauldron',
  '353542': 'tuna',
  '353838': 'wet-concrete',
  '353839': 'onyx',
  '353F51': 'dark-and-stormy',
  '354230': 'kombu-green',
  '354E8C': 'chambray',
  '355E3B': 'hunter-green',
  '359E6B': 'bulma-hair',
  '35B76D': 'turtle-warrior',
  '35FA00': 'plutonium',
  '361D0A': 'close-but-no-cigar',
  '363050': 'martinique',
  '363534': 'tuatara',
  '363B43': 'do-not-disturb',
  '363C0D': 'waiouru',
  '363E7D': 'evening-magic',
  '36454F': 'charcoal',
  '366D68': 'deep-pool-teal',
  '36747D': 'ming',
  '367588': 'teal-blue',
  '368716': 'la-palma',
  '36A5C9': 'laguna',
  '371D09': 'clinker',
  '372354': 'stormy-night',
  '37290E': 'brown-tumbleweed',
  '372A05': 'secret-passage',
  '372D52': 'midnight-pie',
  '373021': 'birch',
  '37393E': 'artists-charcoal',
  '373E02': 'dark-olive',
  '37525F': 'nocturne-blue',
  '377475': 'oracle',
  '377B70': 'pearl-green',
  '380474': 'blue-diamond',
  '383533': 'dune',
  '383838': 'lacquered-liquorice',
  '38393F': 'after-midnight',
  '384910': 'clover',
  '384B6B': 'naval-blue',
  '387ABE': 'mykonos',
  '38914A': 'wild-forest',
  '391285': 'pixie-powder',
  '391531': 'nightly-voyager',
  '392D2B': 'mole',
  '393540': 'professor-plum',
  '393F4B': 'inkblot',
  '394851': 'limed-spruce',
  '394C3B': 'mountain-view',
  '394D78': 'noble-knight',
  '395D68': 'under-the-sea',
  '39636A': 'mediterranea',
  '396413': 'dell',
  '39766C': 'green-sleeves',
  '3992A8': 'blue-moon',
  '3994AF': 'enchanted-well',
  '39A78E': 'zomp',
  '39AD48': 'matt-green',
  '39FF14': 'neon-green',
  '3A0020': 'toledo',
  '3A1F76': 'explorer-of-the-galaxies',
  '3A2010': 'sambuca',
  '3A2A6A': 'jacarta',
  '3A3532': 'kilimanjaro',
  '3A4866': 'bonne-nuit',
  '3A4A63': 'silent-sea',
  '3A533D': 'highlander',
  '3A5B52': 'iridescent',
  '3A5F49': 'herbes-de-provence',
  '3A686C': 'william',
  '3A6A47': 'killarney',
  '3A7099': 'windsurfing',
  '3A797E': 'divers-eden',
  '3AB09E': 'keppel',
  '3AB0A2': 'waterfall',
  '3B0346': 'romanic-scene',
  '3B0910': 'aubergine',
  '3B1921': 'bruised-plum',
  '3B1F1F': 'jon',
  '3B2820': 'treehouse',
  '3B2B2C': 'havana',
  '3B2F2F': 'smoked-black-coffee',
  '3B331C': 'pullman-green',
  '3B3A3A': 'dead-pixel',
  '3B3B3D': 'coal-hard-truth',
  '3B3C36': 'black-olive',
  '3B3C41': 'in-the-dark',
  '3B3F40': 'tamahagane',
  '3B444B': 'arsenic',
  '3B476B': 'starlit-night',
  '3B5760': 'great-void',
  '3B593A': 'ficus',
  '3B638C': 'mississippi-river',
  '3B719F': 'muted-blue',
  '3B7A57': 'amazon',
  '3B91B4': 'boston-blue',
  '3C0878': 'windsor',
  '3C1206': 'rebel',
  '3C1414': 'dark-sienna',
  '3C1421': 'chocolate-kiss',
  '3C1F76': 'meteorite',
  '3C2005': 'medium-roast',
  '3C2F4E': 'sanctum-of-shadows',
  '3C341F': 'olive-drab-seven',
  '3C3535': 'after-dark',
  '3C3910': 'camouflage',
  '3C393D': 'moonless-night',
  '3C4151': 'bright-gray',
  '3C4443': 'cape-cod',
  '3C463E': 'deep-forest',
  '3C493A': 'lunar-green',
  '3C4D03': 'godzilla',
  '3C4F4E': 'night-watch',
  '3C663E': 'jurassic-park',
  '3C69E7': 'bluetiful',
  '3C773C': 'cucumber-queen',
  '3C85BE': 'king-triton',
  '3C9992': 'sea',
  '3CB371': 'medium-sea-green',
  '3CBCFC': 'megaman',
  '3CD070': 'ufo-green',
  '3D0C02': 'black-bean',
  '3D2B1F': 'bistre',
  '3D322E': 'six-feet-under',
  '3D3D63': 'storm-is-coming',
  '3D4585': 'queen-of-the-night-shift',
  '3D474B': 'lights-out',
  '3D6C54': 'toad-king',
  '3D7016': 'forest-empress',
  '3D7049': 'parsley-sprig',
  '3D7D52': 'goblin',
  '3D8B37': 'resplendent-growth',
  '3D8ED0': 'magical-merlin',
  '3E0480': 'kingfisher-daisy',
  '3E1825': 'black-hearted',
  '3E1C14': 'cedar',
  '3E2723': 'ethereal-espresso',
  '3E2B23': 'english-walnut',
  '3E2C1C': 'black-marlin',
  '3E3A44': 'ship-gray',
  '3E4244': 'metropolitan-silhouette',
  '3E4364': 'genie',
  '3E4855': 'starless-night',
  '3E5361': 'dark-secret',
  '3E5E4E': 'ethereal-woods',
  '3E6334': 'greenhouse',
  '3E6D6A': 'moonlit-forest',
  '3E6F87': 'crashing-waves',
  '3E7A85': 'mysterious-blue',
  '3EABBF': 'pelorous',
  '3EB489': 'mint',
  '3F00FF': 'ultramarine',
  '3F012C': 'dark-sanctuary',
  '3F2500': 'cola',
  '3F3002': 'madras',
  '3F307F': 'minsk',
  '3F354F': 'maharaja',
  '3F3C43': 'tuxedo',
  '3F4250': 'madonna',
  '3F4551': 'dark-crypt',
  '3F4C3A': 'cabbage-pont',
  '3F583B': 'tom-thumb',
  '3F5865': 'stargazer',
  '3F5D53': 'mineral-green',
  '3F9B0B': 'grass-is-greener',
  '3FC1AA': 'puerto-rico',
  '3FFF00': 'harlequin',
  '401801': 'brown-pod',
  '40291D': 'cork',
  '403547': 'royal-decree',
  '403B38': 'masala',
  '403D19': 'thatch-green',
  '404404': 'green-not-found',
  '404C57': 'abyssal',
  '405169': 'fiord',
  '405E5C': 'rosemary',
  '40826D': 'viridian',
  '40A860': 'chateau-green',
  '40E0D0': 'turquoise',
  '410056': 'ripe-plum',
  '411F10': 'paco',
  '412010': 'deep-oak',
  '41373A': 'void-wellness-coach',
  '413C37': 'merlin',
  '413D4B': 'italian-grape',
  '414257': 'gun-powder',
  '41434E': 'midnight-serenade',
  '414549': 'stargazing',
  '414A4C': 'outer-space',
  '414C7D': 'east-bay',
  '415B36': 'turf',
  '4166F5': 'ultramarine-blue',
  '416858': 'june-ivy',
  '4169E1': 'royal-blue',
  '41729F': 'naval',
  '417491': 'harbour-blue',
  '41767B': 'ocean-slumber',
  '417DC1': 'tufts-blue',
  '419168': 'illuminati-green',
  '41A94F': 'leapfrog',
  '420303': 'burnt-maroon',
  '42364C': 'call-it-a-night',
  '423921': 'lisbon-brown',
  '424242': 'black-panther',
  '424443': 'vulcanised',
  '424753': 'midnight-sky',
  '424C4A': 'urban-chic',
  '425267': 'into-the-stratosphere',
  '427898': 'cry-me-a-river',
  '427977': 'faded-jade',
  '4286BC': 'warm-spring',
  '428C49': 'underclover',
  '431560': 'scarlet-gum',
  '431705': 'old-study',
  '431C53': 'plunged-into-darkness',
  '432E6F': 'her-highness',
  '43302E': 'old-burgundy',
  '433120': 'iroko',
  '433E37': 'armadillo',
  '434B4F': 'dead-forest',
  '434C59': 'river-bed',
  '43535E': 'nightfall',
  '436A0D': 'green-leaf',
  '436B95': 'queen-blue',
  '4376AB': 'blue-triumph',
  '439946': 'kryptonite-green',
  '43B3AE': 'verdigris',
  '440099': 'space-battle-blue',
  '4400FF': 'overdue-blue',
  '44012D': 'barossa',
  '441100': 'black-chocolate',
  '441111': 'english-breakfast',
  '441122': 'what-we-do-in-the-shadows',
  '441144': 'velvet-cosmos',
  '4411FF': 'blustering-blue',
  '441D00': 'morocco-brown',
  '442244': 'purple-void',
  '442266': 'fading-horizon',
  '442288': 'galactic-civilization',
  '443388': 'majestic-eggplant',
  '44413C': 'deepest-nightmare',
  '444411': 'alligator-gladiator',
  '444499': 'galaxy-express',
  '444954': 'mako',
  '444B43': 'ancient-pine',
  '444B4A': 'moonless-sky',
  '444C38': 'rifle-green',
  '445055': 'obsidian',
  '445155': 'descent-into-the-catacombs',
  '445533': 'zen-garden-olive',
  '44556B': 'inkjet',
  '445780': 'sailor',
  '4466CC': 'god-of-rain',
  '446CCF': 'han-blue',
  '447744': 'autumn-crocodile',
  '447777': 'tropical-rain',
  '4477DD': 'skies-of-cyberspace',
  '448811': 'kelp-forest',
  '448833': 'overgrown-mausoleum',
  '4488AA': 'underwater-moonlight',
  '449084': 'highlands',
  '4499AA': 'rainy-mood',
  '4499FF': 'sky-dancer',
  '44AA11': 'botanical-garden',
  '44AA55': 'devils-grass',
  '44AA77': 'jubilant-jade',
  '44AADD': 'thalassophile',
  '44BBFF': 'glitter-lake',
  '44CCFF': 'thors-thunder',
  '44D7A8': 'eucalyptus',
  '44DD66': 'hello-spring',
  '44DDFF': 'splashing-wave',
  '44EE00': 'nuclear-meltdown',
  '452207': 'chocolate-castle',
  '45362B': 'dark-rum',
  '45392F': 'batch-brew',
  '454936': 'kelp',
  '455454': 'all-nighter',
  '456CAC': 'san-marino',
  '4575AD': 'sail-on',
  '457B74': 'turquoise-tortoise',
  '45B1E8': 'picton-blue',
  '45E9C1': 'aphrodite-aqua',
  '460B41': 'loulou',
  '462425': 'crater-brown',
  '463D3E': 'black-truffle',
  '46565F': 'good-night',
  '465945': 'gray-asparagus',
  '46647E': 'stellar',
  '4664A5': 'starstruck',
  '466590': 'sea-of-galilee',
  '4682B4': 'steel-blue',
  '4682BF': 'cyan-blue-azure',
  '468D45': 'lush-grass',
  '46A795': 'jewel-weed',
  '46B5C0': 'glassmith',
  '46C299': 'macau',
  '46CB18': 'harlequin-green',
  '472E97': 'galactic-purple',
  '473933': 'film-noir',
  '474C50': 'witchcraft',
  '474D52': 'sooty-lashes',
  '475C5D': 'woodland-night',
  '476E42': 'under-the-radar',
  '47ABCC': 'maximum-blue',
  '47AE9C': 'ambrosial-oceanside',
  '480404': 'rustic-red',
  '480607': 'bulgarian-rose',
  '480656': 'clairvoyant',
  '481C1C': 'cocoa-bean',
  '483131': 'woody-brown',
  '48357B': 'galactic-compass',
  '483C32': 'taupe',
  '483C41': 'pitch-black',
  '483D8B': 'dark-slate-blue',
  '48A8D0': 'mystic-blue',
  '48BF91': 'ocean-green',
  '48D1CC': 'medium-turquoise',
  '49170C': 'van-cleef',
  '492615': 'brown-derby',
  '492A34': 'wine-tasting',
  '49371B': 'metallic-bronze',
  '49463F': 'whiskey-and-wine',
  '494C55': 'deep-night',
  '494D55': 'isolation',
  '494E4F': 'cover-of-night',
  '495252': 'dark-as-night',
  '495400': 'verdun-green',
  '49583E': 'heavy-green',
  '496679': 'blue-bayoux',
  '497183': 'bismark',
  '49747F': 'hydro',
  '497A9F': 'zenith',
  '4997D0': 'celestial-blue',
  '4A0A00': 'lonely-chocolate',
  '4A120D': 'minotaur-hide',
  '4A2559': 'wonka-purple',
  '4A2A04': 'bracken',
  '4A2C2A': 'brown-coffee',
  '4A2D2F': 'dark-roast',
  '4A3004': 'deep-bronze',
  '4A3C30': 'mondo',
  '4A4244': 'tundora',
  '4A444B': 'gravel',
  '4A4747': 'dampened-black',
  '4A4E5A': 'trout',
  '4A5C6A': 'seven-seas',
  '4A5D23': 'dark-moss-green',
  '4A5D5F': 'still-waters-run-deep',
  '4A646C': 'deep-space-sparkle',
  '4A73A8': 'song-of-the-sea',
  '4A7D82': 'submerged',
  '4AAE97': 'hole-in-one',
  '4AFF00': 'chlorophyll-green',
  '4B0082': 'indigo',
  '4B0183': 'indigo-static',
  '4B1E87': 'occult',
  '4B2C74': 'mystic-nights',
  '4B3621': 'cafe-noir',
  '4B373A': 'vibrant-vine',
  '4B5320': 'army-green',
  '4B5338': 'broccoli-green',
  '4B57DB': 'warm-blue',
  '4B5D46': 'muddy-olive',
  '4B5D52': 'nandor',
  '4B61D1': 'savoy-blue',
  '4B7079': 'winter-storm',
  '4B9B93': 'lagoon',
  '4BC7CF': 'sea-serpent',
  '4BEC13': 'becquerel',
  '4C2882': 'spanish-violet',
  '4C3024': 'saddle',
  '4C4B4C': 'shady-character',
  '4C4F56': 'abbey',
  '4C516D': 'independence',
  '4C567A': 'deep-indigo',
  '4C6177': 'night-market',
  '4C9141': 'may-green',
  '4C9C77': 'natural-orchestra',
  '4CA8E0': 'high-blue',
  '4CBB17': 'kelly-green',
  '4CBDAC': 'emerald-bliss',
  '4CFF7B': 'experimintal-green',
  '4D0135': 'blackberry',
  '4D0A18': 'cab-sav',
  '4D1E01': 'indian-tan',
  '4D282D': 'cowboy',
  '4D282E': 'livid-brown',
  '4D3833': 'rock',
  '4D3D14': 'punga',
  '4D400F': 'bronzetone',
  '4D516C': 'intergalactic',
  '4D5328': 'woodland',
  '4D5B88': 'wizard',
  '4D5D53': 'feldgrau',
  '4D6D08': 'over-the-hills',
  '4D6E2F': 'botanical',
  '4DBBAF': 'tropical-escape',
  '4E1609': 'french-puce',
  '4E1B0B': 'chocolate-rush',
  '4E241E': 'torrefacto-roast',
  '4E2A20': 'couch',
  '4E2A5A': 'bossanova',
  '4E334E': 'shadow-purple',
  '4E3B41': 'matterhorn',
  '4E3E1F': 'avocado-stone',
  '4E420C': 'bronze-olive',
  '4E4562': 'mulled-wine',
  '4E4B35': 'olive-leaf',
  '4E5180': 'purple-navy',
  '4E5481': 'dusk',
  '4E5A4A': 'verdant-hush',
  '4E6649': 'axolotl',
  '4E7376': 'rogue-waters',
  '4E7F9E': 'wedgewood',
  '4E82B4': 'cyan-azure',
  '4E8747': 'beanpole',
  '4EABD1': 'shakespeare',
  '4F1C70': 'honey-flower',
  '4F2398': 'daisy-bush',
  '4F284B': 'murasaki',
  '4F2923': 'bitter-chocolate',
  '4F325E': 'royal-crown',
  '4F3A3C': 'dark-puce',
  '4F42B5': 'ocean-blue',
  '4F4554': 'black-magic',
  '4F4744': 'espresso-macchiato',
  '4F4D32': 'jungle-king',
  '4F4E4A': 'subterrain-kingdom',
  '4F566C': 'heavy-violet',
  '4F666A': 'stormcloud',
  '4F6F85': 'shipyard',
  '4F7694': 'beach-view',
  '4F7942': 'fern-green',
  '4F7BA7': 'into-the-blue',
  '4F86F7': 'blueberry',
  '4F8FE6': 'olympic-blue',
  '4F9D5D': 'fruit-salad',
  '4FA83D': 'apple',
  '50404D': 'purple-taupe',
  '504351': 'mortar',
  '50507F': 'tangent-periwinkle',
  '50647F': 'admiral-blue',
  '507096': 'kashmir-blue',
  '5072A7': 'blue-yonder',
  '507672': 'cutty-sark',
  '507BCE': 'serenitys-reign',
  '507D2A': 'sap-green',
  '5087BD': 'sea-salt-rivers',
  '5097FC': 'polar-glow',
  '50C878': 'emerald',
  '514649': 'emperor',
  '51484F': 'quartz',
  '51588E': 'piccadilly-purple',
  '516E3D': 'chalet-green',
  '517933': 'luscious-lemongrass',
  '517C66': 'como',
  '51808F': 'smalt-blue',
  '5182B9': 'fisher-king',
  '51A5A4': 'twilight-meadow',
  '52001F': 'castro',
  '520B00': 'burned',
  '520C17': 'maroon-oak',
  '5218FA': 'han-purple',
  '522000': 'evil-cigar',
  '522D80': 'regalia',
  '523C94': 'gigas',
  '523F31': 'turtle',
  '525054': 'magnet',
  '525463': 'black-orchid',
  '5260E1': 'arcane-brew',
  '526771': 'silent-night',
  '52B4CA': 'blue-bobbin',
  '52B4D3': 'blue-martini',
  '52C1B3': 'treasured-teal',
  '533455': 'voodoo',
  '533CC6': 'royal-nightcore',
  '534491': 'victoria',
  '534B4F': 'dark-liver',
  '534C4B': 'off-the-beaten-path',
  '535E64': 'lava-rock',
  '536872': 'cadet',
  '536878': 'paynes-grey',
  '536895': 'ucla-blue',
  '53734C': 'irish-clover',
  '53824B': 'hippie-green',
  '53B1BA': 'thalassa',
  '53F6FF': 'frozen-turquoise',
  '540D6E': 'velvet-vortex',
  '541012': 'heath',
  '543254': 'purple-prose',
  '543D37': 'horses',
  '544333': 'judge-gray',
  '544563': 'nightly-walk',
  '54534D': 'fuscous-gray',
  '545663': 'blackwater',
  '545AA7': 'liberty',
  '54626F': 'black-coral',
  '54682B': 'bimi-green',
  '549019': 'vida-loca',
  '54AF9C': 'water-park',
  '54D905': 'corrosive-green',
  '550055': 'cloak-and-dagger',
  '551155': 'cosmic-explorer',
  '5511CC': 'sea-serpents-tears',
  '5511DD': 'space-opera',
  '552367': 'elegant-purple-gown',
  '55280C': 'cioccolato',
  '553311': 'moelleux-au-chocolat',
  '5533FF': 'meteor-shower',
  '553592': 'blue-magenta-violet',
  '5539CC': 'blurple',
  '553B39': 'monkey-island',
  '554747': 'chinotto',
  '555555': 'davys-grey',
  '555570': 'majestic-magic',
  '555B10': 'saratoga',
  '555B59': 'crucible',
  '556600': 'serrano-pepper',
  '556611': 'forestial-outpost',
  '556962': 'dark-forest',
  '556B2F': 'dark-olive-green',
  '556D56': 'finlandia',
  '5577EE': 'blue-yster-cult',
  '558800': 'pesto-alla-genovese',
  '558844': 'the-legend-of-green',
  '5588DD': 'blue-jay',
  '5588FF': 'skinny-jeans',
  '558E4C': 'victorian-garden',
  '5590D9': 'havelock-blue',
  '55A9D6': 'cousteau',
  '55AA00': 'yoshi',
  '55B492': 'electra',
  '55BB33': 'exit-light',
  '55BB88': 'bleached-olive',
  '55BBFF': 'hello-summer',
  '55CC11': 'verminal',
  '55CCBB': 'peppy-peacock',
  '55DD00': 'tropical-funk',
  '55DDCC': 'jazzy-jade',
  '55EE00': 'furious-frog',
  '55FF11': 'poisonous',
  '55FF22': 'traffic-green',
  '560319': 'dark-scarlet',
  '563C0D': 'pineapple',
  '563C5C': 'old-heliotrope',
  '565266': 'freefall',
  '565350': 'heavy-charcoal',
  '566062': 'yacht-club',
  '566373': 'midnight-shadow',
  '567AAD': 'endless-river',
  '568203': 'avocado',
  '56887D': 'wintergreen-dream',
  '56A0D3': 'carolina-blue',
  '56ACCA': 'frozen-wave',
  '56B4BE': 'fountain-blue',
  '56FCA2': 'illicit-green',
  '571E2F': 'drops-of-god',
  '572B26': 'worcestershire-sauce',
  '572E89': 'night-fever',
  '573894': 'ruthless-empress',
  '57446A': 'haunted-candelabra',
  '574A47': 'molasses',
  '577396': 'clean-slate',
  '578363': 'spring-leaves',
  '57958B': 'martian-cerulean',
  '579ACA': 'canadian-tuxedo',
  '57A1CE': 'sub-zero',
  '581A57': 'purple-velour',
  '58427C': 'cyber-grape',
  '585562': 'scarpa-flow',
  '585D40': 'cypress',
  '587156': 'cactus',
  '5879A2': 'montreux-blue',
  '588C3A': 'indica',
  '589AAF': 'hippie-blue',
  '58A64B': 'jungle-jewels',
  '58BC08': 'frog',
  '58C8B6': 'cockatoo',
  '58D854': 'koopa-green-shell',
  '591D35': 'wine-berry',
  '59260B': 'seal-brown',
  '592720': 'caput-mortuum',
  '592804': 'brown-bramble',
  '5930A9': 'royalty',
  '593737': 'congo-brown',
  '594433': 'millbrook',
  '5946B2': 'plump-purple',
  '595D45': 'tree-of-life',
  '59A4C1': 'surgical',
  '59B9CC': 'high-dive',
  '59C8A5': 'mermaids-kiss',
  '5A3D29': 'peat-brown',
  '5A4FCF': 'iris',
  '5A5E61': 'blindfolded',
  '5A6E9C': 'waikawa-gray',
  '5A789A': 'quiet-harbour',
  '5A8643': 'shepherds-green',
  '5A87A0': 'horizon',
  '5A88C8': 'marina',
  '5A9E4B': 'golf-course',
  '5AA7A0': 'paradise-island',
  '5B1E8B': 'intergalactic-settlement',
  '5B3013': 'jambalaya',
  '5B3167': 'imperial-purple',
  '5B3256': 'japanese-violet',
  '5B3F34': 'espresso-bar',
  '5B4276': 'drifting-violet',
  '5B92E5': 'united-nations-blue',
  '5C0120': 'bordeaux',
  '5C0536': 'mulberry-wood',
  '5C1C39': 'soul-anchor',
  '5C2E01': 'carnaby-tan',
  '5C2E88': 'purple-patch',
  '5C3612': 'chocolate-fantasies',
  '5C457B': 'in-the-vines',
  '5C5083': 'freshly-purpleized',
  '5C5D5D': 'knights-armour',
  '5C5D75': 'comet',
  '5C606E': 'concrete-landscape',
  '5C7287': 'plumbeous',
  '5C821A': 'enchanted-forest',
  '5C97CF': 'winter-lake',
  '5C9F59': 'savage-garden',
  '5CA0A7': 'atlas-cedar',
  '5CA904': 'ruminants-paradise',
  '5CAC2D': 'grass',
  '5CB200': 'kermit-green',
  '5CCD97': 'vegetation',
  '5D3954': 'dark-byzantium',
  '5D4C51': 'don-juan',
  '5D5C58': 'chicago',
  '5D6098': 'wizards-potion',
  '5D66AA': 'bellflower',
  '5D7747': 'dingley',
  '5D7B89': 'night-owl',
  '5D89BA': 'silver-lake-blue',
  '5D8AA8': 'royal-air-force-blue',
  '5DA19F': 'breaker-bay',
  '5DA464': 'endo',
  '5DA493': 'polished-pine',
  '5DADEC': 'blue-jeans',
  '5DB0BE': 'finnish-fiord',
  '5E0E0B': 'sacramental-red',
  '5E2912': 'hot-fudge',
  '5E2D10': 'count-chocula',
  '5E483E': 'kabul',
  '5E4A47': 'mustang',
  '5E5755': 'smokescreen',
  '5E582B': 'reptile-revenge',
  '5E5D3B': 'hemlock',
  '5E7B7F': 'north-atlantic',
  '5E7E7D': 'stream-burble',
  '5E8B3D': 'hidden-paradise',
  '5EE7DF': 'near-moon',
  '5F2C2F': 'jazz',
  '5F3D26': 'irish-coffee',
  '5F5537': 'olive-bark',
  '5F5854': 'bark',
  '5F5F6E': 'mid-gray',
  '5F606E': 'venus-mist',
  '5F6672': 'shuttle-gray',
  '5F674B': 'monstera',
  '5F6957': 'italian-basil',
  '5F6D6E': 'wrapped-in-twilight',
  '5F6DB0': 'loch-ness',
  '5F8A8B': 'steel-teal',
  '5F9EA0': 'cadet-blue',
  '5FA052': 'muted-green',
  '5FA777': 'aqua-forest',
  '5FA778': 'shiny-shamrock',
  '5FB3AC': 'tradewind',
  '600000': 'spikey-red',
  '602F6B': 'imperial',
  '603231': 'rampant-rhubarb',
  '60443F': 'death-by-chocolate',
  '604913': 'horses-neck',
  '604C81': 'sumptuous-purple',
  '604D47': 'lynx',
  '60504B': 'chocolate-pretzel',
  '6050DC': 'majorelle-blue',
  '605244': 'volcanic-island',
  '605258': 'pinot-noir',
  '605B73': 'smoky',
  '605E63': 'cloak-grey',
  '606E68': 'corduroy',
  '607C8E': 'whale-shark',
  '6082B6': 'glaucous',
  '6093D1': 'danube',
  '60BFD3': 'skydive',
  '610507': 'vampire-hunter',
  '612718': 'espresso',
  '612E32': 'chocolate-truffle',
  '614051': 'eggplant',
  '61496E': 'your-majesty',
  '614A7B': 'royal-robe',
  '61574E': 'major-brown',
  '61584F': 'metropolis',
  '615D30': 'costa-del-sol',
  '616669': 'grey-web',
  '616C51': 'hinterland',
  '61845F': 'glade-green',
  '619AD6': 'blue-bay',
  '620B15': 'cherry-picking',
  '622F30': 'buccaneer',
  '623B70': 'heartless',
  '623D2E': 'chocolate-escape',
  '623F2D': 'quincy',
  '624A49': 'dark-chocolate',
  '624E9A': 'butterfly-bush',
  '625119': 'west-coast',
  '625C58': 'caveman',
  '626649': 'finch',
  '628468': 'clouded-pine',
  '62A5DF': 'windjammer',
  '63209B': 'wild-violet',
  '632F92': 'lucid-dreams',
  '633F2E': 'grilled',
  '635147': 'umber',
  '635D63': 'wonder-wine',
  '636CA8': 'twinkle-night',
  '63884A': 'homegrown',
  '639A8F': 'patina',
  '63B76C': 'fern',
  '640F09': 'blood-of-zeus',
  '644117': 'pullman-brown',
  '644348': 'plum-intended',
  '64435F': 'grape-fizz',
  '645452': 'wenge',
  '646077': 'dolphin',
  '646463': 'storm-dust',
  '646A54': 'siam',
  '646B7A': 'ashen-whisper',
  '646E75': 'nevada',
  '648251': 'kale',
  '648589': 'arctic',
  '6495ED': 'cornflower-blue',
  '64BFA4': 'spearmint',
  '64CCDB': 'viking',
  '64E986': 'grotesque-green',
  '65000B': 'rosewood',
  '650021': 'merguez',
  '651A14': 'cherrywood',
  '652793': 'queens-of-the-dead',
  '653B66': 'wine-tour',
  '654161': 'royal-plum',
  '654243': 'wild-thing',
  '654321': 'dark-brown',
  '654B37': 'black-power',
  '654EA3': 'ultrapurple-merge',
  '654F2D': 'jungle-beat',
  '655883': 'berry-jam',
  '656874': 'alley-cat',
  '656E72': 'batman',
  '657220': 'fern-frond',
  '657432': 'muddy-green',
  '65745D': 'willow-grove',
  '65769A': 'misty-harbour',
  '657AEF': 'pan-purple',
  '657D82': 'catfish',
  '657F7A': 'underwater-world',
  '65869F': 'hoki',
  '658FAA': 'treasure-map-waters',
  '659C35': 'radiant-foliage',
  '65A7DD': 'acapulco-dive',
  '65DCD6': 'hammam-blue',
  '660011': 'darkest-dungeon',
  '660045': 'pompadour',
  '66023C': 'tyrian-purple',
  '661020': 'forbidden-passion',
  '661188': 'extraviolet',
  '662288': 'sapphire-siren',
  '663311': 'meatloaf',
  '663322': 'freshly-roasted-coffee',
  '663366': 'wineberry',
  '663399': 'rebecca-purple',
  '6633BB': 'purple-emperor',
  '663854': 'halayà-úbe',
  '664228': 'van-dyke-brown',
  '664238': 'brunette',
  '66424D': 'deep-tuscan-red',
  '664411': 'very-coffee',
  '664422': 'floridas-alligator',
  '664488': 'lords-of-the-night',
  '664C28': 'donkey-brown',
  '665134': 'wild-chocolate',
  '665500': 'ayahuasca-vine',
  '665A51': 'underground',
  '665D1E': 'antique-bronze',
  '666699': 'dark-blue-gray',
  '666A47': 'bancha',
  '667700': 'topiary-green',
  '667744': 'ghoul',
  '6677BB': 'flood',
  '66787E': 'night-rendezvous',
  '669841': 'bitter-leaf',
  '669900': 'geckos-dream',
  '669999': 'desaturated-cyan',
  '6699CC': 'blue-gray',
  '66A4B0': 'seaside',
  '66AA22': 'green-symphony',
  '66B032': 'ryb-green',
  '66B58F': 'silver-tree',
  '66BB00': 'emerald-glitter',
  '66CC00': 'blinking-terminal',
  '66CCCC': 'petrichor',
  '66DDAA': 'medium-aquamarine',
  '66EEBB': 'onsen',
  '66EEEE': 'poseidon-jr',
  '66FC00': 'fertility-green',
  '66FF00': 'bright-green',
  '66FF22': 'venomous-green',
  '66FF66': 'screamin-green',
  '67032D': 'black-rose',
  '670728': 'plum-cheese',
  '673147': 'wine-dregs',
  '673362': 'opulent-purple',
  '673E6E': 'majesty',
  '674834': 'buckeye',
  '674876': 'neon-violet',
  '674C47': 'liver',
  '675A75': 'plummy',
  '675FA6': 'scampi',
  '67614F': 'ivy-topiary',
  '676168': 'excalibur',
  '676662': 'ironside-gray',
  '676767': 'granite-gray',
  '67786E': 'camping-trip',
  '677F70': 'ecological',
  '678779': 'aloe-vera',
  '679B6A': 'leafy',
  '67A195': 'emerald-oasis',
  '67A712': 'christi',
  '682860': 'palatinate-purple',
  '683600': 'nutmeg-wood-finish',
  '683939': 'hot-chocolate',
  '684F3C': 'tobacco',
  '685558': 'zambezi',
  '685E6E': 'salt-box',
  '686D70': 'beautiful-darkness',
  '688049': 'beyond-the-pines',
  '689938': 'hidden-valley',
  '689DB7': 'lake-lucerne',
  '68C2F5': 'blue-mana',
  '692302': 'roastery',
  '692545': 'tawny-port',
  '692D54': 'finn',
  '69359C': 'purple-heart',
  '693F43': 'red-rumour',
  '69444F': 'wine-stain',
  '695F62': 'scorpion',
  '69673A': 'jungle-civilization',
  '696845': 'eat-your-greens',
  '696969': 'dim-gray',
  '697E9A': 'lynch',
  '698589': 'thundercloud',
  '6A2F2F': 'arcane-red',
  '6A442E': 'spice',
  '6A5ACD': 'slate-blue',
  '6A5D1B': 'himalaya',
  '6A6051': 'soya-bean',
  '6A6887': 'heron',
  '6A6B65': 'armoury',
  '6A7E5F': 'emerald-city',
  '6A7F8B': 'citadel',
  '6A819E': 'bay-view',
  '6A8389': 'puddle-jumper',
  '6A8E22': 'asparagus-sultan',
  '6AB417': 'extra-life',
  '6B295A': 'pretty-in-prune',
  '6B2A14': 'hairy-heath',
  '6B327B': 'galactic-grapevine',
  '6B3FA0': 'poppy-pompadour',
  '6B4423': 'kobicha',
  '6B4E31': 'shingle-fawn',
  '6B5755': 'dorado',
  '6B6047': 'ochicha-latte',
  '6B6965': 'volcanic-rock',
  '6B6C89': 'dark-prince',
  '6B6D4E': 'herbal-whispers',
  '6B6D6A': 'shadows',
  '6B717A': 'made-in-the-shade',
  '6B7F81': 'blue-blood',
  '6B8BA2': 'bermuda-gray',
  '6B8E23': 'olive-drab',
  '6B90B3': 'heavenly-sky',
  '6BB3DB': 'milky-waves',
  '6BC026': 'zunda-green',
  '6BC271': 'bermudagrass',
  '6C110E': 'sanguine',
  '6C2E09': 'cold-press-coffee',
  '6C2E1F': 'organ',
  '6C3082': 'eminence',
  '6C462D': 'pumpernickel',
  '6C541E': 'field-drab',
  '6C685E': 'catch-of-the-day',
  '6C9DA9': 'tranquili-teal',
  '6CA0DC': 'little-boy-blue',
  '6D0101': 'lonestar',
  '6D4433': 'noble-chocolate',
  '6D5E54': 'pine-cone',
  '6D6C5F': 'knit-cardigan',
  '6D6C6C': 'dove-gray',
  '6D83BB': 'orbital',
  '6D86B6': 'kimono',
  '6D9292': 'juniper',
  '6D92A1': 'gothic',
  '6D98C4': 'windstorm',
  '6D9BC3': 'cerulean-frost',
  '6DAFA7': 'turquoise-fantasies',
  '6DB083': 'lily-pads',
  '6DBAC0': 'castaway',
  '6E0902': 'red-oxide',
  '6E0F12': 'festive-bordeaux',
  '6E1D14': 'moccaccino',
  '6E4534': 'brisket',
  '6E4826': 'pickled-bean',
  '6E4B26': 'dallas',
  '6E4F3A': 'bison',
  '6E544B': 'afternoon-coffee',
  '6E592C': 'olivary',
  '6E6A44': 'beat-around-the-bush',
  '6E6A5E': 'archaeology',
  '6E6D57': 'kokoda',
  '6E6EF9': 'dark-imperial-blue',
  '6E7783': 'pale-sky',
  '6E797B': 'phantom',
  '6E7E99': 'infinity-and-beyond',
  '6E7F80': 'auro-metal-saurus',
  '6E8082': 'stormy-sea',
  '6EAEA1': 'green-sheen',
  '6EC9A3': 'minted-elegance',
  '6F00FF': 'electric-indigo',
  '6F123C': 'her-fierceness',
  '6F2DA8': 'grape',
  '6F440C': 'cafe-royale',
  '6F4E37': 'coffee',
  '6F5166': 'hibernation',
  '6F5698': 'passion-flower',
  '6F58A6': 'prophet-violet',
  '6F5944': 'baby-bear',
  '6F6A61': 'flint',
  '6F7678': 'volcanic-ash',
  '6F7755': 'dill',
  '6F8770': 'thyme-and-place',
  '6F8D6A': 'kashmir',
  '6F8E63': 'highland',
  '6F9D02': 'limeade',
  '6FA77A': 'primavera',
  '6FD0C5': 'downy',
  '6FD1C9': 'hidden-sea-glass',
  '701C11': 'prune',
  '701C1C': 'persian-plum',
  '702670': 'midnight',
  '702963': 'byzantium',
  '703642': 'catawba',
  '70403D': 'wine-cellar',
  '704214': 'sepia',
  '704241': 'roast-coffee',
  '704A3A': 'cappuccino',
  '704F50': 'ferra',
  '705446': 'hold-your-horses',
  '708090': 'slate-gray',
  '70818E': 'stormy-oceans',
  '70916C': 'paying-mantis',
  '70F15E': 'the-matrix',
  '71000E': 'barolo',
  '710101': 'hellbound',
  '711A00': 'cedar-wood-finish',
  '712735': 'merlot-fields',
  '71291D': 'metallic-copper',
  '713E39': 'single-origin',
  '714693': 'affair',
  '714A8B': 'grapes-of-italy',
  '714AB2': 'studio',
  '714F29': 'chocolate-rain',
  '715145': 'bigfoot',
  '715636': 'oak-barrel',
  '715BB1': 'simply-purple',
  '715D47': 'tobacco-brown',
  '716338': 'yellow-metal',
  '716B56': 'peat',
  '716E10': 'olivetone',
  '717486': 'storm-gray',
  '718080': 'sirocco',
  '7181A4': 'english-manor',
  '71A6D2': 'iceberg',
  '71AA34': 'leaf',
  '71AB62': 'ferntastic',
  '71D9E2': 'aquamarine-blue',
  '722F37': 'wine',
  '724A2F': 'old-copper',
  '726854': 'treasure-chest',
  '726D4E': 'go-ben',
  '727472': 'nickel',
  '727736': 'jungle-look',
  '727B89': 'raven',
  '728284': 'classic-movie',
  '72939E': 'cavolo-nero',
  '72A0C1': 'air-superiority-blue',
  '731E8F': 'seance',
  '73383C': 'cuba-libre',
  '733C8E': 'perkin-mauve',
  '734F96': 'dark-lavender',
  '73624A': 'heavy-brown',
  '73645C': 'morel',
  '736C9F': 'kimberly',
  '736D58': 'crocodile',
  '737000': 'bronze-yellow',
  '737054': 'secret-path',
  '737274': 'paris-paving',
  '737829': 'crete',
  '738276': 'smoke',
  '738678': 'xanadu',
  '738F5D': 'four-leaf-clover',
  '73A4C6': 'wandering-river',
  '73A9C2': 'moonstone-blue',
  '73B683': 'frog-pond',
  '73C2FB': 'maya-blue',
  '73E608': 'hypnotic-green',
  '73FA79': 'flora',
  '740900': 'liquorice-red',
  '7442C8': 'purple-rain',
  '74626D': 'chimaera',
  '74640D': 'spicy-mustard',
  '746A5E': 'granite',
  '746C8F': 'bureaucracy',
  '746CC0': 'toolbox',
  '747261': 'organic',
  '747A8A': 'abandoned-spaceship',
  '747D63': 'limed-ash',
  '747D83': 'rolling-stone',
  '747F71': 'camo-clay',
  '74819A': 'stonewash',
  '74857F': 'armour',
  '748881': 'blue-smoke',
  '748A35': 'pesto-di-rucola',
  '748D70': 'toad',
  '749378': 'laurel',
  '749A54': 'bavarian-green',
  '749E4E': 'kiwi',
  '74AF54': 'lost-golfer',
  '74C365': 'mantis',
  '74CDD8': 'summer-of-82',
  '750851': 'velvet',
  '753A58': 'passionate-plum',
  '755139': 'toffee',
  '75528B': 'ninja-princess',
  '755A57': 'russett',
  '7563A8': 'deluge',
  '756F6B': 'anchovy',
  '757374': 'bank-vault',
  '757461': 'mangrove',
  '757575': 'sonic-silver',
  '75978F': 'yucca',
  '75AD5B': 'arugula',
  '75AEBD': 'blue-eye-samurai',
  '76395D': 'cosmic',
  '7666C6': 'blue-marguerite',
  '766B69': 'acoustic-brown',
  '767437': 'crocodile-style',
  '767D86': 'nocturnal',
  '76856A': 'wreath',
  '768B59': 'moss-gardens',
  '76AD83': 'green-goddess',
  '76BAA8': 'sereni-teal',
  '76BD17': 'lima',
  '76D6FF': 'sky',
  '770011': 'blood-brother',
  '770022': 'evil-forces',
  '770088': 'ultraberry',
  '770F05': 'dark-burgundy',
  '771122': 'heavy-heart',
  '7711DD': 'voluptuous-violet',
  '77150E': 'blackened-sun',
  '771908': 'obscure-ogre',
  '771F1F': 'crown-of-thorns',
  '772233': 'whisky-cola',
  '772299': 'orb-of-discord',
  '7722AA': 'fuchsia-nebula',
  '772C30': 'wine-and-unwind',
  '773243': 'red-octopus',
  '773344': 'satin-chocolate',
  '7733AA': 'purple-pristine',
  '7736D9': 'hokkaido-lavender',
  '7737AA': 'shredder-lavender',
  '773C30': 'ebi-brown',
  '773F1A': 'walnut',
  '775130': 'chocolate-bells',
  '775511': 'coffee-adept',
  '7755EE': 'candy-grape-fizz',
  '776F61': 'pablo',
  '777696': 'rhythm',
  '777777': 'lucky-grey',
  '777799': 'stormy-horizon',
  '778120': 'pacifika',
  '77824A': 'grasshopper',
  '778899': 'light-slate-gray',
  '778BA5': 'shadow-blue',
  '7794C0': 'king-neptune',
  '779900': 'green-thumb',
  '779966': 'mosslands',
  '779E86': 'oxley',
  '779ECB': 'dark-pastel-blue',
  '77AA00': 'green-envy',
  '77AAFF': 'fennel-flower',
  '77B033': 'natural-order',
  '77B5FE': 'french-sky-blue',
  '77BBFF': 'cooler-than-ever',
  '77C9C2': 'cyantific',
  '77CCBB': 'jolly-jade',
  '77DD22': 'king-lizard',
  '77DD77': 'pastel-green',
  '77EEBB': 'jittery-jade',
  '77FF66': 'poisonous-dart',
  '780109': 'japanese-maple',
  '78184A': 'pansy-purple',
  '782D19': 'mocha',
  '782F16': 'peanut',
  '784467': 'magicians-cloak',
  '784674': 'purple-passion',
  '784F50': 'veil-of-cinder',
  '7851A9': 'royal-purple',
  '785246': 'roasted',
  '785441': 'brownstone',
  '785736': 'cold-brew-coffee',
  '78587D': 'dr-who',
  '786E38': 'garden-weed',
  '78736E': 'gauntlet-grey',
  '787489': 'flying-carpet',
  '78776F': 'wolf-pack',
  '787B54': 'bonsai',
  '787E93': 'your-shadow',
  '78866B': 'camouflage-green',
  '788A25': 'wasabi',
  '788BBA': 'ship-cove',
  '789B4A': 'mossy-glossy',
  '78A39C': 'sea-nymph',
  '78A7C3': 'serene-sea',
  '79443B': 'bole',
  '795D4C': 'roman-coffee',
  '796359': 'bear-hug',
  '796878': 'old-lavender',
  '796989': 'rum',
  '796A78': 'fedora',
  '796D62': 'sandstone',
  '79774A': 'tree-hugger',
  '79839B': 'tempest',
  '79D0A7': 'crystal-gem',
  '79DEEC': 'spray',
  '7A013A': 'siren',
  '7A0E0E': 'secret-scarlet',
  '7A280A': 'drip-coffee',
  '7A3F2B': 'stone-age-queen',
  '7A463A': 'chocolate-magma',
  '7A4B56': 'nocturne-red',
  '7A58C1': 'fuchsia-blue',
  '7A6DC0': 'venus-violet',
  '7A7A7A': 'boulder',
  '7A8F68': 'crispy-crunch',
  '7AA3CC': 'shipmate',
  '7AC488': 'de-york',
  '7ACCB8': 'bevelled-glass',
  '7AD7AD': 'tadorna-teal',
  '7B1113': 'up-maroon',
  '7B3801': 'red-beech',
  '7B3F00': 'chocolate',
  '7B4D3A': 'cheeky-chestnut',
  '7B5867': 'royal-fig',
  '7B645A': 'ranch-house',
  '7B6608': 'yukon-gold',
  '7B68EE': 'medium-slate-blue',
  '7B6943': 'lizard',
  '7B6C7C': 'sakura-night',
  '7B6C8E': 'nymphs-delight',
  '7B737B': 'cement-feet',
  '7B7874': 'tapa',
  '7B7C94': 'waterloo-',
  '7B8265': 'flax-smoke',
  '7B8762': 'green-relict',
  '7B9A6D': 'money',
  '7B9F80': 'amulet',
  '7BA05B': 'frankenstein',
  '7BB369': 'soon-to-be-hay',
  '7BB661': 'bud-green',
  '7BB92B': 'jubilant-meadow',
  '7BC027': 'kiwi-crush',
  '7BC8F6': 'nevermind-nirvana',
  '7BD181': 'electric-lettuce',
  '7C0A02': 'barn-red',
  '7C1C05': 'kenyan-copper',
  '7C4848': 'tuscan-red',
  '7C6D61': 'namibia',
  '7C754C': 'greek-oregano',
  '7C7631': 'pesto',
  '7C7B7A': 'concord',
  '7C7B82': 'jumbo',
  '7C8181': 'whale',
  '7C881A': 'trendy-green',
  '7C939D': 'inland-waters',
  '7C94B3': 'celestial-horizon',
  '7C98AB': 'weldon-blue',
  '7C9ED9': 'vista-blue',
  '7CA1A6': 'gumbo',
  '7CB0A1': 'acapulco',
  '7CB7BB': 'neptune',
  '7CB9E8': 'aero',
  '7CBBAE': 'mintnight',
  '7CFC00': 'lawn-green',
  '7D2C14': 'pueblo',
  '7D4E38': 'cigar',
  '7D5D5E': 'reading-tea-leaves',
  '7D623C': 'autumn-gold',
  '7D685B': 'warrior',
  '7D7D77': 'moon-base',
  '7D848B': 'serious-cloud',
  '7D8878': 'majestic-evergreen',
  '7D9B89': 'parisian-patina',
  '7DA98D': 'bay-leaf',
  '7DABD8': 'high-seas',
  '7DB39E': 'beau-monde',
  '7DC4CD': 'wavelet',
  '7DC8F7': 'malibu',
  '7DD8C6': 'bermuda',
  '7DF9FF': 'electric-blue',
  '7E203F': 'beet-red',
  '7E3A15': 'copper-canyon',
  '7E3A3C': 'wild-berry',
  '7E4071': 'bruise',
  '7E4730': 'sunbathing-beauty',
  '7E5C52': 'wild-west',
  '7E5E60': 'deep-taupe',
  '7E7466': 'bat-wing',
  '7E7D88': 'silver-surfer',
  '7E8082': 'ironside',
  '7E8590': 'smoky-studio',
  '7EBA4D': 'ultra-green',
  '7EBEA5': 'celadon-porcelain',
  '7ED89A': 'enchanted-emerald',
  '7EFFBA': 'mint-bliss',
  '7F00FF': 'violet',
  '7F01FE': 'poisoning-purple',
  '7F1734': 'claret',
  '7F3A02': 'peru-tan',
  '7F4774': 'magic-magenta',
  '7F4E1E': 'milk-chocolate',
  '7F5E50': 'acorn',
  '7F6054': 'chocolate-bliss',
  '7F626D': 'falcon',
  '7F735F': 'handmade',
  '7F7453': 'chocolate-velvet',
  '7F7589': 'mobster',
  '7F76D3': 'moody-blue',
  '7F7755': 'boa',
  '7F8181': 'mt-rushmore',
  '7F8793': 'sea-lion',
  '7F8CB8': 'galactic-gossamer',
  '7FA2BF': 'far-horizons',
  '7FA771': 'garden-of-eden',
  '7FB383': 'verde',
  '7FBA9E': 'froggy-pond',
  '7FBB9E': 'neptune-green',
  '7FBBC2': 'cuttlefish',
  '7FFF00': 'web-chartreuse',
  '7FFFD4': 'aquamarine',
  '800000': 'maroon',
  '800020': 'burgundy',
  '800080': 'purple',
  '800707': 'red-reign',
  '800B47': 'rose-bud-cherry',
  '801818': 'falu-red',
  '802280': 'hello-darkness-my-old-friend',
  '80341F': 'red-robin',
  '80385C': 'pleasure',
  '80442F': 'cacao-nibs',
  '80461B': 'russet',
  '804741': 'sly-fox',
  '805B87': 'muted-purple',
  '806B77': 'moonscape',
  '807396': 'purple-haze',
  '807532': 'spanish-bistre',
  '807872': 'gotham',
  '807E79': 'friar-gray',
  '808000': 'olive',
  '808080': 'gray',
  '80AA95': 'catnip',
  '80B3AE': 'gulf-stream',
  '80B3C4': 'glacier',
  '80BB66': 'leafy-greens',
  '80C872': 'emerald-rain',
  '80CCEA': 'seagull',
  '80DAEB': 'medium-sky-blue',
  '811453': 'french-plum',
  '813533': 'dockside-red',
  '81422C': 'nutmeg',
  '81459E': 'purple-pleasures',
  '81544A': 'root-beer',
  '815B28': 'hot-curry',
  '816045': 'man-cave',
  '81613E': 'coyote-brown',
  '816558': 'chivalrous-walrus',
  '816575': 'opera',
  '816C5B': 'nut-cracker',
  '816C5E': 'caribou',
  '816E71': 'spicy-pink',
  '817377': 'empress',
  '81777F': 'chain-mail',
  '817C4A': 'verdant-leaf',
  '818581': 'happy-hippo',
  '819B4F': 'rosemarried',
  '819E84': 'vineyard',
  '81C784': 'exhilarating-green',
  '81D0DF': 'water-nymph',
  '81D5C6': 'shore',
  '820000': 'deep-maroon',
  '820E3B': 'inescapable-lover',
  '822A10': 'caponata',
  '82476F': 'grape-kiss',
  '826644': 'raw-umber',
  '827B77': 'mule',
  '828039': 'green-commando',
  '828287': 'lunar-outpost',
  '828685': 'gunsmoke',
  '828E84': 'mummys-tomb',
  '828F72': 'battleship-gray',
  '829F96': 'japanese-bonsai',
  '82DBCC': 'shimmering-blue',
  '831923': 'merlot',
  '832A0D': 'smokey-topaz',
  '834841': 'think-brick',
  '836953': 'pastel-brown',
  '836E59': 'golem',
  '838585': 'gryphon',
  '838996': 'roman-silver',
  '839AB0': 'monsoon-season',
  '839C6D': 'sleepy-hollow',
  '839E83': 'basswood-green',
  '83A9B3': 'equanimity',
  '83AA5D': 'chelsea-cucumber',
  '83AFBC': 'open-seas',
  '83BBC1': 'misty-cold-sea',
  '83D0C6': 'monte-carlo',
  '840014': 'sneaky-devil',
  '841B2D': 'antique-ruby',
  '843F5B': 'deep-ruby',
  '8469BC': 'lavish-spending',
  '84705B': 'aztec-temple',
  '847592': 'vintage',
  '84838E': 'in-the-twilight',
  '848393': 'mecha-metal',
  '848482': 'old-silver',
  '84898C': 'monument',
  '849C8D': 'mother-earth',
  '84A0A0': 'granny-smith',
  '84A2D4': 'wisteria-blue',
  '84A7CE': 'windfall',
  '84A97C': 'verdant-haven',
  '84A9B0': 'stormy-waters',
  '84DE02': 'alien-armpit',
  '850101': 'deep-red',
  '85323C': 'blood-oath',
  '853682': 'purple-sultan',
  '853C69': 'midnight-aubergine',
  '85464B': 'red-elegance',
  '855E42': 'dark-wood',
  '856088': 'chinese-violet',
  '856D4D': 'french-bistre',
  '857349': 'mossy',
  '85754E': 'gold-fusion',
  '8581D9': 'chetwode-blue',
  '858381': 'lingering-storm',
  '858470': 'bandicoot',
  '858585': 'black-mana',
  '859FAF': 'bali-hai',
  '85A3B2': 'grauzone',
  '85A6C8': 'high-tide',
  '85B3F3': 'fly-away',
  '85BB65': 'dollar-bill',
  '85C2B2': 'seaborn',
  '85C4CC': 'half-baked',
  '860111': 'red-devil',
  '8601AF': 'ryb-violet',
  '8601BF': 'violet-poison',
  '862A2E': 'polished-apple',
  '863C3C': 'lotus',
  '864788': 'prunella',
  '86483C': 'ironstone',
  '864D1E': 'bull-shot',
  '86560A': 'rusty-nail',
  '86608E': 'french-lilac',
  '867BA9': 'aster',
  '867E36': 'old-moss-green',
  '868974': 'bitter',
  '86949F': 'regent-gray',
  '869CBB': 'sailing',
  '86BEBE': 'riverbed',
  '86C8ED': 'fish-pond',
  '871466': 'bane-of-royalty',
  '871550': 'disco',
  '871F78': 'noble-plum',
  '872657': 'dark-raspberry',
  '873260': 'boysenberry',
  '875F42': 'cocoa',
  '87756E': 'americano',
  '877C7B': 'hurricane',
  '878757': 'iguana',
  '878786': 'lunar-base',
  '878787': 'mithril',
  '878D91': 'oslo-gray',
  '879877': 'backyard',
  '879F84': 'basil',
  '87A96B': 'asparagus',
  '87AB39': 'sushi',
  '87B364': 'broccoli',
  '87CDED': 'below-zero',
  '87CEEB': 'sky-blue',
  '87CEFA': 'light-sky-blue',
  '87D3F8': 'pale-cyan',
  '87D7BE': 'cabbage',
  '87DCCE': 'tantalising-teal',
  '87E0CF': 'sea-foam',
  '87FF2A': 'spring-frost',
  '880011': 'bloodthirsty',
  '880033': 'macabre',
  '880066': 'grapest',
  '880085': 'mardi-gras',
  '8806CE': 'french-violet',
  '881111': 'netherworld',
  '881166': 'possessed-purple',
  '881177': 'royal-purpleness',
  '882211': 'minotaurus-brown',
  '8822CC': 'lilac-spring',
  '882D17': 'sienna',
  '883333': 'planet-of-the-apes',
  '8833AA': 'pleasant-purple',
  '88432E': 'olive-ni-oise',
  '885522': 'precious-copper',
  '885577': 'plum-highness',
  '885818': 'grizzly',
  '886221': 'kumera',
  '88654E': 'dark-brown-tangelo',
  '886600': 'alligator',
  '886688': 'sunshone-plum',
  '886806': 'muddy-brown',
  '886B2E': 'aged-antics',
  '8878C3': 'ube',
  '888387': 'suva-gray',
  '888738': 'witch-brew',
  '888844': 'overgrown-citadel',
  '888877': 'kosher-khaki',
  '888888': 'argent',
  '888899': 'dusty-chimney',
  '889717': 'snakes-in-the-grass',
  '889900': 'bioshock',
  '889911': 'densetsu-green',
  '88AA22': 'guardian-of-gardens',
  '88AA77': 'lush-fields',
  '88AAAA': 'harbour-mist',
  '88ACE0': 'light-cobalt-blue',
  '88B5C4': 'crystal-lake',
  '88BB11': 'walk-in-the-park',
  '88BB55': 'makin-it-rain',
  '88BBEE': 'electric-eel',
  '88CC33': 'overgrowth',
  '88CC55': 'fairy-tale-green',
  '88D8C0': 'pearl-aqua',
  '88DD00': 'overgrown',
  '88DD11': 'opulent-lime',
  '88DDAA': 'jovial-jade',
  '88DDCC': 'opulent-turquoise',
  '88DDDD': 'cold-blue',
  '88EE11': 'poisonous-pistachio',
  '88EE22': 'luxurious-lime',
  '88EE77': 'herbivore',
  '88EEEE': 'bath-water',
  '88FF00': 'lasting-lime',
  '88FF11': 'lethal-lime',
  '88FF22': 'loud-lime',
  '88FFCC': 'a-state-of-mint',
  '88FFFF': 'glitter-shower',
  '890A01': 'roasted-pepper',
  '893456': 'camelot',
  '893843': 'solid-pink',
  '893F45': 'cordovan',
  '894367': 'cannon-pink',
  '896A46': 'sneaky-sesame',
  '897A3E': 'capers',
  '897B66': 'home-brew',
  '897D6D': 'makara',
  '897D76': 'moon-rock',
  '898C92': 'nuts-and-bolts',
  '89A068': 'buckingham-gardens',
  '89A203': 'noxious',
  '89AC27': 'german-hop',
  '89ACDA': 'birdie-num-num',
  '89C6DF': 'sky-fall',
  '89CFF0': 'baby-blue',
  '89D178': 'fluorescence',
  '89F5E3': 'turquoise-pearl',
  '89FE05': 'radioactive',
  '8A0009': 'kiss-of-a-vampire',
  '8A2BE2': 'blue-violet',
  '8A3324': 'burnt-umber',
  '8A496B': 'twilight-lavender',
  '8A5773': 'indian-silk',
  '8A73D6': 'true-v',
  '8A7561': 'mink',
  '8A795D': 'shadow',
  '8A7F80': 'rocket-metallic',
  '8A8360': 'clay-creek',
  '8A8389': 'monsoon',
  '8A8F8A': 'stack',
  '8A9480': 'aloe-tip',
  '8A966A': 'bullfrog',
  '8A9A5B': 'moss-green',
  '8AA282': 'mistletoe',
  '8AADF7': 'kittens-eye',
  '8AB9F1': 'jordy-blue',
  '8ABBD0': 'juvie',
  '8AF1FE': 'shallow-water',
  '8B0000': 'dark-red',
  '8B008B': 'dark-magenta',
  '8B00FF': 'electric-violet',
  '8B031C': 'barbera',
  '8B0723': 'monarch',
  '8B4121': 'chocolate-covered',
  '8B4248': 'silk-satin',
  '8B4513': 'saddle-brown',
  '8B5F4D': 'spicy-mix',
  '8B6945': 'barrel-aged',
  '8B6B0B': 'corn-harvest',
  '8B6B58': 'mocha-madness',
  '8B846D': 'antique',
  '8B8470': 'olive-haze',
  '8B847E': 'schooner',
  '8B8589': 'taupe-gray',
  '8B8680': 'natural-gray',
  '8B8685': 'detective-coat',
  '8B9C90': 'mantle',
  '8B9CAC': 'blank-stare',
  '8B9FEE': 'portage',
  '8BA477': 'succulent-greenhouse',
  '8BA690': 'envy',
  '8BA8B7': 'pewter-blue',
  '8BA9A5': 'cascade',
  '8BAC0F': 'gameboy-screen',
  '8BB6B8': 'summit',
  '8BE6D8': 'riptide',
  '8C055E': 'cardinal-pink',
  '8C3A00': 'espresso-martini',
  '8C3F52': 'liaison',
  '8C4512': 'otterly-brown',
  '8C472F': 'mule-fawn',
  '8C4A2F': 'gingerbread',
  '8C5341': 'annatto',
  '8C5738': 'potters-clay',
  '8C6495': 'trendy-pink',
  '8C724F': 'tobacco-leaf',
  '8C7F3C': 'peas-please',
  '8C8E65': 'paid-in-full',
  '8C92AC': 'cool-grey',
  '8C9632': 'chorus-of-frogs',
  '8CA891': 'omgreen',
  '8CA94A': 'lime-it-or-leave-it',
  '8CBED6': 'dark-sky-blue',
  '8CC34B': 'thrilling-lime',
  '8CC6CB': 'cerulean-skies',
  '8CC90B': 'jewel-beetle',
  '8CD612': 'frogger',
  '8D0226': 'paprika',
  '8D3D38': 'sanguine-brown',
  '8D3F3F': 'tosca',
  '8D4E85': 'razzmic-berry',
  '8D6747': 'wild-horses',
  '8D7662': 'cement',
  '8D7E6D': 'teakwood',
  '8D844D': 'rural-green',
  '8D8974': 'granite-green',
  '8D8B55': 'green-olive',
  '8D95AA': 'silverfish',
  '8D99B1': 'moon-veil',
  '8D9CA7': 'lost-at-sea',
  '8DA8CC': 'polo-blue',
  '8DB600': 'apple-green',
  '8DDEE1': 'paradisiacal-getaway',
  '8E0000': 'red-berry',
  '8E3537': 'sizzling-bacon',
  '8E3A59': 'quinacridone-magenta',
  '8E4585': 'plum',
  '8E473B': 'chocolate-explosion',
  '8E4D1E': 'rope',
  '8E5164': 'velour-scar',
  '8E664E': 'mocha-delight',
  '8E6F70': 'opium',
  '8E775E': 'domino',
  '8E8062': 'mushroom-forest',
  '8E8190': 'mamba',
  '8E8987': 'chorus-of-elephants',
  '8E97C7': 'easter-egg',
  '8EABC1': 'nepal',
  '8EBAA6': 'lichen',
  '8ECCFE': 'clear-sky',
  '8EDACC': 'bambino',
  '8EFA00': 'mochito',
  '8F021C': 'pohutukawa',
  '8F3129': 'potion-9',
  '8F3E33': 'el-salva',
  '8F4B0E': 'korma',
  '8F509D': 'vicious-violet',
  '8F7F85': 'mighty-mauve',
  '8F8176': 'squirrel',
  '8F886C': 'wilderness',
  '8F8CE7': 'perrywinkle',
  '8F8E8C': 'pedigrey',
  '8F917C': 'farmers-market',
  '8F9394': 'grey-area',
  '8F9779': 'artichoke',
  '8F9B5B': 'vitality',
  '8FA0D5': 'azureno',
  '8FB943': 'frog-on-a-log',
  '8FBC8F': 'dark-sea-green',
  '8FD400': 'sheen-green',
  '900405': 'scoville-highness',
  '901E1E': 'old-brick',
  '90305D': 'pink-horror',
  '905284': 'grape-candy',
  '905D5D': 'rose-taupe',
  '90614A': 'weathered-leather',
  '907874': 'hemp',
  '907B71': 'almond-frost',
  '907E6C': 'wet-taupe',
  '908D39': 'sycamore',
  '90979B': 'steely-grey',
  '909853': 'totally-broccoli',
  '90A96E': 'green-tea-mochi',
  '90AA0B': 'augustus-asparagus',
  '90CCA3': 'irish-spring',
  '90EE90': 'light-green',
  '911911': 'emergency',
  '914E75': 'sugar-plum',
  '915C83': 'antique-fuchsia',
  '915F6D': 'mauve-taupe',
  '91788C': 'muted-berry',
  '918151': 'dark-tan',
  '918C8F': 'gull',
  '919191': 'tin',
  '91979F': 'grisaille',
  '919C81': 'whispering-willow',
  '91A3B0': 'cadet-grey',
  '91A8CF': 'old-world',
  '91B6AC': 'treetop',
  '91CB7D': 'fresh-cut-grass',
  '92000A': 'sangria',
  '920F0E': 'jack-and-coke',
  '92181D': 'noble-red',
  '921A1C': 'socialist',
  '922724': 'vivid-auburn',
  '924321': 'cumin',
  '928573': 'stonewall',
  '928590': 'venus',
  '92898A': 'zinc',
  '92A1CF': 'ceil',
  '932A25': 'saffronaut',
  '933D41': 'smoky-topaz',
  '9370DB': 'medium-purple',
  '938B4B': 'negishi-green',
  '93977F': 'swamp-sessions',
  '93B83D': 'grinch-green',
  '93B8E3': 'adrift-on-the-nile',
  '93C572': 'pistachio',
  '93CCEA': 'light-cornflower-blue',
  '93DFB8': 'algae-green',
  '9400D3': 'dark-violet',
  '941100': 'cayenne',
  '941751': 'wine-grape',
  '94312F': 'ripasso',
  '943589': 'purple-excellency',
  '944747': 'copper-rust',
  '945200': 'mochaccino',
  '9457EB': 'lavender-indigo',
  '946985': 'fruit-of-passion',
  '946DAD': 'crown-jewels',
  '947E68': 'gazelle',
  '948593': 'femme-fatale',
  '948771': 'arrowtown',
  '9488BE': 'magic-carpet',
  '948E90': 'hong-kong-mist',
  '948F54': 'amazon-queen',
  '94A2B1': 'robotic-gods',
  '94B1A9': 'ninja-turtle',
  '94C84C': 'lone-hunter',
  '94D2BF': 'wintermint',
  '94D4E4': 'infinity-pool',
  '950015': 'scarlett',
  '950C1B': 'sacred-scarlet',
  '952E8F': 'warm-purple',
  '954535': 'chestnut',
  '956387': 'strikemaster',
  '95859C': 'hatoba-pigeon',
  '959396': 'mountain-mist',
  '9596A4': 'too-big-to-whale',
  '95986B': 'guacamole',
  '95B388': 'foliage',
  '95BCE1': 'double-denim',
  '95C703': 'bergamot',
  '960018': 'carmine',
  '9601F4': 'cosmic-heart',
  '9632CE': 'dreamscape-purple',
  '964B00': 'brown',
  '964E02': 'warm-brown',
  '965A3E': 'coconut',
  '966FD6': 'dark-pastel-purple',
  '967059': 'leather',
  '967117': 'sand-dune',
  '96711C': 'puma',
  '967217': 'glazed-chestnut',
  '96745B': 'whisky-barrel',
  '9678B6': 'purple-mountain-majesty',
  '967BB6': 'lavender-purple',
  '967D96': 'amorous',
  '968772': 'shipwreck',
  '969389': 'lost-space',
  '9698A3': 'dark-ages',
  '969E86': 'herbalist',
  '96A8A1': 'pewter',
  '96B3B3': 'cool',
  '96BBAB': 'summer-green',
  '96C8A2': 'eton-blue',
  '96D9DF': 'exotic-escape',
  '96DED1': 'pale-robin-egg-blue',
  '96DFCE': 'beach-glass',
  '96E2E1': 'aqua-fiesta',
  '972B51': 'raspberry-romantic',
  '97605D': 'au-chico',
  '977B2F': 'fernweh',
  '978C59': 'in-a-pickle',
  '979AAA': 'manatee',
  '979BA8': 'dusky-mood',
  '979EA1': 'happy-cement',
  '97B73A': 'limolicious',
  '97C0D1': 'neptunes-realm',
  '97CD2D': 'atlantis',
  '980036': 'pink-raspberry',
  '980B4A': 'aristocratic-velvet',
  '98211A': 'antique-port-wine',
  '98333A': 'queen-of-hearts',
  '983D61': 'vin-rouge',
  '984218': 'hot-brown',
  '985E2B': 'chilli-con-carne',
  '986960': 'dark-chestnut',
  '987456': 'liver-chestnut',
  '9874D3': 'lilac-bush',
  '987652': 'guinea-pig',
  '987654': 'pale-brown',
  '98777B': 'bazaar',
  '98811B': 'hacienda',
  '98817B': 'cinereous',
  '988D77': 'pale-oyster',
  '989493': 'flint-rock',
  '989898': 'spanish-gray',
  '989CAB': 'wet-asphalt',
  '98B2B4': 'ether',
  '98BD3C': 'funky-frog',
  '98C6CB': 'continental-waters',
  '98C945': 'aromatic-herbs',
  '98CBBA': 'mint-twist',
  '98D5EA': 'over-the-sky',
  '98D98E': 'leek',
  '98EFF9': 'permafrost',
  '98FB98': 'pale-green',
  '98FF97': 'mint-to-be',
  '98FF98': 'mint-green',
  '990000': 'crimson-red',
  '990020': 'xmas-candy',
  '990022': 'succubus',
  '990033': 'lifeline',
  '990055': 'vertigo-cherry',
  '990066': 'fresh-eggplant',
  '990077': 'persian-luxury-purple',
  '990F4B': 'berry',
  '991111': 'carnivore',
  '991133': 'french-winery',
  '991166': 'romantic-vampire',
  '991177': 'haunted-purple',
  '991199': 'violet-eggplant',
  '991613': 'tamarillo',
  '991B07': 'totem-pole',
  '9932CC': 'dark-orchid',
  '993300': 'chocoholic',
  '993311': 'choco-chic',
  '994341': 'red-my-mind',
  '994A25': 'coco-muck',
  '99522B': 'ancient-chest',
  '995533': 'hello-fall',
  '9955BB': 'deep-lilac',
  '996515': 'golden-brown',
  '996600': 'gamboge-orange',
  '996611': 'embarrassed-frog',
  '996622': 'olivia',
  '996633': 'woodgrain',
  '996666': 'copper-rose',
  '9966CC': 'amethyst',
  '997A8D': 'mountbatten-pink',
  '998E83': 'eiffel-tower',
  '9998A7': 'lavender-ash',
  '999911': 'papyrus',
  '999988': 'concrete-jungle',
  '999999': 'million-grey',
  '9999AA': 'machinery',
  '999A86': 'lemongrass',
  '999B9B': 'walrus',
  '99AA66': 'gallant-green',
  '99AAFF': 'widowmaker',
  '99BADD': 'blues-white-shoes',
  '99BB33': 'machu-picchu-gardens',
  '99BDD2': 'gentle-sky',
  '99C1CC': 'aquatic',
  '99C3F0': 'sail-to-the-sea',
  '99C5C4': 'pastel-turquoise',
  '99CCEE': 'fail-whale',
  '99CEA0': 'garden-goddess',
  '99DD33': 'poisonous-potion',
  '99DDCC': 'tropical-freeze',
  '99E6B3': 'teal-deer',
  '99EEEE': 'freezy-breezy',
  '99EEFF': 'alpine-expedition',
  '99FFEE': 'hello-winter',
  '9A2CA0': 'purple-ink',
  '9A373F': 'shin-godzilla',
  '9A3820': 'prairie-sand',
  '9A382D': 'ketchup',
  '9A435D': 'velvet-wine',
  '9A463D': 'mature-cognac',
  '9A4EAE': 'purpureus',
  '9A6E61': 'toast',
  '9A9577': 'gurkha',
  '9A9E80': 'fennelly',
  '9AA77C': 'forester',
  '9AA955': 'springtide-melodies',
  '9AAFAF': 'stormy-bay',
  '9AB8C2': 'shallow-sea',
  '9AB973': 'olivine',
  '9AC2B8': 'shadow-green',
  '9ACD32': 'yellow-green',
  '9AD28C': 'botanist',
  '9AE37D': 'snarky-mint',
  '9B0F11': 'vampire-fiction',
  '9B111E': 'ruby-red',
  '9B1414': 'bleeding-crimson',
  '9B1DCD': 'prom-queen',
  '9B2848': 'vampirella',
  '9B351B': 'spill-the-beans',
  '9B4682': 'grape-riot',
  '9B4703': 'oregon',
  '9B4B80': 'plum-passion',
  '9B5227': 'panela',
  '9B7653': 'dirt',
  '9B856B': 'tahini-brown',
  '9B870C': 'dark-yellow',
  '9B8B84': 'ruins-of-metal',
  '9B959C': 'lunar-light',
  '9B9E8F': 'lemon-grass',
  '9BA0EF': 'cold-lips',
  '9BC4E2': 'pale-cerulean',
  '9C0009': 'shades-of-ruby',
  '9C2542': 'big-dip-oruby',
  '9C2626': 'tamed-beast',
  '9C2D5D': 'thorne-wines',
  '9C3336': 'stiletto',
  '9C51B6': 'purple-plum',
  '9C5736': 'cinnamon-sparkle',
  '9C5E33': 'gingerbread-crumble',
  '9C7C38': 'metallic-sunburst',
  '9C87C1': 'petrified-purple',
  '9C8855': 'wasteland',
  '9C9C4B': 'lazy-lizard',
  '9CA389': 'edamame',
  '9CFAFF': 'eternal-winter',
  '9D2626': 'rustic-rouge',
  '9D2933': 'japanese-carmine',
  '9D4542': 'lumberjack',
  '9D5616': 'hawaiian-tan',
  '9D5783': 'feminism',
  '9D5A8F': 'bermuda-onion',
  '9D5F46': 'vintage-copper',
  '9D61D4': 'legendary-lavender',
  '9D6646': 'argan-oil',
  '9D913C': 'gecko',
  '9D9880': 'pebble',
  '9DACB7': 'gull-gray',
  '9DB4A0': 'copper-patina',
  '9DC209': 'limerick',
  '9DE5FF': 'anakiwa',
  '9E0E64': 'morbid-princess',
  '9E1212': 'heavy-red',
  '9E1316': 'spartan-crimson',
  '9E3D3F': 'sappanwood',
  '9E5302': 'chelsea-gem',
  '9E5B40': 'sepia-skin',
  '9E5E6F': 'rose-dust',
  '9E7B6C': 'woodhaven',
  '9E9E7C': 'bonsai-garden',
  '9EA4A5': 'statuary',
  '9EAD92': 'rooftop-garden',
  '9EB1CD': 'rock-blue',
  '9EB6D8': 'mont-blanc',
  '9EDEE0': 'morning-glory',
  '9EFD38': 'french-lime',
  '9F0000': 'cacodemon-red',
  '9F00C5': 'munsell-purple',
  '9F00FF': 'vivid-violet',
  '9F0630': 'petal-of-a-dying-rose',
  '9F1D35': 'vivid-burgundy',
  '9F2305': 'burnt-red',
  '9F381D': 'cognac',
  '9F4576': 'magenta-haze',
  '9F4CB7': 'fuchsia-pheromone',
  '9F4D65': 'cherry-berry',
  '9F5E4E': 'chutney',
  '9F7D4F': 'pyramid',
  '9F8170': 'beaver',
  '9F821C': 'reef-gold',
  '9F9978': 'a-frond-in-need',
  '9F9B84': 'knock-on-wood',
  '9F9F9C': 'star-dust',
  '9FA0B1': 'santas-gray',
  '9FA5A5': 'silent-film',
  '9FA91F': 'citron',
  '9FAF6C': 'matcha-mecha',
  '9FAFBD': 'lost-in-time',
  '9FD7D3': 'sinbad',
  '9FDD8C': 'feijoa',
  'A020F0': 'veronica',
  'A0252A': 'haute-couture',
  'A02712': 'tabasco',
  'A03623': 'brick',
  'A0365F': 'royal-flush',
  'A04039': 'rusty-heart',
  'A04933': 'picante',
  'A05D4D': 'grand-canyon',
  'A07569': 'equestrienne',
  'A0785A': 'chamoisee',
  'A08650': 'greek-olive',
  'A090B8': 'wizards-brew',
  'A09F5B': 'garden-of-earthly-delights',
  'A0A09C': 'gateway-grey',
  'A0D6B4': 'turquoise-green',
  'A0E2D4': 'menthol-kiss',
  'A0E5D9': 'sea-glass-teal',
  'A0E6FF': 'winter-wizard',
  'A13905': 'muddy',
  'A13F49': 'eternal-flame',
  'A15589': 'purple-zergling',
  'A1750D': 'buttered-rum',
  'A17A74': 'burnished-brown',
  'A17B4D': 'caramelised-pecan',
  'A18162': 'mulled-cider',
  'A19250': 'backroom-ember',
  'A1A46D': 'willow-leaf',
  'A1A9A9': 'crown-of-ash',
  'A1ADB5': 'hit-gray',
  'A1B670': 'around-the-gills',
  'A1BDBF': 'seafoam-whisper',
  'A1C50A': 'citrus',
  'A1CAF1': 'baby-blue-eyes',
  'A1DAD7': 'aqua-island',
  'A1E9DE': 'water-leaf',
  'A2006D': 'flirt',
  'A2101B': 'romantic-thriller',
  'A23B6C': 'rouge',
  'A264BA': 'prickly-purple',
  'A26645': 'cape-palliser',
  'A28557': 'banner-gold',
  'A2919B': 'nirvana',
  'A29587': 'smoking-mirror',
  'A2A2D0': 'blue-bell',
  'A2AAB3': 'gray-chateau',
  'A2ADD0': 'wild-blue-yonder',
  'A2AEAB': 'edward',
  'A2C2D0': 'airborne',
  'A2C3DB': 'metal-gear',
  'A30112': 'dear-darling',
  'A30800': 'gory-red',
  'A32D48': 'warrior-queen',
  'A32E1D': 'sugo-della-nonna',
  'A33540': 'wine-and-roses',
  'A34631': 'toasted-paprika',
  'A35139': 'truffle-trouble',
  'A36B4B': 'hazel',
  'A37298': 'drama-queen',
  'A38052': 'forbidden-peanut',
  'A3807B': 'pharlap',
  'A3896C': 'gramps-shoehorn',
  'A397B4': 'amethyst-smoke',
  'A3999C': 'walkway',
  'A3A2A1': 'shadow-of-the-colossus',
  'A3B1F2': 'wondrous-wisteria',
  'A3BBDC': 'sail-into-the-horizon',
  'A3C1AD': 'cambridge-blue',
  'A3E3ED': 'blizzard-blue',
  'A3EFB8': 'ultra-mint',
  'A40000': 'dark-candy-apple-red',
  'A42E41': 'radish',
  'A45A52': 'redwood',
  'A48A80': 'earthbound',
  'A4A404': 'countryside',
  'A4A49D': 'delta',
  'A4A6D3': 'wistful',
  'A4AF6E': 'green-smoke',
  'A4BF20': 'pea',
  'A4C639': 'android-green',
  'A4DDED': 'non-photo-blue',
  'A4F4F9': 'waterspout',
  'A50B5E': 'jazzberry-jam',
  'A52A2A': 'auburn',
  'A55A55': 'cheek-red',
  'A55AF4': 'orion-nebula',
  'A5694F': 'hot-cacao',
  'A57164': 'blast-off-bronze',
  'A5988A': 'shiitake',
  'A59B91': 'zorba',
  'A5AF76': 'estragon',
  'A5C1C0': 'wild-life',
  'A5CA4F': 'two-peas-in-a-pod',
  'A5CB0C': 'bahia',
  'A5CED5': 'wave',
  'A5D8CD': 'whirlpool',
  'A62F20': 'roof-terracotta',
  'A6465B': 'rose-laffy-taffy',
  'A65529': 'paarl',
  'A6646F': 'cinnapink',
  'A669DB': 'violet-voltage',
  'A67253': 'pecan',
  'A67283': 'never-forget',
  'A67B5B': 'tuscan-tan',
  'A67E4B': 'tosty-crust',
  'A6814C': 'hamster-fur',
  'A68B5B': 'barley-corn',
  'A69151': 'salted-capers',
  'A6978A': 'earl-grey',
  'A69A51': 'formosan-green',
  'A6A29A': 'dawn',
  'A6A6A6': 'quick-silver',
  'A6AB9B': 'moorland',
  'A6BCBE': 'seafoam-slate',
  'A6BCE2': 'blue-lips',
  'A6C875': 'fiddle-leaf-fig',
  'A6D608': 'vivid-lime-green',
  'A6E7FF': 'fresh-air',
  'A72525': 'mexican-red',
  'A73A3E': 'kabuki',
  'A75429': 'garfield',
  'A75502': 'windsor-tan',
  'A78558': 'exhumed-gold',
  'A7882C': 'luxor-gold',
  'A79954': 'gremlin',
  'A79B7E': 'mohalla',
  'A7A7A7': 'moon-landing',
  'A7C2EB': 'sky-high',
  'A7C437': 'pesto-di-pistacchio',
  'A7CCA4': 'limestoned',
  'A7D8DE': 'crystal',
  'A7F432': 'green-lizard',
  'A7FC00': 'spring-bud',
  'A81000': 'kid-icarus',
  'A8102A': 'hong-kong-taxi',
  'A81C07': 'rufous',
  'A82A38': 'pompeian-red',
  'A83731': 'sweet-brown',
  'A84734': 'barbarossa',
  'A84B7A': 'our-little-secret',
  'A8516E': 'china-rose',
  'A85624': 'spicy-cinnamon',
  'A86515': 'reno-sand',
  'A86B6B': 'coral-tree',
  'A86F48': 'stroopwafel',
  'A8715A': 'hazelnut',
  'A893C1': 'enchanted-lilac',
  'A8989B': 'dusty-gray',
  'A899E6': 'dull-lavender',
  'A8A589': 'tallow',
  'A8A9A8': 'elephant-in-the-room',
  'A8AE9C': 'bud',
  'A8AF8E': 'locust',
  'A8B59E': 'salvia',
  'A8BD9F': 'norway',
  'A8E3BD': 'chinook',
  'A8E4A0': 'granny-smith-apple',
  'A91C1C': 'ketchup-later',
  'A9203E': 'deep-carmine',
  'A93435': 'desirable',
  'A95C68': 'deep-puce',
  'A97B2D': 'chai-tea',
  'A97FB1': 'heart-potion',
  'A99592': 'cortex',
  'A99593': 'sphinx',
  'A99A86': 'grullo',
  'A99FCF': 'imperial-lilac',
  'A9A450': 'desert-locust',
  'A9A491': 'gray-olive',
  'A9A8A9': 'ultimate-grey',
  'A9A9A9': 'dark-medium-gray',
  'A9ACB6': 'aluminium',
  'A9AFAA': 'pigeon',
  'A9B497': 'schist',
  'A9B4A9': 'alpine-air',
  'A9BA9D': 'laurel-green',
  'A9BDBF': 'tower-gray',
  'A9BEF2': 'perano',
  'A9C6C2': 'opal',
  'AA0000': 'heartbeat',
  'AA0011': 'chorizo',
  'AA0033': 'hot-lava',
  'AA0077': 'katy-berry',
  'AA00BB': 'heliotrope-magenta',
  'AA00CC': 'ferocious-fuchsia',
  'AA1122': 'ecstatic-red',
  'AA1155': 'plum-perfect',
  'AA1177': 'fabric-of-love',
  'AA11AA': 'magentle',
  'AA2121': 'red-menace',
  'AA2222': 'blood-rush',
  'AA2266': 'plastic-lips',
  'AA22BB': 'magentleman',
  'AA251B': 'tomato-sunrise',
  'AA262B': 'samba',
  'AA3333': 'raging-raisin',
  'AA3377': 'plum-kingdom',
  'AA33EE': 'sweet-desire',
  'AA3646': 'roses-are-red',
  'AA375A': 'night-shadz',
  'AA381E': 'chinese-red',
  'AA4069': 'medium-ruby',
  'AA4203': 'fire',
  'AA4400': 'pepperoni',
  'AA44DD': 'magenta-affair',
  'AA5412': 'brandy-bear',
  'AA5522': 'wine-barrel',
  'AA6D28': 'inca-gold',
  'AA7711': 'falafel',
  'AA8833': 'rich-gold',
  'AA895D': 'iced-coffee',
  'AA8B5B': 'muesli',
  'AA8D6F': 'sandal',
  'AA8F7A': 'cocoloco',
  'AA98A9': 'heliotrope-gray',
  'AA9922': 'greedy-gecko',
  'AAA5A9': 'shady-lady',
  'AAA9CD': 'logan',
  'AAAA00': 'honey-and-thyme',
  'AAAA77': 'cardamom',
  'AAAA99': 'humble-hippo',
  'AAABB7': 'spun-pearl',
  'AAAD94': 'quiet-thicket',
  'AABB11': 'leafy-woodland',
  'AACC11': 'leafy-canopy',
  'AACCFF': 'night-snow',
  'AAD5DB': 'clear-water',
  'AAD6E6': 'regent-st-blue',
  'AADD66': 'last-of-lettuce',
  'AADDFF': 'droplet',
  'AAEE11': 'glorious-green-glitter',
  'AAEE22': 'sour-apple-candy',
  'AAF0D1': 'magic-mint',
  'AAFFAA': 'creamy-mint',
  'AAFFCC': 'neo-mint',
  'AAFFEE': 'blister-pearl',
  'AB0102': 'velvet-volcano',
  'AB0563': 'lipstick',
  'AB250B': 'salsa-picante',
  'AB274F': 'amaranth-purple',
  'AB3472': 'royal-heath',
  'AB4210': 'donkey-kong',
  'AB4231': 'chocolate-chilli',
  'AB4B52': 'english-red',
  'AB4E52': 'rose-vale',
  'AB4F41': 'hot-sauce',
  'AB6057': 'dried-tomatoes',
  'AB6F60': 'amaretto',
  'AB7100': 'cookie-dough',
  'AB7CB4': 'berries-galore',
  'AB9078': 'bakery-brown',
  'AB917A': 'sandrift',
  'AB927A': 'saddle-up',
  'AB92B3': 'glossy-grape',
  'ABA0D9': 'cold-purple',
  'ABA196': 'bronco',
  'ABA77C': 'olive-tree',
  'ABB39E': 'gargoyle',
  'ABB8D5': 'over-the-moon',
  'ABBED0': 'rendez-blue',
  'ABCA99': 'oh-pistachio',
  'ABCDEE': 'andromeda-blue',
  'ABCDEF': 'pale-cornflower-blue',
  'ABF5ED': 'pale-kings-blue',
  'AC1E3A': 'chilli-pepper',
  'AC1E44': 'french-wine',
  'AC495C': 'cherry-on-top',
  'AC8A56': 'limed-oak',
  'AC8F6C': 'morrel',
  'AC91CE': 'east-side',
  'AC9E22': 'lemon-ginger',
  'ACA28F': 'sage-the-day',
  'ACA494': 'napa',
  'ACA586': 'hillary',
  'ACA59F': 'cloudy',
  'ACAAA7': 'cathedral',
  'ACACAC': 'silver-chalice',
  'ACB78E': 'swamp-green',
  'ACC326': 'sour-lime',
  'ACCB35': 'tender-shoot',
  'ACCBB1': 'spring-rain',
  'ACDCEE': 'distant-homeworld',
  'ACDD4D': 'conifer',
  'ACDDAF': 'big-spender',
  'ACE1AF': 'celadon',
  'ACE5EE': 'blue-lagoon',
  'AD03DE': 'vibrant-purple',
  'AD3D1E': 'crimson-blaze',
  'AD4379': 'mystic-maroon',
  'AD4E1A': 'funky-monkey',
  'AD5928': 'autumnal',
  'AD5C34': 'monument-valley',
  'AD6242': 'mars',
  'AD654C': 'red-cent',
  'AD6961': 'rustling-leaves',
  'AD6F69': 'copper-penny',
  'AD781B': 'mandalay',
  'AD9A5D': 'kathmandu',
  'AD9A84': 'majestic-elk',
  'ADBED1': 'casper',
  'ADD8E6': 'light-blue',
  'ADD8FF': 'belgion',
  'ADD900': 'king-lime',
  'ADDFAD': 'light-moss-green',
  'ADE6C4': 'padua',
  'ADFF2F': 'green-yellow',
  'AE0C00': 'mordant-red',
  'AE2029': 'upsdell-red',
  'AE2719': 'joyous-red',
  'AE2F48': 'amore',
  'AE4560': 'hippie-pink',
  'AE6020': 'desert',
  'AE809E': 'bouquet',
  'AE8934': 'honey',
  'AE8A78': 'nougat',
  'AE98AA': 'lilac-luster',
  'AEA132': 'martian',
  'AEBBD0': 'sailor-boy',
  'AEBEA6': 'meadow-morn',
  'AEC6CF': 'pastel-blue',
  'AEC9EA': 'breeze',
  'AED1E8': 'vive-le-vent',
  'AED7EA': 'ariel',
  'AEDCEC': 'lady-in-waiting',
  'AEE4FF': 'frozen-landscape',
  'AF002A': 'alabama-crimson',
  'AF3519': 'grilled-tomato',
  'AF4035': 'pale-carmine',
  'AF403C': 'landj-ger',
  'AF4D43': 'apple-blossom',
  'AF593E': 'brown-rust',
  'AF6E4D': 'brown-sugar',
  'AF7934': 'butterbeer',
  'AF8751': 'driftwood',
  'AF8BA8': 'voila',
  'AF8F2C': 'alpine',
  'AF9968': 'veranda-gold',
  'AF9A7E': 'incense',
  'AF9F1C': 'lucky',
  'AFA09E': 'martini',
  'AFA696': 'forgotten-sandstone',
  'AFAF5E': 'palm',
  'AFB1B8': 'bombay',
  'AFB982': 'nile',
  'AFBB33': 'lush-bamboo',
  'AFBDD9': 'pigeon-post',
  'AFBED4': 'supremely-cool',
  'AFC9DC': 'life-at-sea',
  'AFCBE5': 'featherbed',
  'AFE3D6': 'ice-cube',
  'AFEEEE': 'light-turquoise',
  'AFFFD5': 'mintastic',
  'B0003C': 'bindi-red',
  'B0063D': 'ruby-queen',
  'B01B2E': 'christmas-red',
  'B04C6A': 'cadillac',
  'B05C52': 'giants-club',
  'B05D54': 'matrix',
  'B05E81': 'tapestry',
  'B06500': 'ginger',
  'B06608': 'mai-tai',
  'B06D3B': 'ginger-dough',
  'B07426': 'hamtaro-brown',
  'B08F42': 'pirates-hook',
  'B090B2': 'metal-petal',
  'B090C7': 'fleur-de-lis',
  'B09A95': 'del-rio',
  'B0A676': 'windy-meadow',
  'B0B8CC': 'ethereal-mist',
  'B0BCC3': 'stormy',
  'B0BF1A': 'acid-green',
  'B0C4DE': 'light-steel-blue',
  'B0E0E6': 'powder-blue',
  'B0E313': 'inch-worm',
  'B0EFCE': 'seafoam-splashes',
  'B10000': 'bright-red',
  'B1282A': 'tartan-red',
  'B14A0B': 'vesuvius',
  'B1610B': 'pumpkin-skin',
  'B16D52': 'santa-fe',
  'B1714C': 'not-yet-caramel',
  'B18377': 'dusty-duchess',
  'B1936D': 'caramel-gold',
  'B19461': 'teak',
  'B195E4': 'dreamy-candy-forest',
  'B19778': 'cookie-crumb',
  'B19C86': 'weathered-wood',
  'B19CD9': 'light-pastel-purple',
  'B1A979': 'bamboo-forest',
  'B1C6D6': 'cloudy-valley',
  'B1CF5D': 'juicy-lime',
  'B1DBAA': 'fizz',
  'B1DBF5': 'endless-horizon',
  'B1E2C1': 'fringy-flower',
  'B1E2CB': 'quiet-jade',
  'B1F4E7': 'ice-cold',
  'B20931': 'shiraz',
  'B2132B': 'kirsch',
  'B21D1D': 'siren-scarlet',
  'B21F1F': 'scarlet-blaze',
  'B22122': 'brick-by-brick',
  'B22222': 'firebrick',
  'B22743': 'cherryade',
  'B23C5D': 'cry-of-a-rose',
  'B23E4F': 'romantic-embers',
  'B24648': 'intrigue-red',
  'B2654E': 'bruschetta',
  'B27A47': 'rocky-racoon',
  'B284BE': 'african-violet',
  'B29700': 'sunken-gold',
  'B2A1EA': 'biloba-flower',
  'B2B2AD': 'steam-engine',
  'B2B2B2': 'tangled-web',
  'B2B5AF': 'magnetic',
  'B2BEB5': 'ash-grey',
  'B2C8BD': 'misty-morning',
  'B2CC9A': 'greenhorn',
  'B2E191': 'sage-sensation',
  'B2E1EE': 'break-the-ice',
  'B2EC5D': 'inchworm',
  'B2F8F8': 'ice-citadel',
  'B2FFFF': 'celeste',
  'B300FF': 'poison-purple-paradise',
  'B30103': 'all-systems-red',
  'B3107A': 'kings-plum-pie',
  'B31B1B': 'carnelian',
  'B3205F': 'murderous-magenta',
  'B32651': 'minted-blueberry-lemonade',
  'B32D29': 'tall-poppy',
  'B33A22': 'bricky-brick',
  'B3446C': 'irresistible',
  'B35213': 'fiery-orange',
  'B35966': 'hot-flamingo',
  'B3695F': 'peach-dunes',
  'B36B92': 'je-taime',
  'B38007': 'hot-toddy',
  'B38052': 'komodo-dragon',
  'B3833B': 'weissbier',
  'B3861E': 'arrowwood',
  'B38B6D': 'light-taupe',
  'B38B71': 'macaroon',
  'B39C8C': 'sombrero',
  'B39EB5': 'pastel-purple',
  'B3A74B': 'pickled',
  'B3A9A3': 'muted-mauve',
  'B3ADA7': 'dove',
  'B3B2BF': 'nebulous-december',
  'B3C110': 'la-rioja',
  'B3E2D3': 'bay',
  'B3E8C2': 'glaucous-green',
  'B40039': 'pure-passion',
  'B4023D': 'm-bison',
  'B40441': 'fancy-red-wine',
  'B43332': 'well-read',
  'B43548': 'chubby-kiss',
  'B44933': 'crimson-boy',
  'B4559B': 'magenta-memoir',
  'B47463': 'vin-cuit',
  'B48395': 'english-lavender',
  'B4B9B9': 'silver-mistral',
  'B4BDC7': 'stainless-steel',
  'B4C2A2': 'camping-grounds',
  'B4CFD3': 'jungle-mist',
  'B4D5BD': 'frosted-fir',
  'B4DA55': 'badass-grass',
  'B4DFED': 'polar-wind',
  'B4F319': 'lurid-lettuce',
  'B52604': 'crimson-velvet-sunset',
  'B52923': 'upset-tomato',
  'B52F3A': 'bloodsport',
  'B53389': 'fandango',
  'B55067': 'extravagant-blush',
  'B5651D': 'light-brown',
  'B57281': 'turkish-rose',
  'B57EDC': 'lavender',
  'B59410': 'faint-gold',
  'B5A27F': 'mongoose',
  'B5A642': 'brass',
  'B5AB9C': 'desert-dune',
  'B5ACAB': 'rose-ashes',
  'B5B35C': 'olive-green',
  'B5B68F': 'green-tea',
  'B5B6B7': 'wolfram',
  'B5C0B3': 'irish-moor',
  'B5D2CE': 'jet-stream',
  'B5D2D8': 'subtle-breeze',
  'B5DCD8': 'catch-the-wave',
  'B5ECDF': 'cruise',
  'B6273E': 'timeless-beauty',
  'B6316C': 'hibiscus',
  'B6321E': 'smouldering',
  'B63364': 'valentines-kiss',
  'B64055': 'merlot-magic',
  'B66325': 'polished-copper',
  'B66A50': 'clay',
  'B67267': 'morocco',
  'B68692': 'punched-pink',
  'B69D98': 'thatch',
  'B6B095': 'heathered-gray',
  'B6B0A9': 'mercurial',
  'B6BAA4': 'eagle',
  'B6BD4A': 'sinsemilla',
  'B6BDD0': 'arctic-ice',
  'B6D1EA': 'spindle',
  'B6D3BF': 'gum-leaf',
  'B6D3DF': 'pale-whale',
  'B6D4A0': 'in-good-taste',
  'B6E9C8': 'mint-o-licious',
  'B6FF1A': 'sweet-venom',
  'B6FFBB': 'light-mint',
  'B71010': 'federation-of-love',
  'B73D3F': 'cherry-bomb',
  'B7410E': 'rust',
  'B7513A': 'hot-chilli',
  'B768A2': 'pearly-purple',
  'B76E79': 'rose-gold',
  'B77D5F': 'silken-chocolate',
  'B784A7': 'opera-mauve',
  'B78727': 'university-of-california-gold',
  'B78E5C': 'muddy-waters',
  'B79C94': 'creamed-caramel',
  'B7A214': 'sahara',
  'B7A28E': 'hickory',
  'B7A458': 'husk',
  'B7A5AD': 'foggy-plum',
  'B7B1B1': 'nobel',
  'B7B9B5': 'greystone',
  'B7BDD1': 'violet-vision',
  'B7C2CC': 'icebreaker',
  'B7C3D0': 'heather',
  'B7C5C6': 'trade-winds',
  'B7D2E3': 'delicate-ice',
  'B7E1A1': 'basil-smash',
  'B7F0BE': 'madang',
  'B80CE3': 'vivid-mulberry',
  'B81104': 'milano-red',
  'B8282F': 'toadstool',
  'B84048': 'dragons-blood',
  'B84823': 'spice-market',
  'B85824': 'fallen-canopy',
  'B8623B': 'caramel-dream',
  'B86D29': 'dogs',
  'B86FC2': 'lavendless',
  'B87333': 'copper',
  'B8860B': 'dark-goldenrod',
  'B8B1A5': 'silver-lining',
  'B8B56A': 'gimblet',
  'B8B8F8': 'purple-illusion',
  'B8BF71': 'zoodles',
  'B8BFDC': 'stardust-evening',
  'B8C1B1': 'green-spring',
  'B8C25D': 'celery',
  'B8E0D0': 'jade-sea',
  'B8E0F9': 'sail',
  'B8E4F5': 'breaking-the-ice',
  'B8F818': 'green-venom',
  'B9030A': 'bullseye',
  'B9396E': 'spicy-purple',
  'B94E41': 'conker',
  'B94E48': 'deep-chestnut',
  'B95140': 'crail',
  'B95B6D': 'candied-apple',
  'B96033': 'boho-copper',
  'B96B00': 'indocile-tiger',
  'B96D8E': 'pinky-pickle',
  'B97DA8': 'romanov-mauve',
  'B98052': 'in-a-nutshell',
  'B9B4B1': 'grey-marble',
  'B9C46A': 'wild-willow',
  'B9C4D2': 'plein-air',
  'B9C8AC': 'rainee',
  'B9F2FF': 'diamond',
  'B9FF03': 'atomic-lime',
  'BA0033': 'warlord',
  'BA0101': 'guardsman-red',
  'BA0105': 'bloody-mary',
  'BA0728': 'valentine-lava',
  'BA160C': 'engineering-international-orange',
  'BA271A': 'bloodshed',
  'BA417B': 'razzle-dazzle',
  'BA450C': 'rock-spray',
  'BA55D3': 'medium-orchid',
  'BA6F1E': 'bourbon',
  'BA7F03': 'pirate-gold',
  'BA7F38': 'cut-the-mustard',
  'BA8759': 'deer',
  'BA8B36': 'treasures',
  'BA93D8': 'lenurple',
  'BA9B5D': 'packing-paper',
  'BAA2CE': 'lucius-lilac',
  'BAA38B': 'sesame',
  'BAAAAA': 'grey-sheep',
  'BAAEA8': 'taupedo',
  'BAB1A2': 'nomad',
  'BAB8AD': 'zen-pebble',
  'BABC72': 'savannah-grass',
  'BABCC0': 'microchip',
  'BABFBC': 'metal',
  'BAC3CC': 'yorkshire-cloud',
  'BAC7C9': 'submarine',
  'BADBED': 'sleepless-blue',
  'BAEBAE': 'ice-ice',
  'BAEEF9': 'charlotte',
  'BB0000': 'harlocks-cape',
  'BB0011': 'red-baron',
  'BB0022': 'pixel-bleeding',
  'BB0033': 'hot-cuba',
  'BB0066': 'aztec-warrior',
  'BB0088': 'vibrant-velvet',
  'BB0099': 'jealous-jellyfish',
  'BB00AA': 'purple-pirate',
  'BB00FF': 'the-grape-war-of-97',
  'BB02FE': 'spectacular-purple',
  'BB1133': 'active-volcano',
  'BB1144': 'rural-red',
  'BB1155': 'velvet-magic',
  'BB1177': 'infectious-love',
  'BB11AA': 'punk-rock-purple',
  'BB11EE': 'promiscuous-pink',
  'BB1E1E': 'red-inferno',
  'BB2266': 'chaotic-roses',
  'BB22AA': 'amora-purple',
  'BB240C': 'lobster',
  'BB3300': 'dropped-brick',
  'BB3333': 'pesto-rosso',
  'BB3381': 'very-berry',
  'BB3385': 'medium-red-violet',
  'BB4400': 'bolognese',
  'BB4466': 'mauve-it',
  'BB5511': 'bloodhound',
  'BB5522': 'roland-garros',
  'BB55CC': 'love-priestess',
  'BB5C4D': 'tandoori',
  'BB5F62': 'her-velour',
  'BB6528': 'ruddy-brown',
  'BB6688': 'malevolent-mauve',
  'BB6B41': 'oak-palace',
  'BB715B': 'spiced',
  'BB7711': 'caramel-coating',
  'BB7A39': 'molten-caramel',
  'BB8246': 'arrakis-spice',
  'BB852F': 'gothic-gold',
  'BB8877': 'ludicrous-lemming',
  'BB8983': 'brandy-rose',
  'BB8D4E': 'baristas-favourite',
  'BB9351': 'maple-syrup',
  'BB99AA': 'classy-mauve',
  'BB99BB': 'dripping-wisteria',
  'BB9E7C': 'french-oak',
  'BB9ECD': 'turnip-crown',
  'BBAA88': 'bangalore',
  'BBAC7D': 'nettle',
  'BBB3A2': 'ashes-to-ashes',
  'BBB477': 'misty-moss',
  'BBBCBC': 'dust-to-dust',
  'BBC199': 'beige-and-sage',
  'BBCC00': 'serpent-sceptre',
  'BBCFEF': 'frost-fairy',
  'BBD009': 'rio-grande',
  'BBD75A': 'frog-prince',
  'BBD7C1': 'surf',
  'BBDAF8': 'oh-boy',
  'BBDD00': 'high-grass',
  'BBDD11': 'cucumber-bomber',
  'BBDD55': 'queen-of-gardens',
  'BBDDFF': 'broad-daylight',
  'BBE4EA': 'tip-of-the-iceberg',
  'BBEE00': 'lush-green',
  'BBEE99': 'sweet-mint-pesto',
  'BBEFD3': 'mystery-mint',
  'BBFF00': 'nuclear-blast',
  'BBFFFF': 'the-big-freeze',
  'BC002C': 'nippon',
  'BC002D': 'hinomaru-red',
  'BC012E': 'akai-red',
  'BC13FE': 'neon-purple',
  'BC2026': 'red-carpet',
  'BC3033': 'hot-jazz',
  'BC6F37': 'lucky-penny',
  'BC8F8F': 'rosy-brown',
  'BC987E': 'pale-taupe',
  'BCB667': 'motherland',
  'BCB7AD': 'ghost-writer',
  'BCB7B1': 'rampart',
  'BCB88A': 'sage',
  'BCC09E': 'animal-kingdom',
  'BCC3C7': 'metallic',
  'BCC9C2': 'powder-ash',
  'BCCAB3': 'bok-choy',
  'BCCB08': 'cheerly-kiwi',
  'BCCCB5': 'isle-of-dreams',
  'BCD4E6': 'beau-blue',
  'BD2F10': 'once-bitten',
  'BD33A4': 'byzantine',
  'BD5620': 'titian-red',
  'BD978E': 'quicksand',
  'BD9D95': 'coca-mocha',
  'BDA58B': 'oakwood',
  'BDA928': 'greenfinch',
  'BDACA3': 'mushroom',
  'BDB0D0': 'pastel-lilac',
  'BDB1A8': 'silk',
  'BDB2A1': 'malta',
  'BDB3C7': 'chatelle',
  'BDB76B': 'dark-khaki',
  'BDBCC4': 'silver-fox',
  'BDBDC6': 'french-gray',
  'BDBEBF': 'rough-asphalt',
  'BDC2BB': 'silky-green',
  'BDC8B3': 'clay-ash',
  'BDC9CE': 'loblolly',
  'BDCFEA': 'maritime',
  'BDD1D2': 'windy',
  'BDD4D1': 'coast-to-coast',
  'BDDA57': 'june-bud',
  'BDDBE1': 'quick-freeze',
  'BDDFD8': 'antiguan',
  'BDE1C4': 'mother-nature',
  'BDEDFD': 'french-pass',
  'BE0032': 'crimson-glory',
  'BE4F62': 'popstar',
  'BE6400': 'fire-ant',
  'BE893F': 'peanut-butter',
  'BE9C67': 'tiger',
  'BE9E6F': 'curry-sauce',
  'BEA6C3': 'london-hue',
  'BEA88D': 'coffee-diva',
  'BEA932': 'hey-pesto',
  'BEB5B7': 'pink-swan',
  'BEBEC4': 'moonwalk',
  'BEC187': 'kiss-a-frog',
  'BECEDB': 'winter-scene',
  'BED565': 'glow-worm',
  'BEDE0D': 'fuego',
  'BEE0E2': 'poolside',
  'BEE7A5': 'pastel-pea',
  'BEEB71': 'pisco-sour',
  'BEEDDC': 'fresh-breeze',
  'BEF7CF': 'smell-the-mint',
  'BEFDB7': 'glow-in-the-dark',
  'BF00FF': 'electric-purple',
  'BF1818': 'heartwarming',
  'BF2735': 'lolita',
  'BF3CFF': 'magento',
  'BF4000': 'copper-hopper',
  'BF4F51': 'bittersweet-shimmer',
  'BF5500': 'rose-of-sharon',
  'BF6153': 'too-hot-to-handle',
  'BF652E': 'dwarven-bronze',
  'BF77F6': 'illicit-purple',
  'BF8FC4': 'violaceous',
  'BF90BB': 'la-la-love',
  'BF91B2': 'mauve-magic',
  'BF94E4': 'bright-lavender',
  'BFA3D9': 'enchanted-lavender',
  'BFA58A': 'pergament',
  'BFAC05': 'muddy-yellow',
  'BFAC86': 'faded-letter',
  'BFAFB2': 'black-shadows',
  'BFB3AB': 'hipster-hippo',
  'BFB8B0': 'tide',
  'BFB9AA': 'techno-taupe',
  'BFBED8': 'blue-haze',
  'BFC1C2': 'silver-sand',
  'BFC1CB': 'slipper-satin',
  'BFC921': 'key-lime-pie',
  'BFD5B3': 'nature',
  'BFD6D1': 'aquatic-edge',
  'BFDBE2': 'ziggurat',
  'BFF128': 'pick-your-poison',
  'BFFBFF': 'friendly-frost',
  'BFFF00': 'lime',
  'C02B18': 'thunderbird',
  'C02E4C': 'bleeding-heart',
  'C0362C': 'golden-gate-bridge',
  'C04000': 'mahogany',
  'C04737': 'mojo',
  'C0686E': 'watermelon-gelato',
  'C07765': 'himalayan-salt',
  'C08081': 'old-rose',
  'C09856': 'amaretto-sour',
  'C09999': 'tuscany',
  'C0B0D0': 'vintage-bloom',
  'C0B2D7': 'moonraker',
  'C0B9AC': 'city-dweller',
  'C0C0C0': 'silver',
  'C0C2C0': 'waxwing',
  'C0C3C4': 'foil',
  'C0CBA1': 'seedling',
  'C0D0E6': 'misty-mountains',
  'C0D3B9': 'pale-leaf',
  'C0D725': 'lime-punch',
  'C0D8B6': 'pixie-green',
  'C0E2C5': 'sugar-mint',
  'C0F000': 'leafy-lemon',
  'C0FFEE': 'arabica-mint',
  'C10102': 'ghost-pepper',
  'C11C84': 'rrosy-fingered-dawn',
  'C13939': 'crimson-glow',
  'C1440E': 'tia-maria',
  'C1537D': 'fat-smooch',
  'C154C1': 'deep-fuchsia',
  'C17C54': 'pheasant',
  'C19A13': 'rapeseed',
  'C19A62': 'lion',
  'C19A6B': 'fallow',
  'C19A6C': 'cardboard',
  'C1A004': 'buddha-gold',
  'C1ACC3': 'monet-magic',
  'C1B19D': 'warm-neutral',
  'C1B7A4': 'bison-hide',
  'C1B7B0': 'sand-ripples',
  'C1BAB0': 'tea',
  'C1BCAC': 'pelican',
  'C1BECD': 'gray-suit',
  'C1C2C3': 'magnesium',
  'C1D7B0': 'sprout',
  'C1E613': 'sour-green',
  'C1EE13': 'virtual-golf',
  'C1F07C': 'sulu',
  'C1FD95': 'celery-mousse',
  'C1FDC9': 'toxic-steam',
  'C21727': 'racing-red',
  'C21E56': 'rose-red',
  'C2264D': 'possessed-red',
  'C22F4D': 'dry-rose',
  'C23B22': 'dark-pastel-red',
  'C23C47': 'poppy',
  'C24325': 'paprika-kisses',
  'C24359': 'saffron-desires',
  'C26157': 'barbecue',
  'C26B03': 'indochine',
  'C2792B': 'maine-coon-orange',
  'C27F38': 'ginger-beer',
  'C2877B': 'whisky',
  'C2955D': 'twine',
  'C29594': 'mutabilis',
  'C29867': 'chalet',
  'C2A06D': 'silence-is-golden',
  'C2A4C2': 'novel-lilac',
  'C2B280': 'ecru',
  'C2B4A7': 'couch-potato',
  'C2B8AE': 'moonbeam',
  'C2BDB6': 'cotton-seed',
  'C2C0BA': 'silverplate',
  'C2CAC4': 'pumice',
  'C2D3AF': 'morris-leaf',
  'C2D5D8': 'up-in-the-air',
  'C2D6EC': 'polar-opposite',
  'C2DDE6': 'breezy',
  'C2E1EC': 'cotton-clouds',
  'C2E2E3': 'cold-wave',
  'C2E5E5': 'swimming',
  'C2E7E8': 'on-cloud-nine',
  'C2E8E5': 'jagged-ice',
  'C2F177': 'cucumber-milk',
  'C30232': 'pomodoro',
  'C30305': 'threatening-red',
  'C30B0A': 'blood-kiss',
  'C30B4E': 'pictorial-carmine',
  'C32148': 'bright-maroon',
  'C32F40': 'crimson-cloud',
  'C33A36': 'stop',
  'C34B1B': 'red-panda',
  'C3585C': 'pimms',
  'C35B99': 'llilacquered',
  'C36666': 'stormy-passion',
  'C3738D': 'prehistoric-pink',
  'C3816E': 'earthworm',
  'C38B36': 'victorian-crown',
  'C38D87': 'grand-sunset',
  'C39355': 'caramel-crumb',
  'C3988B': 'muddy-mire',
  'C39953': 'aztec-gold',
  'C39C55': 'steampunk-gold',
  'C3A679': 'medallion',
  'C3B091': 'khaki',
  'C3BFC1': 'pale-slate',
  'C3C3BD': 'gray-nickel',
  'C3C67E': 'soda-pop',
  'C3CDE6': 'periwinkle-gray',
  'C3D1D1': 'tiara',
  'C3D7E0': 'skinny-dippin',
  'C3DAE3': 'getting-wet',
  'C3DDF9': 'tropical-blue',
  'C3ECE9': 'gentle-cold',
  'C3FBF4': 'glacial-drift',
  'C40233': 'ncs-red',
  'C41661': 'secret-affair',
  'C41E3A': 'cardinal',
  'C42B2D': 'knockout',
  'C44E4F': 'autumn-fire',
  'C45655': 'fuzzy-wuzzy-brown',
  'C45719': 'orange-roughy',
  'C46210': 'alloy-orange',
  'C46D29': 'cajeta',
  'C49B35': 'golden-mean',
  'C4A777': 'gold-rush',
  'C4A7A1': 'sable-cloaked',
  'C4AB86': 'croissant',
  'C4AEAD': 'silver-pink',
  'C4B198': 'tender-taupe',
  'C4B9B8': 'nebulous',
  'C4BAD2': 'fog-syringa',
  'C4BBA5': 'forgotten-tusk',
  'C4C3D0': 'lavender-gray',
  'C4C4BC': 'mist-gray',
  'C4C4C4': 'explosive-grey',
  'C4C5C6': 'weathered-stone',
  'C4D0B0': 'coriander',
  'C4D8E2': 'columbia-blue',
  'C4ECF0': 'icy-breeze',
  'C4F4EB': 'mint-tulip',
  'C4FFF7': 'crushed-ice',
  'C53151': 'dingy-dungeon',
  'C54B8C': 'mulberry',
  'C58D4B': 'caramel-macchiato',
  'C59922': 'nugget',
  'C5994B': 'tussock',
  'C5A049': 'goldbricker',
  'C5A582': 'latte',
  'C5B358': 'vegas-gold',
  'C5BDA0': 'lush',
  'C5C0B0': 'stone-fortress',
  'C5D17B': 'alligator-alley',
  'C5D1DA': 'polished-silver',
  'C5D8E9': 'snowy-summit',
  'C5DBCA': 'sea-mist',
  'C5E1E1': 'peek-a-blue',
  'C5E5E2': 'swan-lake',
  'C5E6CF': 'delta-mint',
  'C6101E': 'bloodthirsty-lips',
  'C62D2C': 'peri-peri',
  'C64A4A': 'king-crimson',
  'C6726B': 'contessa',
  'C68F65': 'butterum',
  'C69191': 'oriental-pink',
  'C69F26': 'mustard-seed',
  'C69F59': 'camel',
  'C6A1CF': 'lilac-lace',
  'C6A84B': 'roti',
  'C6AA2B': 'hippie-trail',
  'C6AA81': 'pony',
  'C6BB9C': 'beach-dune',
  'C6BBDB': 'new-love',
  'C6C3B5': 'ash',
  'C6C6C2': 'brume',
  'C6C8BD': 'kangaroo',
  'C6C8CF': 'herring-silver',
  'C6CEDA': 'steel-mist',
  'C6D624': 'lime-twist',
  'C6D86B': 'cool-as-a-cucumber',
  'C6D8C7': 'marsh-fog',
  'C6DCE7': 'king-of-waves',
  'C6E1BC': 'ambrosia',
  'C6E610': 'las-palmas',
  'C6EC7A': 'venomous-sting',
  'C7031E': 'monza',
  'C71414': 'cherry-crush',
  'C71585': 'red-violet',
  'C72616': 'minestrone',
  'C72C48': 'french-raspberry',
  'C74300': 'vinaceous-tawny',
  'C74375': 'fuchsia-rose',
  'C7662A': 'chivalrous-fox',
  'C77579': 'rosa-chinensis',
  'C79843': 'natt',
  'C7AB8B': 'semolina',
  'C7AC7D': 'toupe',
  'C7BBA4': 'another-one-bites-the-dust',
  'C7BCA1': 'chopped-almonds',
  'C7BCA2': 'coral-reef',
  'C7BDB3': 'kitty-kitty',
  'C7C1FF': 'melrose',
  'C7C4BF': 'cloud',
  'C7C9D5': 'ghost',
  'C7CCCE': 'where-there-is-smoke',
  'C7CD90': 'pine-glade',
  'C7CFC7': 'murmur',
  'C7D1DB': 'memory-lane',
  'C7D7E0': 'yeti-footprint',
  'C7DBE4': 'breath-of-fresh-air',
  'C7DDE5': 'botticelli',
  'C7F1FF': 'heaven-gates',
  'C80815': 'venetian-red',
  'C84186': 'smitten',
  'C88849': 'butter-bronze',
  'C88CA4': 'pinch-me',
  'C89D3F': 'goldie',
  'C8A2C8': 'lilac',
  'C8A528': 'hokey-pokey',
  'C8A6A1': 'parfait',
  'C8AABF': 'lily',
  'C8AD7F': 'light-french-beige',
  'C8B568': 'laser',
  'C8C2BE': 'dim',
  'C8C8CC': 'nimbus-cloud',
  'C8D07F': 'zucchini-noodles',
  'C8D0CA': 'infusion',
  'C8DAF5': 'fly-a-kite',
  'C8DDEA': 'put-on-ice',
  'C8E3D7': 'edgewater',
  'C8FF00': 'liquid-neon',
  'C90016': 'harvard-crimson',
  'C9001E': 'marilyn-monrouge',
  'C90B42': 'akari-red',
  'C920B0': 'mystifying-magenta',
  'C92435': 'cherry-sangria',
  'C92B1E': 'red-mist',
  'C92D21': 'red-seal',
  'C9312B': 'hot-lips',
  'C95A49': 'cedar-chest',
  'C96323': 'piper',
  'C973A2': 'fading-love',
  'C98F70': 'bakers-dream',
  'C99415': 'pizza',
  'C99680': 'beauty-and-the-beach',
  'C9A0DC': 'wisteria',
  'C9A0FF': 'diva',
  'C9A375': 'outback',
  'C9A86A': 'ginger-ale',
  'C9B29B': 'rodeo-dust',
  'C9B35B': 'sundance',
  'C9B93B': 'earls-green',
  'C9C0BB': 'pale-silver',
  'C9C1B1': 'oatmeal',
  'C9D1EF': 'frozen-periwinkle',
  'C9D9D2': 'conch',
  'C9DC87': 'medium-spring-bud',
  'C9E7E3': 'polar-expedition',
  'C9FFA2': 'reef',
  'C9FFE5': 'aero-blue',
  'CA135E': 'yearning-desire',
  'CA1F7B': 'magenta',
  'CA2C92': 'royal-fuchsia',
  'CA3434': 'smouldering-red',
  'CA3435': 'flush-mahogany',
  'CA4E33': 'fox',
  'CA83A7': 'moonlight-mauve',
  'CA994E': 'gingerbread-house',
  'CAB012': 'sulphur',
  'CAB266': 'canadian-maple',
  'CABA97': 'stone-guardians',
  'CABAA9': 'dinosaur-egg',
  'CABAB1': 'smooth-pebbles',
  'CABAE0': 'viking-diva',
  'CABB48': 'turmeric',
  'CABFB4': 'crumbling-statue',
  'CAC0E1': 'digital-lavender',
  'CAD175': 'fools-gold',
  'CADCD4': 'paris-white',
  'CADECE': 'ruins-of-civilization',
  'CAE00D': 'bitter-lemon',
  'CAE03B': 'greenivorous',
  'CAE6DA': 'skeptic',
  'CAE80A': 'poisonous-pesto',
  'CAE8E8': 'tropical-mist',
  'CAF0E5': 'caribbean',
  'CB0103': 'scarlet-glow',
  'CB1028': 'super-rose-red',
  'CB410B': 'sinopia',
  'CB4154': 'brick-red',
  'CB6D51': 'copper-red',
  'CB862C': 'harvest-at-dusk',
  'CB8F7B': 'ginger-scent',
  'CB8FA9': 'viola',
  'CB9711': 'retro-vibe',
  'CB99C9': 'pastel-violet',
  'CB9E34': 'local-curry',
  'CBA135': 'satin-sheen-gold',
  'CBBBCD': 'last-of-the-lilacs',
  'CBC1A2': 'moth',
  'CBC4C0': 'in-the-shadows',
  'CBC5C6': 'dangerous-robot',
  'CBC9C0': 'quill-grey',
  'CBCAB6': 'foggy-gray',
  'CBCBCB': 'silverback',
  'CBCDCD': 'iron-fist',
  'CBCECF': 'whisper-of-smoke',
  'CBD1D0': 'ghost-whisperer',
  'CBD3B0': 'green-mist',
  'CBD4DF': 'ephemeral-blue',
  'CBDBD6': 'nebula',
  'CBDCE2': 'sea-foam-mist',
  'CBE1E4': 'melting-point',
  'CBE3EE': 'niagara-falls',
  'CBE4E7': 'wave-splash',
  'CBEAEE': 'summer-mist',
  'CBF4F8': 'vaporised',
  'CC0000': 'boston-university-red',
  'CC0002': 'signal',
  'CC0021': 'fierce-red',
  'CC0033': 'vivid-crimson',
  'CC0077': 'bottom-of-my-heart',
  'CC00CC': 'deep-magenta',
  'CC00EE': 'trippy-velvet',
  'CC00FF': 'vivid-orchid',
  'CC0404': 'rebellion-red',
  'CC0C1B': 'scarlet-splendour',
  'CC1100': 'vampire-state-building',
  'CC1133': 'red-tape',
  'CC1155': 'love-juice',
  'CC11BB': 'explosive-purple',
  'CC2200': 'piment-piquant',
  'CC2222': 'lionheart',
  'CC2233': 'methadone',
  'CC2255': 'vampire-fangs',
  'CC2277': 'prince-charming',
  'CC22FF': 'flirtatious-flamingo',
  'CC3300': 'pleasant-pomegranate',
  'CC3322': 'lucky-lobster',
  'CC3333': 'persian-red',
  'CC3366': 'spicy-berry',
  'CC3388': 'shrine-of-pleasures',
  'CC338B': 'magenta-pink',
  'CC33CC': 'steel-pink',
  'CC33FF': 'flamingo-queen',
  'CC363C': 'bento-box',
  'CC397B': 'fuchsia-purple',
  'CC3B3B': 'chefs-kiss',
  'CC4400': 'mellow-mango',
  'CC4411': 'fire-bolt',
  'CC4422': 'underpass-shrine',
  'CC4433': 'bloody-salmon',
  'CC4466': 'paper-hearts',
  'CC474B': 'english-vermillion',
  'CC4E5C': 'dark-terra-cotta',
  'CC5500': 'burnt-orange',
  'CC55EE': 'bubblegum-baby-girl',
  'CC6622': 'solar-ash',
  'CC6666': 'fuzzy-wuzzy',
  'CC6E3B': 'hot-caramel',
  'CC7722': 'ochre',
  'CC7744': 'cork-wood',
  'CC77EE': 'fake-love',
  'CC8822': 'chicken-masala',
  'CC8866': 'escalope',
  'CC8899': 'puce',
  'CC8F15': 'end-of-summer',
  'CC974D': 'bengal',
  'CC9900': 'vivid-amber',
  'CC9944': 'camel-cardinal',
  'CC9966': 'brown-yellow',
  'CC99CC': 'light-grayish-magenta',
  'CC99DD': 'somewhere-in-a-fairytale',
  'CC99EE': 'dream-vapour',
  'CC99FF': 'pale-violet',
  'CCA01D': 'lemon-curry',
  'CCAA00': 'hot-sand',
  'CCB490': 'windsor-toffee',
  'CCBB99': 'intimate-journal',
  'CCBBAA': 'smoke-dragon',
  'CCBBDD': 'sweet-lucid-dreams',
  'CCBCA9': 'attic-linen',
  'CCC4B0': 'seine-and-sensibility',
  'CCCAA8': 'thistle-green',
  'CCCC11': 'golden-harvest',
  'CCCCFF': 'periwinkle',
  'CCCF86': 'sunken-treasure',
  'CCD0DA': 'steam-bath',
  'CCDDCC': 'flip-a-coin',
  'CCE2F3': 'salty-ice',
  'CCE7E8': 'starship-tonic',
  'CCFF00': 'electric-lime',
  'CCFF11': 'toxic-boyfriend',
  'CCFFC2': 'frosted-mint-hills',
  'CCFFEE': 'mint-coffee',
  'CD0317': 're-entry-red',
  'CD0D0D': 'love-goddess',
  'CD123F': 'toreador',
  'CD2217': 'pizza-flame',
  'CD5700': 'tenne',
  'CD5B45': 'dark-coral',
  'CD5C51': 'firebug',
  'CD5C5C': 'indian-red',
  'CD607E': 'cinnamon-satin',
  'CD7F32': 'bronze',
  'CD8429': 'brandy-punch',
  'CD853F': 'peru',
  'CD9575': 'antique-brass',
  'CDA291': 'cashmere-clay',
  'CDA4DE': 'tropical-violet',
  'CDB1AB': 'garden-snail',
  'CDB7FA': 'violet-heaven',
  'CDBB63': 'the-weight-of-gold',
  'CDC7C7': 'silver-tongued',
  'CDD80D': 'goldzilla',
  'CDDFE7': 'bird-bath-blue',
  'CDF4FF': 'onahau',
  'CDF80C': 'liquid-lime',
  'CE0001': 'thai-chilli',
  'CE0644': 'flame-lily',
  'CE145E': 'love-potion',
  'CE1D51': 'love-surge',
  'CE2029': 'fire-engine-red',
  'CE243F': 'sovereign-red',
  'CE4676': 'ruber',
  'CE4A2D': 'peanut-butter-jelly',
  'CE5F38': 'campfire',
  'CE7790': 'devilish-diva',
  'CE9844': 'mayan-treasure',
  'CEB790': 'goldfrapp',
  'CEB98F': 'sorrell-brown',
  'CEB997': 'bakers-dozen',
  'CEBABA': 'cold-turkey',
  'CEBBB3': 'mothy',
  'CEC291': 'yuma',
  'CEC3DD': 'lavender-bliss',
  'CEC754': 'salsa-verde',
  'CEC7A7': 'chino',
  'CEC8EF': 'soap',
  'CEC9C3': 'misty-haze',
  'CECAC3': 'argento',
  'CECB97': 'court-bouillon',
  'CEDEE2': 'high-sierra',
  'CEE1C8': 'endive',
  'CEE1F2': 'hint-of-blue',
  'CEE5DF': 'ice-dagger',
  'CEE5E9': 'northwind',
  'CEECE7': 'spa',
  'CEF0CC': 'pastel-mint',
  'CEFF00': 'volt',
  'CF0234': 'cherry',
  'CF0D14': 'hypnotic-red',
  'CF1020': 'lava',
  'CF3476': 'telemagenta',
  'CF4796': 'twinkly-pinkily',
  'CF5570': 'strawberry-moon',
  'CF6BA9': 'super-pink',
  'CF71AF': 'sky-magenta',
  'CF758A': 'first-love',
  'CF7A4B': 'brown-sugar-glaze',
  'CF875F': 'harvest-time',
  'CF8A78': 'muted-clay',
  'CF929A': 'rosetti',
  'CFA14A': 'chipmunk',
  'CFA39D': 'eunry',
  'CFAC47': 'haystack',
  'CFB53B': 'old-gold',
  'CFBCCF': 'tamed-beauty',
  'CFC5AF': 'pistachio-shell',
  'CFC9C7': 'warm-ashes',
  'CFC9DF': 'dust-of-the-moon',
  'CFCBE5': 'foggy-plateau',
  'CFCFC4': 'pastel-gray',
  'CFCFCF': 'silver-eagle',
  'CFD1B2': 'bitter-melon',
  'CFD9DE': 'zen',
  'CFDAFB': 'icy-plains',
  'CFDCCF': 'tasman',
  'CFE2E0': 'mountain-dew',
  'CFE5D2': 'surf-crest',
  'CFE838': 'lime-fizz',
  'CFE8B6': 'frozen-forest',
  'CFEBEA': 'mint-chip',
  'CFECEE': 'sprinkled-with-dew',
  'CFF9F3': 'humming-bird',
  'CFFAF4': 'scandal',
  'CFFF04': 'neon-yellow',
  'D00220': 'dangerous-affair',
  'D01722': 'cartoon-violence',
  'D01A2C': 'splatter-movie',
  'D02B48': 'demonic-kiss',
  'D04014': 'lava-smoothie',
  'D04127': 'mr-krabs',
  'D0417E': 'pantone-magenta',
  'D05F04': 'red-stage',
  'D06DA1': 'hopbush',
  'D07D12': 'meteor',
  'D0851D': 'copious-caramel',
  'D09C43': 'espresso-crema',
  'D0B393': 'bakers-bread',
  'D0BB9D': 'treasure-map',
  'D0BEF8': 'perfume',
  'D0C0E5': 'prelude',
  'D0C19F': 'castaway-beach',
  'D0C4AC': 'trail-dust',
  'D0C4D3': 'mecha-kitty',
  'D0C678': 'muted-lime',
  'D0C7FF': 'innocent-snowdrop',
  'D0CBCE': 'columbos-coat',
  'D0D0C9': 'silken-pebble',
  'D0D1C1': 'wishing-well',
  'D0D418': 'sun-flooded-woods',
  'D0DCE8': 'blue-silk',
  'D0E1E8': 'goddess',
  'D0E5F2': 'new-heights',
  'D0EED7': 'jade-palace',
  'D0F0C0': 'tea-green',
  'D0FF14': 'arctic-lime',
  'D1001C': 'blood-orange',
  'D10047': 'spanish-carmine',
  'D10056': 'rubine-red',
  'D1062B': 'vermilion-scarlet',
  'D1191C': 'heroic-red',
  'D13D4B': 'smooch-rouge',
  'D15915': 'tomato-bisque',
  'D1668F': 'preppy-rose',
  'D16D76': 'mexican-chile',
  'D1768F': 'muted-pink',
  'D18F1B': 'geebung',
  'D1902E': 'vibrant-amber',
  'D19431': 'jackpot',
  'D198B5': 'exotic-lilac',
  'D19C97': 'savoury-salmon',
  'D19FE8': 'bright-ube',
  'D1B075': 'gold-digger',
  'D1B49F': 'soba',
  'D1B99B': 'cosy-wool',
  'D1BEA8': 'dark-vanilla',
  'D1C0DC': 'girl-crush',
  'D1C6B4': 'soft-amber',
  'D1D2DD': 'mischka',
  'D1D4D1': 'sterling',
  'D1DAC0': 'zen-garden',
  'D1DCE8': 'ice-desert',
  'D1DDE1': 'head-in-the-clouds',
  'D1E1E4': 'valley-of-tears',
  'D1E231': 'pear',
  'D1E8F1': 'on-thin-ice',
  'D1EAEA': 'teardrop',
  'D1EAEC': 'jet-deau',
  'D1EAED': 'castle-in-the-sky',
  'D1F358': 'ultra-moss',
  'D208CC': 'awkward-purple',
  'D22B6D': 'self-love',
  'D2663B': 'koi',
  'D26911': 'cinnamon',
  'D2691E': 'cocoa-brown',
  'D28CA7': 'kiss',
  'D29EAA': 'careys-pink',
  'D2A5A3': 'la-vie-en-rose',
  'D2AB51': 'solar-relic',
  'D2AD84': 'toast-and-butter',
  'D2ADB5': 'strawberry-latte',
  'D2AE84': 'sheaf',
  'D2B48C': 'tan',
  'D2CFC1': 'lunar-landing',
  'D2CFC4': 'silver-birch',
  'D2D1D0': 'blowing-smoke',
  'D2D2D4': 'rapunzel-silver',
  'D2DA97': 'deco',
  'D2DEF2': 'puffy-cloud',
  'D2EAEA': 'queen-of-waves',
  'D2F2E7': 'minty-fresh',
  'D2F6DE': 'blue-romance',
  'D2F8B0': 'gossip',
  'D3003F': 'utah-crimson',
  'D30F3F': 'last-warning',
  'D3212D': 'amaranth-red',
  'D33376': 'beetroot-purple',
  'D34D4D': 'horror-snob',
  'D35D7D': 'peppermint-swirl',
  'D3934D': 'salt-caramel',
  'D39BCB': 'light-medium-orchid',
  'D39ED2': 'velvet-horizon',
  'D3BFE5': 'york-plum',
  'D3CBBA': 'sisal',
  'D3CDC5': 'swirl',
  'D3CFAB': 'crystal-palace',
  'D3D3D3': 'light-gray',
  'D3DBE2': 'skyscraper',
  'D3DDE4': 'a-dime-a-dozen',
  'D3DDE7': 'nordic-breeze',
  'D3E1D3': 'misty-marsh',
  'D3E5EB': 'ocean-breeze',
  'D40000': 'rosso-corsa',
  'D40701': 'boulevardier',
  'D41003': 'dragons-breath',
  'D41C4E': 'electrifying-kiss',
  'D4202A': 'flaming-cherry',
  'D4265D': 'beet-wave',
  'D44B3B': 'warming-heart',
  'D46362': 'happy-hearts',
  'D4696D': 'lipstick-illusion',
  'D470A2': 'wild-orchid',
  'D47186': 'strawberry-milkshake',
  'D473D4': 'french-mauve',
  'D47494': 'charm',
  'D47D72': 'bite-my-tongue',
  'D4915D': 'whiskey-sour',
  'D49AB9': 'sweet-perfume',
  'D4AF37': 'metallic-gold',
  'D4B6AF': 'clam-shell',
  'D4B75D': 'luxurious',
  'D4BC94': 'crepe',
  'D4C4A8': 'akaroa',
  'D4C990': 'golden-mist',
  'D4CA8E': 'royal-goblet',
  'D4CB60': 'quince',
  'D4CD16': 'bird-flower',
  'D4D0C5': 'greybeard',
  'D4D4D4': 'disco-ball',
  'D4D7D9': 'iron',
  'D4D8CE': 'luna',
  'D4D8D7': 'olympus-white',
  'D4DE49': 'yuzukosh',
  'D4DFE2': 'geyser',
  'D4E0EF': 'cold-shoulder',
  'D4E2FC': 'hawkes-blue',
  'D4E8D8': 'splashdown',
  'D4E9F5': 'freezing-vapour',
  'D4EAFF': 'veiling-waterfalls',
  'D4F1F9': 'water',
  'D4FFFF': 'mount-olympus',
  'D54600': 'grenadier',
  'D58A37': 'caramelise',
  'D591A4': 'can-can',
  'D59A6F': 'whiskey',
  'D5A129': 'mustard-musketeers',
  'D5A193': 'indian-mesa',
  'D5A1A9': 'young-at-heart',
  'D5BC26': 'indian-pale-ale',
  'D5C7E8': 'foggy-love',
  'D5CE69': 'force-of-nature',
  'D5D195': 'winter-hazel',
  'D5D2C7': 'soy-milk',
  'D5D2D1': 'day-on-mercury',
  'D5D5CE': 'kefir',
  'D5D7BF': 'medlar',
  'D5E4EC': 'ethereal-moonlight',
  'D5F6E3': 'granny-apple',
  'D6201A': 'tomato-burst',
  'D65282': 'mystic',
  'D65E93': 'flirty-rose',
  'D66352': 'track-and-field',
  'D68755': 'copperhead',
  'D68A59': 'raw-sienna',
  'D69188': 'my-pink',
  'D6A332': 'curry',
  'D6B63D': 'oldies-but-goldies',
  'D6B956': 'gold-vein',
  'D6BE01': 'groovy-lemon-pie',
  'D6C562': 'tacha',
  'D6C6B4': 'cafe-latte',
  'D6CADD': 'languid-lavender',
  'D6CEF6': 'moon-raker',
  'D6D1DC': 'iron-maiden',
  'D6D6D1': 'quill-gray',
  'D6E3E7': 'bare-mintimum',
  'D6E5EA': 'dreamstress',
  'D6E9E6': 'whispery-breeze',
  'D6EAFC': 'cloudless',
  'D6FFDB': 'snowy-mint',
  'D6FFFA': 'ice',
  'D70141': 'jokers-smile',
  'D70200': 'red-republic',
  'D70A53': 'debian-red',
  'D71868': 'dogwood-rose',
  'D73B3E': 'jasper',
  'D74894': 'pantone-pink',
  'D75969': 'dragon-fruit',
  'D75E6C': 'berrylicious',
  'D7837F': 'new-york-pink',
  'D78E48': 'golden-nugget',
  'D7BB80': 'honeymoon',
  'D7C498': 'pavlova',
  'D7D0FF': 'fog',
  'D7D8D9': 'gliding-feather',
  'D7D9D5': 'quiet-dew',
  'D7E5D8': 'whispering-frost',
  'D7ECD9': 'silky-mint',
  'D7FEFE': 'salt-mountain',
  'D82029': 'angry-tomato',
  'D82C0D': 'dazzling-red',
  'D84437': 'valencia',
  'D85DA1': 'sugar-rush',
  'D87C3B': 'sweet-potato',
  'D87C63': 'japonica',
  'D8877A': 'island-coral',
  'D891EF': 'bright-lilac',
  'D8948B': 'powder-blush',
  'D89F66': 'kombucha',
  'D8A1C4': 'pastel-lavender',
  'D8A48F': 'apricotta',
  'D8B2D1': 'pink-lavender',
  'D8BFD8': 'thistle',
  'D8C2D5': 'maverick',
  'D8CAA9': 'fiji-sands',
  'D8CFB6': 'berber',
  'D8CFBA': 'warm-oats',
  'D8D4D7': 'so-fresh-so-clean',
  'D8D7D9': 'desired-dawn',
  'D8D8D4': 'whispering-smoke',
  'D8DBE1': 'grain-of-salt',
  'D8DCD6': 'light-grey',
  'D8E4E7': 'inuit-blue',
  'D8EEE7': 'light-spirited',
  'D8F19C': 'creamy-avocado',
  'D8F1F4': 'let-it-snow',
  'D8FCFA': 'foam',
  'D8FFF3': 'candied-snow',
  'D9004C': 'ua-red',
  'D90B0B': 'redsurrection',
  'D91E3F': 'lollipop',
  'D92FB4': 'loudicious-pink',
  'D9381E': 'vermilion',
  'D94972': 'cabaret',
  'D9603B': 'medium-vermilion',
  'D97D8F': 'i-love-you-pink',
  'D983BD': 'pink-punk',
  'D98586': 'peaches-of-immortality',
  'D98695': 'shimmering-blush',
  'D99058': 'persian-orange',
  'D99290': 'juicy-peach',
  'D99376': 'burning-sand',
  'D9AD7F': 'caramel-drizzle',
  'D9AE86': 'porcini',
  'D9B1AA': 'borlotti-bean',
  'D9B1D6': 'blushing-sky',
  'D9B99B': 'cameo',
  'D9C948': 'lanky-lemon',
  'D9CFBE': 'buff-it',
  'D9D2CD': 'smoked-oyster',
  'D9D6CF': 'timid-white',
  'D9DCC1': 'tana',
  'D9DDCB': 'smell-of-garlic',
  'D9E4F5': 'link-water',
  'D9E6A6': 'mermaid-tears',
  'D9E6E8': 'smoke-and-mirrors',
  'D9E7E3': 'icelandic-winter',
  'D9EAE5': 'tropical-dream',
  'D9F7FF': 'mabel',
  'DA1D38': 'incubation-red',
  'DA1D81': 'vivid-cerise',
  'DA244B': 'cosmic-red',
  'DA2811': 'run-lola-run',
  'DA2C43': 'rusty-red',
  'DA321C': 'fatal-fury',
  'DA3287': 'deep-cerise',
  'DA5265': 'cranberry-splash',
  'DA5B38': 'flame-pea',
  'DA614E': 'jelly-bean',
  'DA6304': 'bamboo',
  'DA6A41': 'red-damask',
  'DA70D6': 'orchid',
  'DA8704': 'fleur-de-sel-caramel',
  'DA8A67': 'pale-copper',
  'DA9100': 'harvest-gold',
  'DAA520': 'goldenrod',
  'DAAFD1': 'violet-vamp',
  'DAB4CC': 'purple-poodle',
  'DABE82': 'vermicelles',
  'DAC9B9': 'tapioca',
  'DACAC0': 'coconut-macaroon',
  'DACD81': 'hay-day',
  'DAD0BB': 'bell-tower',
  'DAD7C8': 'fennec-fox',
  'DAD9CE': 'feather',
  'DADAD1': 'alaska',
  'DADBE1': 'big-fish-to-fry',
  'DADBE2': 'muffled-white',
  'DADDC3': 'planet-earth',
  'DADEB5': 'april-showers',
  'DAE3E7': 'cityscape',
  'DAE6E9': 'airy',
  'DAEAF6': 'celestial-cathedral',
  'DAECD6': 'zanah',
  'DAEEE6': 'shattered-ice',
  'DAFAFF': 'oyster-bay',
  'DB1459': 'rubylicious',
  'DB1D27': 'red-hot-chili-pepper',
  'DB2217': 'snake-fruit',
  'DB304A': 'anarchist',
  'DB3C02': 'flame-of-prometheus',
  'DB5079': 'cranberry',
  'DB7093': 'pale-red-violet',
  'DB783E': 'holy-cannoli',
  'DB95AB': 'foxy-pink',
  'DB9690': 'petite-orchid',
  'DB995E': 'di-serria',
  'DBA637': 'sunny-disposition',
  'DBB40C': 'gold-tooth',
  'DBB881': 'honey-bunny',
  'DBBC4B': 'buried-gold',
  'DBC364': 'crusade-king',
  'DBD0CA': 'mushroom-risotto',
  'DBD186': 'treasury',
  'DBD7D0': 'catacomb-walls',
  'DBD7D2': 'timberwolf',
  'DBD8DA': 'urban-snowfall',
  'DBDBDB': 'alto',
  'DBE0C4': 'airy-fields',
  'DBE0E1': 'drifting-cloud',
  'DBE7E1': 'porcelain-mint',
  'DBE7E3': 'homoeopathic-blue',
  'DBE9DF': 'clair-de-lune',
  'DBE9F4': 'azureish-white',
  'DBFFF8': 'frosted-mint',
  'DBFFFE': 'cold-canada',
  'DC143C': 'crimson',
  'DC331A': 'kiss-of-the-scorpion',
  'DC4333': 'punch',
  'DC5226': 'langoustine',
  'DC571D': 'war-paint-red',
  'DC5D47': 'pimento',
  'DC7B7C': 'babe',
  'DC8E31': 'soft-pumpkin',
  'DC9367': 'summers-end',
  'DC9B68': 'coyote',
  'DCB20C': 'galliano',
  'DCB4BC': 'blossom',
  'DCC61F': 'paella',
  'DCC6D2': 'light-lilac',
  'DCD0FF': 'pale-lavender',
  'DCD5C8': 'polished-limestone',
  'DCD747': 'wattle',
  'DCD7CC': 'athena',
  'DCD7CD': 'skyvory',
  'DCD9D2': 'westar',
  'DCD9DB': 'salt-n-pepa',
  'DCDCDC': 'gainsboro',
  'DCDD65': 'succulent-lime',
  'DCDDCC': 'moon-mist',
  'DCE0CD': 'gentle-frost',
  'DCE3E4': 'serene',
  'DCE7CB': 'breath-of-celery',
  'DCEDB4': 'caper',
  'DCF0EA': 'swans-down',
  'DCF1C7': 'green-glint',
  'DD0000': 'red-pegasus',
  'DD0022': 'untamed-red',
  'DD0055': 'anger',
  'DD0066': 'magna-cum-laude',
  'DD0077': 'vampire-love-story',
  'DD00EE': 'piercing-pink',
  'DD0D06': 'passion-for-revenge',
  'DD1111': 'stoplight',
  'DD1122': 'piercing-red',
  'DD1133': 'rare-red',
  'DD1144': 'red-herring',
  'DD1188': 'benevolent-pink',
  'DD11DD': 'drunk-tank-pink',
  'DD11FF': 'pinkman',
  'DD14AB': 'aphroditean-fuchsia',
  'DD180E': 'hot-flamin-chilli',
  'DD2211': 'halloween-punch',
  'DD2222': 'chicken-comb',
  'DD2233': 'red-handed',
  'DD22AA': 'melodramatic-magenta',
  'DD22FF': 'cotton-candy-explosions',
  'DD3322': 'devilish',
  'DD33FF': 'epink',
  'DD3744': 'serial-kisses',
  'DD3845': 'poppy-red',
  'DD4124': 'furnace',
  'DD4132': 'vampire-red',
  'DD4422': 'tomato-queen',
  'DD4433': 'matt-demon',
  'DD4444': 'cute-crab',
  'DD5533': 'frozen-tomato',
  'DD5577': 'fever-dream',
  'DD55FF': 'flaming-flamingo',
  'DD6633': 'bronzed',
  'DD6677': 'feverish',
  'DD8844': 'touch-of-glamour',
  'DD8869': 'canyon-sunset',
  'DD9922': 'tiger-king',
  'DD9933': 'lion-king',
  'DD99AA': 'blush-bomb',
  'DDA0DD': 'pale-plum',
  'DDAA11': 'honeycomb',
  'DDAA33': 'currywurst',
  'DDAA55': 'old-whiskey',
  'DDAA88': 'lunatic-lynx',
  'DDAAFF': 'testosterose',
  'DDADAF': 'pale-chestnut',
  'DDBB33': 'wax',
  'DDC283': 'sunspill',
  'DDC75B': 'duck-butter',
  'DDCA69': 'pirate-treasure',
  'DDCC88': 'master-key',
  'DDCC99': 'desert-temple',
  'DDCDA6': 'ancestral-gold',
  'DDCFB9': 'cream-and-sugar',
  'DDCFBC': 'malt',
  'DDD3AE': 'stardust',
  'DDD6D5': 'swiss-coffee',
  'DDDD88': 'garlic-toast',
  'DDDDDD': 'steam',
  'DDDFE8': 'delicate-cloud',
  'DDE26A': 'booger-buster',
  'DDE2E6': 'bright-star',
  'DDE3D5': 'water-lily',
  'DDE3E7': 'wind-blown',
  'DDE3E8': 'snow-blanket',
  'DDECE0': 'cryo-freeze',
  'DDEDBD': 'mellow-mint',
  'DDEEDD': 'vanishing-point',
  'DDF9F1': 'white-ice',
  'DDFF00': 'lime-zest',
  'DDFFAA': 'lime-mist',
  'DDFFCC': 'herbal-vapours',
  'DE0170': 'magenta-elephant',
  'DE3163': 'cerise',
  'DE4D7B': 'feverish-passion',
  'DE5285': 'fandango-pink',
  'DE5346': 'blossoming-dynasty',
  'DE5D83': 'blush',
  'DE6360': 'roman',
  'DE6646': 'jelly-slug',
  'DE6B86': 'kiss-me-more',
  'DE6FA1': 'thulian-pink',
  'DE9930': 'kingpin-gold',
  'DEA392': 'shy-champagne-blush',
  'DEA5A4': 'pastel-pink',
  'DEAA88': 'tumbleweed',
  'DEAB9B': 'sun-kissed-beach',
  'DEAD00': 'mortal-yellow',
  'DEAD11': 'deadly-mustard',
  'DEB4C5': 'mental-floss',
  'DEB887': 'burlywood',
  'DEBA13': 'gold-tips',
  'DEBCCD': 'creamy-berry',
  'DEBEEF': 'beefy-pink',
  'DEC196': 'brandy',
  'DEC6D3': 'matt-lilac',
  'DECADE': 'decadial-pink',
  'DECBC6': 'wafer',
  'DECCAF': 'tatami',
  'DED4A4': 'sapling',
  'DED5C7': 'sh-ji',
  'DED717': 'barberry',
  'DED8DC': 'pebble-beach',
  'DEDACD': 'oat-milk',
  'DEDBCC': 'cocoon',
  'DEDDDD': 'silver-lake',
  'DEDEDE': 'kingly-cloud',
  'DEDEE5': 'white-elephant',
  'DEDFC9': 'sip-of-mint',
  'DEE2C7': 'marble-grape',
  'DEE5C0': 'beryl-green',
  'DEE6EC': 'white-frost',
  'DEE9F4': 'freeze-up',
  'DEECE1': 'pastel-smirk',
  'DEECED': 'winters-breath',
  'DEEEED': 'free-spirit',
  'DEF5FF': 'pattens-blue',
  'DF00FF': 'psychedelic-purple',
  'DF3163': 'intense-passion',
  'DF3F32': 'bacon-strips',
  'DF6124': 'vivid-red-tangelo',
  'DF73FF': 'heliotrope',
  'DF9D5B': 'coffee-whip',
  'DF9F8F': 'pink-palazzo',
  'DFAC4C': 'brass-buttons',
  'DFAD51': 'cheese-wiz',
  'DFB1B6': 'sakura',
  'DFB8BC': 'shy-young-salmon',
  'DFBE6F': 'apache',
  'DFC5FE': 'neon-boneyard',
  'DFC6AA': 'larb-gai',
  'DFCBCF': 'mega-metal-mecha',
  'DFCD6F': 'chenin',
  'DFCDB2': 'pretty-pastry',
  'DFCDC7': 'lip-gloss',
  'DFCFCA': 'watermelon-milk',
  'DFCFDB': 'lola',
  'DFD2CA': 'mocha-ice',
  'DFD4C4': 'wheat-sheaf',
  'DFD8E1': 'pastel-day',
  'DFD9DA': 'frozen-mammoth',
  'DFDFDA': 'white-bullet',
  'DFDFE5': 'festive-ferret',
  'DFE0E2': 'wind-chime',
  'DFE289': 'sassy-lime',
  'DFE9E3': 'frosty-pink',
  'DFECDA': 'willow-brook',
  'DFECE9': 'second-wind',
  'DFEDDA': 'ghost-lichen',
  'DFF1D6': 'hint-of-mint',
  'DFFF00': 'chartreuse',
  'DFFF4F': 'tennis-ball',
  'E0115F': 'ruby',
  'E0180C': 'red-wrath-of-zeus',
  'E0218A': 'barbie-pink',
  'E02E82': 'mystic-magenta',
  'E03C31': 'cg-red',
  'E0413A': 'blood-of-my-enemies',
  'E06F8B': 'raspberry-mousse',
  'E08D3C': 'tigers-eye',
  'E09B81': 'blushing-rose',
  'E0ADC4': 'roseate-spoonbill',
  'E0B0FF': 'mauve',
  'E0B4A4': 'prosciutto',
  'E0B646': 'anzac',
  'E0B8C0': 'grandmas-pink-tiles',
  'E0BB95': 'lama',
  'E0C095': 'calico',
  'E0C5A1': 'fortune-cookie',
  'E0C778': 'protoss',
  'E0C84B': 'golden-kingdom',
  'E0D1A0': 'woven',
  'E0D2A9': 'gratin-dauphinois',
  'E0DAC8': 'peace-and-quiet',
  'E0E1D1': 'wild-wheat',
  'E0E6F0': 'radiant-moon',
  'E0FFFF': 'light-cyan',
  'E10646': 'cherry-velvet',
  'E10D18': 'tomato-baby',
  'E12C2C': 'permanent-geranium-lake',
  'E1583F': 'tiger-lily',
  'E15ACB': 'barbiecore',
  'E16233': 'precious-pumpkin',
  'E16865': 'sunglo',
  'E18289': 'pulp',
  'E18E96': 'ruddy-pink',
  'E1A95F': 'earth-yellow',
  'E1AD21': 'urobilin',
  'E1B67C': 'honey-gold',
  'E1BC64': 'equator',
  'E1C0C8': 'pink-flare',
  'E1C12F': 'finger-banana',
  'E1C9D1': 'sweet-and-sassy',
  'E1CCAF': 'macadamia',
  'E1CEAD': 'boutique-beige',
  'E1D2D5': 'secret-blush',
  'E1D9B8': 'sesame-seed',
  'E1DACB': 'albescent',
  'E1DACE': 'noble-cream',
  'E1DDBF': 'silver-fern',
  'E1DDCD': 'cappuccino-cosmico',
  'E1DED9': 'closet-skeletons',
  'E1DEDA': 'prelude-to-pink',
  'E1DF9A': 'celery-sceptre',
  'E1DFE1': 'chrome',
  'E1E0EB': 'homoeopathic-lilac',
  'E1E1D5': 'fish-ceviche',
  'E1E1E2': 'jupiter',
  'E1E3D7': 'washed-dollar',
  'E1E5E5': 'shaving-cream',
  'E1E6D6': 'periglacial-blue',
  'E1EAD4': 'kidnapper',
  'E1EBD8': 'homoeopathic-green',
  'E1EFDD': 'distant-landscape',
  'E1F2F0': 'bone-chilling',
  'E1F5E5': 'frozen-civilization',
  'E1F6E8': 'tara',
  'E1F8E7': 'toxic-latte',
  'E1FE52': 'green-ooze',
  'E2062C': 'medium-candy-apple-red',
  'E2261F': 'ferocious',
  'E23D2A': 'electric-blood',
  'E24736': 'sour-cherry',
  'E25098': 'raspberry-pink',
  'E25465': 'mandy',
  'E25822': 'flame',
  'E25D1B': 'ferocious-fox',
  'E25E31': 'salametti',
  'E2725B': 'terra-cotta',
  'E28913': 'golden-bell',
  'E292C0': 'shocking',
  'E29418': 'dixie',
  'E2958D': 'strawberry-memory',
  'E29A86': 'shrimp',
  'E2B31B': 'golden-frame',
  'E2B5BD': 'hearts-content',
  'E2BD67': 'crisps',
  'E2BEB4': 'muddy-rose',
  'E2C392': 'halo',
  'E2C779': 'waffle-cone',
  'E2C9CE': 'perfume-cloud',
  'E2CA73': 'dijon-mustard',
  'E2CA76': 'sand',
  'E2CC9C': 'prairie-land',
  'E2D7C1': 'garlic-clove',
  'E2D8C3': 'exclusive-ivory',
  'E2D8ED': 'snuff',
  'E2D9DB': 'forgotten-mosque',
  'E2DCAB': 'virgin-olive-oil',
  'E2DCD7': 'marble-quarry',
  'E2E0DC': 'ghosted',
  'E2EFF3': 'diamond-white',
  'E3000E': 'heat-signature',
  'E30022': 'cadmium-red',
  'E30B5D': 'raspberry',
  'E31B5D': 'radiant-raspberry',
  'E3256B': 'razzmatazz',
  'E32636': 'alizarin-crimson',
  'E34234': 'cinnabar',
  'E35519': 'furious-fox',
  'E35F66': 'lovely-little-rosy',
  'E3664C': 'heirloom-blush',
  'E38FAC': 'pomelo-red',
  'E398AF': 'passion-potion',
  'E39B96': 'she-loves-pink',
  'E3A857': 'indian-yellow',
  'E3AB57': 'sunray',
  'E3ABCE': 'pink-bliss',
  'E3AF64': 'caramel-essence',
  'E3B258': 'cookie-crust',
  'E3B982': 'cane-sugar',
  'E3BCBC': 'soft-blush',
  'E3BEBE': 'cavern-pink',
  'E3C19C': 'tostada',
  'E3C81C': 'oh-em-ghee',
  'E3CBA8': 'gourmet-honey',
  'E3CDC2': 'humble-blush',
  'E3D1CC': 'china-silk',
  'E3D3BF': 'oyster',
  'E3DAC9': 'bone',
  'E3DBCD': 'last-straw',
  'E3DCD6': 'grim-grey',
  'E3DDCC': 'fossil-stone',
  'E3DFEC': 'velvet-scarf',
  'E3F5E1': 'peppermint',
  'E3F988': 'mindaro',
  'E3FF00': 'lemon-lime',
  'E4000F': 'mario',
  'E40058': 'framboise',
  'E40078': 'red-purple',
  'E4007C': 'mexican-pink',
  'E4030F': 'miyamoto-red',
  'E42B73': 'watermelon-sugar',
  'E44E4D': 'red-arremer',
  'E4658E': 'love-letter',
  'E46B71': 'redstone',
  'E46F34': 'lava-pit',
  'E4717A': 'tango-pink',
  'E47698': 'deep-blush',
  'E48400': 'fulvous',
  'E49B0F': 'gamboge',
  'E4B3CC': 'muddy-mauve',
  'E4C2D5': 'melanie',
  'E4C36C': 'bountiful-gold',
  'E4CB6B': 'le-bon-dijon',
  'E4CF99': 'honeycomb-glow',
  'E4CFD7': 'ephemeral-red',
  'E4CFDE': 'twilight',
  'E4D00A': 'citrine',
  'E4D422': 'sunflower',
  'E4D4BE': 'bread-crumb',
  'E4D5B7': 'grain-brown',
  'E4D69B': 'zombie',
  'E4D96F': 'straw',
  'E4D9C5': 'fish-bone',
  'E4DCC9': 'coco-malt',
  'E4E5D8': 'olive-conquering-white',
  'E4F3E0': 'mojito',
  'E4F6E7': 'frostee',
  'E4FFD1': 'snow-flurry',
  'E50000': 'lifeguard',
  'E50752': 'howling-pink',
  'E51A4C': 'spanish-crimson',
  'E52B50': 'amaranth',
  'E56024': 'vivid-vermilion',
  'E5717B': 'turnip-the-pink',
  'E5750F': 'martian-colony',
  'E5841B': 'zest',
  'E58787': 'boho-blush',
  'E59D7B': 'les-demoiselles-davignon',
  'E5A5C1': 'think-pink',
  'E5AA70': 'fawn',
  'E5B03D': 'quercitron',
  'E5B3B2': 'perfect-pink',
  'E5B73B': 'meat-brown',
  'E5BDDF': 'blackberry-yoghurt',
  'E5C1A3': 'fabulous-fawn',
  'E5CAA4': 'caramel-mousse',
  'E5CC69': 'sulphur-pit',
  'E5CCC9': 'dust-storm',
  'E5D3B9': 'almond-brittle',
  'E5D3CC': 'bridal-scent',
  'E5D5AE': 'anise-biscotti',
  'E5D7BD': 'stark-white',
  'E5D8AF': 'hampton',
  'E5DAE1': 'violet-vapour',
  'E5E0D5': 'hourglass',
  'E5E0E1': 'bon-jour',
  'E5E0EC': 'homoeopathic-lavender',
  'E5E2E1': 'diamonds-in-the-sky',
  'E5E4DD': 'swan-dive',
  'E5E4E2': 'platinum',
  'E5E5E1': 'apollo-landing',
  'E5E5E5': 'mercury',
  'E5E7E4': 'whale-bone',
  'E5EAD8': 'homoeopathic-mint',
  'E5EAE6': 'distant-cloud',
  'E5EBE6': 'lightning-bolt',
  'E5EDB5': 'sour',
  'E5EDF1': 'morning-mist',
  'E5F0D9': 'maison-verte',
  'E5F9F6': 'polar',
  'E60026': 'spanish-red',
  'E6390D': 'vulcan-fire',
  'E63E62': 'paradise-pink',
  'E6474A': 'x-marks-the-spot',
  'E6490B': 'baptism-by-fire',
  'E64E03': 'trinidad',
  'E66771': 'light-carmine-pink',
  'E66A77': 'old-heart',
  'E6718D': 'loveland',
  'E67A37': 'spiced-up-orange',
  'E67C41': 'solar-flare',
  'E68A00': 'hotter-butter',
  'E68FAC': 'charm-pink',
  'E69D00': 'hot-butter',
  'E69DAD': 'brandywine-spritz',
  'E6A8D7': 'light-orchid',
  'E6AAC1': 'little-princess',
  'E6B0AF': 'chewing-gum',
  'E6BC00': 'fat-gold',
  'E6BCCD': 'pink-mist',
  'E6BE8A': 'pale-gold',
  'E6BEA5': 'cashmere',
  'E6BF95': 'laksa',
  'E6C7A2': 'egghead',
  'E6D0AB': 'durian-white',
  'E6D682': 'gold-winged',
  'E6D7B9': 'double-spanish-white',
  'E6DCCC': 'varnished-ivory',
  'E6DEE6': 'peekaboo',
  'E6DFC4': 'horseradish',
  'E6E200': 'peridot',
  'E6E382': 'yellow-press',
  'E6E4D4': 'satin-linen',
  'E6E4DE': 'party-ice',
  'E6E5D6': 'tofu',
  'E6E6E3': 'pearl-brite',
  'E6E6FA': 'lavender-mist',
  'E6E8FA': 'glitter',
  'E6F2EA': 'harp',
  'E6F8F3': 'off-green',
  'E6FFE9': 'hint-of-green',
  'E6FFFF': 'tranquil',
  'E75480': 'dark-pink',
  'E760D2': 'death-of-a-star',
  'E76178': 'cherry-static',
  'E76682': 'coral-paradise',
  'E7730A': 'christine',
  'E781A6': 'mangala-pink',
  'E79F8C': 'tonys-pink',
  'E79FC4': 'kobi',
  'E7A2AE': 'sprinkled-with-pink',
  'E7ACCF': 'pink-pearl',
  'E7AECD': 'roses-in-the-snow',
  'E7BCB4': 'rose-fog',
  'E7BF05': 'corn',
  'E7C3E7': 'prom-corsage',
  'E7CD8C': 'putty',
  'E7D082': 'ancient-treasure',
  'E7DBBF': 'deserted-beach',
  'E7DCCE': 'crepuscular',
  'E7E04E': 'dragons-gold',
  'E7E3DB': 'foggy-day',
  'E7E5DE': 'puffy-pillow',
  'E7E6DE': 'morning-bread',
  'E7E7E7': 'placebo',
  'E7ECE6': 'gray-nurse',
  'E7EFE0': 'mount-eden',
  'E7EFFB': 'cotton-boll',
  'E7F8FF': 'lily-white',
  'E7FAFA': 'calm-waters',
  'E7FEFF': 'bubbles',
  'E8000D': 'ku-crimson',
  'E81320': 'silken-ruby',
  'E83A72': 'fantasy-romance',
  'E84998': 'schiaparelli-pink',
  'E86100': 'spanish-orange',
  'E87175': 'pastrami',
  'E88E5A': 'big-foot-feet',
  'E8957A': 'dark-salmon-injustice',
  'E89928': 'fire-bush',
  'E89BC7': 'sultan-of-pink',
  'E8A7E2': 'candy-floss',
  'E8B447': 'honey-glow',
  'E8B523': 'deli-yellow',
  'E8B5CE': 'sweet-lilac',
  'E8B9B3': 'shilo',
  'E8C2B4': 'mellow-marrow',
  'E8C690': 'molten-gold',
  'E8CCD7': 'queen-pink',
  'E8CE49': 'golden-relic',
  'E8CFB1': 'sugar-cookie-crust',
  'E8D284': 'paved-with-gold',
  'E8D6B3': 'champagne-gold',
  'E8D720': 'holy-grail',
  'E8D82C': 'banana-brick',
  'E8D99C': 'sunny-glory',
  'E8DBBD': 'biscuit-dough',
  'E8DBDD': 'homoeopathic-rose',
  'E8DDC6': 'heavy-cream',
  'E8DFED': 'pink-champagne',
  'E8E0D5': 'pearl-bush',
  'E8E0E9': 'bubble-bath',
  'E8E5DE': 'snowed-in',
  'E8E6D9': 'prairie-winds',
  'E8E9E4': 'pegasus',
  'E8EBE0': 'green-white',
  'E8EFF8': 'first-snow',
  'E8F1D4': 'chrome-white',
  'E8F2EB': 'gin',
  'E8F48C': 'key-lime',
  'E8F5F2': 'aqua-squeeze',
  'E9023A': 'neon-romance',
  'E936A7': 'frostbite',
  'E93A0E': 'chilli-crab',
  'E94E41': 'blazing',
  'E95C4B': 'opal-flame',
  'E95E2A': 'sunset-blaze',
  'E9692C': 'deep-carrot-orange',
  'E96D03': 'ochre-spice',
  'E96E00': 'clementine',
  'E97451': 'burnt-sienna',
  'E97C07': 'tahiti-gold',
  'E9967A': 'dark-salmon',
  'E99E56': 'pumpkin-pie',
  'E9A1B8': 'rose-elegance',
  'E9AEF2': 'candy-dreams',
  'E9B413': 'trumpet-gold',
  'E9C160': 'honey-crisp',
  'E9C180': 'freshly-baked',
  'E9C4CC': 'light-blush',
  'E9C89B': 'golden-talisman',
  'E9CECD': 'oyster-pink',
  'E9D66B': 'arylide-yellow',
  'E9D6BD': 'writers-parchment',
  'E9D75A': 'confetti',
  'E9D8C2': 'floating-feather',
  'E9E0D4': 'mountain-peak',
  'E9E1DF': 'milk-and-cookies',
  'E9E1E8': 'violet-vogue',
  'E9E3CB': 'nylon',
  'E9E3E3': 'ebb',
  'E9E9F0': 'diamond-cut',
  'E9F6E2': 'homoeopathic-lime',
  'E9F8ED': 'ottoman',
  'E9F9F5': 'melting-glacier',
  'E9FFDB': 'nyanza',
  'E9FFFD': 'clear-day',
  'EA1822': 'blood-donor',
  'EA1833': 'transfusion',
  'EA3C53': 'desire',
  'EA5013': 'crunchy-carrot',
  'EA5814': 'furious-tiger',
  'EA6777': 'sun-kissed-coral',
  'EA88A8': 'carissma',
  'EA8A7A': 'redolenc',
  'EA9073': 'warm-welcome',
  'EAA221': 'marigold',
  'EAA601': 'illuminate-me',
  'EAACC6': 'pink-macaroon',
  'EAAE69': 'porsche',
  'EAB33B': 'tulip-tree',
  'EAB7A8': 'plushy-pink',
  'EABCC0': 'blush-kiss',
  'EAC674': 'rob-roy',
  'EAC853': 'yellow-brick-road',
  'EACACB': 'petite-pink',
  'EAD151': 'new-gold',
  'EAD665': 'kings-yellow',
  'EAD765': 'pharaohs-gold',
  'EAD771': 'golden-glitter-storm',
  'EAD97C': 'celestial-crown',
  'EAD988': 'pineapple-whip',
  'EADAB8': 'raffia',
  'EADAC6': 'oatmeal-cookie',
  'EADBCA': 'whisper-of-white',
  'EADFCE': 'dry-bone',
  'EAE0C8': 'pearl',
  'EAE3E0': 'disappearing-memories',
  'EAE583': 'hippy',
  'EAE5D8': 'helium',
  'EAE6D7': 'little-lamb',
  'EAE8D4': 'white-rock',
  'EAE9B4': 'steamy-dumpling',
  'EAE9E0': 'polar-bear',
  'EAE9E7': 'glacial-ice',
  'EAEADB': 'magical-stardust',
  'EAEAEA': 'plaster',
  'EAEDE5': 'silence',
  'EAEED8': 'blissful-serenity',
  'EAEEDA': 'bethlehem-superstar',
  'EAEFF2': 'distant-wind-chime',
  'EAF2F1': 'warp-drive',
  'EAF5E7': 'floaty-bubble',
  'EAF6EE': 'panache',
  'EAF6FF': 'solitude',
  'EAF9F5': 'aqua-spring',
  'EAFFFE': 'dew',
  'EB4652': 'watermelonade',
  'EB4C42': 'carmine-pink',
  'EB7B07': 'pumpkin-cat',
  'EB84F5': 'pinkling',
  'EB94DA': 'love-dust',
  'EB9A9D': 'pink-floyd',
  'EB9F9F': 'cosy-summer-sunset',
  'EBB9AF': 'salmon-glow',
  'EBBEB5': 'rosewood-dreams',
  'EBC263': 'french-fry',
  'EBC2AF': 'zinnwaldite',
  'EBC9C6': 'fairy-floss',
  'EBCD95': 'sunlight',
  'EBD147': 'aurora',
  'EBD5CA': 'blushing-coconut',
  'EBD999': 'ivory-buff',
  'EBDBC1': 'clam-up',
  'EBDBDD': 'discrete-pink',
  'EBDECC': 'skeleton',
  'EBE2CF': 'muscat-blanc',
  'EBE3DE': 'bookworm',
  'EBE5D0': 'cauliflower',
  'EBE5D7': 'sugar-quill',
  'EBE8E7': 'coconut-agony',
  'EBEADC': 'salted',
  'EBEAE5': 'blanco',
  'EBEB57': 'pineapple-high',
  'EBEBE9': 'mystic-white',
  'EBECF5': 'silver-phoenix',
  'EC0003': 'alarm',
  'EC006C': 'hyper-pink',
  'EC3B83': 'cerise-pink',
  'EC4872': 'radishical',
  'EC4F28': 'hot-shot',
  'EC5800': 'persimmon',
  'EC834F': 'gravlax',
  'EC842F': 'bourbon-peach',
  'EC9079': 'lox',
  'EC9F76': 'mexican-standoff',
  'ECA6CA': 'elastic-pink',
  'ECA927': 'fuel-yellow',
  'ECAB3F': 'yakitori',
  'ECAE58': 'shiny-trumpet',
  'ECB2B3': 'deeply-embarrassed',
  'ECC54E': 'ronchi',
  'ECC5C0': 'rose-haze',
  'ECCDB9': 'just-right',
  'ECCEE5': 'sweet-dreams',
  'ECD540': 'sandstorm',
  'ECDACD': 'nectar',
  'ECDBE0': 'homoeopathic-red',
  'ECDDC9': 'silk-for-the-gods',
  'ECE086': 'gold-grillz',
  'ECE090': 'wild-rice',
  'ECE0D6': 'dallas-dust',
  'ECE2B7': 'buttered',
  'ECE6D4': 'mascarpone',
  'ECEABE': 'white-asparagus',
  'ECEBBD': 'pale-spring-bud',
  'ECEBCE': 'aths-special',
  'ECEBE5': 'gin-tonic',
  'ECEFE3': 'creamy-garlic',
  'ECF245': 'starship',
  'ECF3E1': 'white-mecca',
  'ECF474': 'nuclear-acid',
  'ED0A3F': 'red-ribbon',
  'ED1C24': 'pigment-red',
  'ED214D': 'che-guevara-red',
  'ED24ED': 'magenta-fizz',
  'ED292B': 'naga-viper-pepper',
  'ED2939': 'imperial-red',
  'ED2C1A': 'dont-be-shy',
  'ED4B00': 'kimchi',
  'ED7A1C': 'tango',
  'ED8666': 'peachy-feeling',
  'ED872D': 'cadmium-orange',
  'ED8A09': 'elden-ring-orange',
  'ED8A53': 'toasted-husk',
  'ED9121': 'carrot-orange',
  'ED989E': 'sea-pink',
  'EDABE6': 'land-of-dreams',
  'EDAC36': 'tonkatsu',
  'EDB2C4': 'fallen-blossoms',
  'EDB381': 'tacao',
  'EDC2DB': 'starlet-pink',
  'EDC3C5': 'berry-good',
  'EDC5D7': 'tussie-mussie',
  'EDC9AF': 'desert-sand',
  'EDCCB3': 'cashew-nut',
  'EDCD62': 'grand-casino-gold',
  'EDCDAB': 'pancho',
  'EDD8D2': 'fiesta',
  'EDD924': 'spectacular-saffron',
  'EDDBC8': 'patisserie',
  'EDDBDA': 'hyper-light-drifter',
  'EDDCB1': 'chamois',
  'EDDEE6': 'antarctic-love',
  'EDDF5E': 'garlic-butter',
  'EDE0D5': 'delicate-bliss',
  'EDE1BE': 'beurre-blanc',
  'EDE1D1': 'white-pearl',
  'EDE7D7': 'homoeopathic-yellow',
  'EDE8DD': 'yang-mist',
  'EDE9EF': 'greek-goddess',
  'EDEA99': 'primrose',
  'EDEBE1': 'sauna-steam',
  'EDECDB': 'cannoli-cream',
  'EDEDC7': 'honey-do',
  'EDEDE4': 'ivory-wedding',
  'EDF5DD': 'frost',
  'EDF5F5': 'aqua-haze',
  'EDF6DB': 'futon',
  'EDF6FF': 'zumthor',
  'EDF9F1': 'narvik',
  'EDFC84': 'honeysuckle',
  'EDFCFB': 'cold-white',
  'EE0000': 'mvs-red',
  'EE0011': 'breath-of-fire',
  'EE0044': 'enraged',
  'EE0077': 'fatty-fuchsia',
  'EE0088': 'feasty-fuchsia',
  'EE0099': 'love-vessel',
  'EE00CC': 'ferocious-flamingo',
  'EE00DD': 'vice-city',
  'EE1144': 'pickled-radish',
  'EE1166': 'borderline-pink',
  'EE1177': 'jelly-berry',
  'EE1188': 'fabulous-fuchsia',
  'EE1199': 'fanatic-fuchsia',
  'EE204D': 'crayola-red',
  'EE2222': 'ottoman-red',
  'EE2244': 'charismatic-red',
  'EE2266': 'mellow-melon',
  'EE2277': 'furious-fuchsia',
  'EE22AA': 'magnificent-magenta',
  'EE3311': 'arcade-fire',
  'EE3344': 'red-radish',
  'EE3366': 'bats-blood-soup',
  'EE3377': 'amor',
  'EE4328': 'heavy-orange',
  'EE4400': 'glowing-meteor',
  'EE4433': 'cascara',
  'EE4488': 'majestic-magenta',
  'EE4D83': 'hindu-lotus',
  'EE5500': 'cigarette-glow',
  'EE5511': 'orangealicious',
  'EE5577': 'lick-and-kiss',
  'EE6611': 'honey-teriyaki',
  'EE6633': 'flaming-orange',
  'EE6655': 'flattered-flamingo',
  'EE6666': 'coral-commander',
  'EE6688': 'jellyfish-sting',
  'EE66AA': 'fugitive-flamingo',
  'EE6730': 'basketball',
  'EE7733': 'orange-crush',
  'EE7776': 'youre-blushing',
  'EE7777': 'salmon-pok-bowl',
  'EE7799': 'embarrassed',
  'EE7C54': 'sassy-salmon',
  'EE8170': 'melondrama',
  'EE827C': 'jinza-safflower',
  'EE82EE': 'lavender-magenta',
  'EE8866': 'firewatch',
  'EE8877': 'in-for-a-penny',
  'EE88EE': 'frail-fuchsia',
  'EE9091': 'pink-porky',
  'EE9922': 'burning-trail',
  'EE9933': 'nuclear-mango',
  'EE9999': 'funki-porcini',
  'EE99AA': 'pink-prestige',
  'EE99CC': 'pearly-pink',
  'EE99EE': 'diva-mecha',
  'EE99FF': 'party-pig',
  'EE9A09': 'cheddar',
  'EEAA11': 'groovy-giraffe',
  'EEAA33': 'whisky-sour',
  'EEAA44': 'summer-glow',
  'EEAA55': 'polished-gold',
  'EEAAEE': 'pinky-swear',
  'EEB033': 'cheesy-cheetah',
  'EEBB11': 'goldfinger',
  'EEBB33': 'nicotine-gold',
  'EEBB55': 'oh-my-gold',
  'EEBB66': 'flaming-june',
  'EEBB88': 'baba-ganoush',
  'EEBBBB': 'angry-ghost',
  'EEBBDD': 'rosecco',
  'EEBE1B': 'radiant-sunrise',
  'EEC0D2': 'guava-glow',
  'EEC1BE': 'beauty-bush',
  'EEC378': 'shallot-peel',
  'EEC3EE': 'purples-baby-sister',
  'EEC474': 'pasta-rasta',
  'EEC4B4': 'fatty-sashimi',
  'EEC6BF': 'strawberry-risotto',
  'EEC7A2': 'negroni',
  'EECC22': 'valkyrie',
  'EECC44': 'montezuma-gold',
  'EECC88': 'spaghetti-monster',
  'EECC99': 'hummus',
  'EECCDD': 'la-vibes',
  'EECCEE': 'bubblegum-crisis',
  'EECE8D': 'honeydew-sand',
  'EED202': 'safety-yellow',
  'EED484': 'kaiser-cheese',
  'EED5EE': 'scented-spring',
  'EED683': 'gatsby-glitter',
  'EED794': 'chalky',
  'EED7C1': 'burrito',
  'EEDC82': 'flax',
  'EEDD11': 'yellow-buzzing',
  'EEDD22': 'caduceus-staff',
  'EEDD44': 'orb-of-harmony',
  'EEDD66': 'pollination',
  'EEDD77': 'delicate-lemon',
  'EEDDAA': 'creamy-ivory',
  'EEDEC7': 'golden-retriever',
  'EEDEDA': 'bizarre',
  'EEDF91': 'party-sponge-cake',
  'EEE0B9': 'sauerkraut',
  'EEE0DD': 'powder-room',
  'EEE3AD': 'double-colonial-white',
  'EEE600': 'titanium-yellow',
  'EEE8AA': 'pale-goldenrod',
  'EEE92D': 'pika-yellow',
  'EEE9D9': 'calcium-rock',
  'EEE9DC': 'silk-dessou',
  'EEE9DF': 'palladian',
  'EEEBE2': 'coconut-milk',
  'EEED56': 'sulphuric',
  'EEEDDF': 'onion-skin',
  'EEEE66': 'crash-dummy',
  'EEEE77': 'illuminating',
  'EEEE88': 'pineapple-perfume',
  'EEEEAA': 'pollen',
  'EEEECC': 'silkworm',
  'EEEEE8': 'cararra',
  'EEEEEE': 'super-silver',
  'EEEF78': 'manz',
  'EEEFE2': 'star-magnolia',
  'EEF0C8': 'tahuna-sands',
  'EEF0E7': 'fogtown',
  'EEF0F3': 'athens-gray',
  'EEF3C3': 'tusk',
  'EEF3D0': 'race-the-sun',
  'EEF4DE': 'loafer',
  'EEF6F7': 'catskill-white',
  'EEF7FA': 'silent-snowfall',
  'EEF9C1': 'kiwi-kiss',
  'EEFDFF': 'twilight-blue',
  'EEFE02': 'banana-flash',
  'EEFF00': 'zeuss-bolt',
  'EEFF04': 'sour-yellow',
  'EEFF11': 'high-voltage',
  'EEFF22': 'john-lemon',
  'EEFF33': 'pickled-pineapple',
  'EEFFEE': 'snow-white',
  'EF1DE7': 'pink-pride',
  'EF3038': 'deep-carmine-pink',
  'EF347C': 'extra-fuchsia',
  'EF4F41': 'strawberry-avalanche',
  'EF586C': 'pink-pepper',
  'EF7D16': 'retro-nectarine',
  'EF863F': 'jaffa',
  'EF985C': 'ridgeback',
  'EF98AA': 'mauvelous',
  'EFB435': 'baklava',
  'EFB4CA': 'fairy-tale',
  'EFB6D8': 'soft-cashmere',
  'EFBBCC': 'cameo-pink',
  'EFC47F': 'polenta',
  'EFC488': 'honeyed-glow',
  'EFC872': 'hit-the-hay',
  'EFC87D': 'mille-feuille',
  'EFC9EC': 'sugar-high',
  'EFCC00': 'munsell-yellow',
  'EFCEDC': 'berry-butter',
  'EFCF98': 'sparkling-champagne',
  'EFD100': 'under-the-sun',
  'EFD7AB': 'cereal-flake',
  'EFDAAE': 'vinaigrette',
  'EFDBA7': 'tortilla',
  'EFDBCD': 'white-truffle',
  'EFDDC3': 'jakarta',
  'EFDE74': 'lightning-bug',
  'EFDECD': 'almond',
  'EFDFBB': 'dutch-white',
  'EFE0CD': 'buttercream',
  'EFE1A7': 'french-vanilla',
  'EFE499': 'lemonade',
  'EFE6C1': 'fake-blonde',
  'EFE6D1': 'white-warm-wool',
  'EFE7EB': 'bride',
  'EFE8DB': 'creamy',
  'EFE9E6': 'holy-ghost',
  'EFEBD8': 'warm-white',
  'EFEBE2': 'silky-white',
  'EFECEE': 'sheikh-white',
  'EFEDD8': 'slippery-soap',
  'EFEDE6': 'salt',
  'EFEEFF': 'foundation-white',
  'EFEFE5': 'oyster-island',
  'EFEFEF': 'gallery',
  'EFF0D3': 'giggle',
  'EFF0F0': 'snowflake',
  'EFF2F1': 'beluga',
  'EFF2F3': 'porcelain',
  'F00000': 'helvetia-red',
  'F00B52': 'rock-lobster',
  'F01A4D': 'sanguinary',
  'F04E45': 'angry-flamingo',
  'F0531C': 'fiery-glow',
  'F07427': 'vivid-tangelo',
  'F08080': 'light-coral',
  'F0833A': 'goku-orange',
  'F092D6': 'bubblegum-kisses',
  'F09338': 'furry-lion',
  'F0A0D1': 'violet-kiss',
  'F0A1BF': 'prism-pink',
  'F0B054': 'deep-fried',
  'F0BCBE': 'blush-rush',
  'F0C641': 'buzz',
  'F0CCD9': 'smidgen-of-love',
  'F0D31E': 'yellow-mellow',
  'F0D38F': 'nectar-jackpot',
  'F0D52D': 'golden-dream',
  'F0D9E0': 'dolce-pink',
  'F0DB7D': 'golden-sand',
  'F0DBAA': 'brilliant-gold',
  'F0DBD5': 'porcelain-blush',
  'F0DC82': 'buff',
  'F0DEDC': 'butterfly-kisses',
  'F0E093': 'cheesy-frittata',
  'F0E0DC': 'white-russian',
  'F0E130': 'dandelion',
  'F0E2EC': 'prim',
  'F0E3C7': 'white-chocolate',
  'F0E4D1': 'ancient-scroll',
  'F0E5F5': 'holographic-lavender',
  'F0E68C': 'light-khaki',
  'F0E8D7': 'platinum-blonde',
  'F0E9D1': 'fuzzy-sheep',
  'F0EAD6': 'eggshell',
  'F0EEE4': 'marshmallow',
  'F0EEEB': 'magical-moonlight',
  'F0EEFD': 'selago',
  'F0EEFF': 'titan-white',
  'F0EFED': 'white-glove',
  'F0F8FF': 'alice-blue',
  'F0FCEA': 'feta',
  'F0FFF0': 'honeydew',
  'F0FFFF': 'azure-mist',
  'F16640': 'opulent-orange',
  'F18200': 'gold-drop',
  'F19000': 'shiritoriers-orange',
  'F1903D': 'mandarin-rind',
  'F1919A': 'pick-your-brain',
  'F19BAB': 'wewak',
  'F19CBB': 'amaranth-pink',
  'F1B457': 'golden-hour',
  'F1BF92': 'peachy-kini',
  'F1C3C2': 'channel',
  'F1C7D0': 'oh-so-pink',
  'F1C882': 'butterscotch-cake',
  'F1C9CC': 'salmon-flush',
  'F1CBCD': 'abloom',
  'F1D058': 'sorreno-lemon',
  'F1D548': 'banana-drama',
  'F1D99F': 'pie-crust',
  'F1DAB2': 'precious',
  'F1DCA1': 'hazy-moon',
  'F1E2C4': 'cloud-of-cream',
  'F1E4E1': 'hint-of-pink',
  'F1E788': 'sahara-sand',
  'F1E798': 'first-day-of-summer',
  'F1E8D2': 'imperial-ivory',
  'F1E8D6': 'fusilli',
  'F1E8DC': 'vanilla-sugar',
  'F1E8DF': 'gardenia',
  'F1E9D2': 'parchment',
  'F1E9FF': 'blue-chalk',
  'F1EAE2': 'refer-to-the-stars',
  'F1EBC8': 'natural-light',
  'F1ECE0': 'paper-plane',
  'F1EDE5': 'cows-milk',
  'F1EEC1': 'mint-julep',
  'F1EEE2': 'blanc-cass',
  'F1EEE8': 'cloud-dancer',
  'F1F2DD': 'restful-rain',
  'F1F458': 'buttercup-glow',
  'F1F5DB': 'final-departure',
  'F1F7F2': 'saltpan',
  'F1FFAD': 'tidal',
  'F1FFC8': 'chiffon',
  'F2003C': 'munsell-red',
  'F2013F': 'cherry-tomato',
  'F20769': 'ruby-fire',
  'F23E67': 'munch-on-melon',
  'F246A7': 'major-magenta',
  'F2552A': 'flamingo',
  'F2643A': 'firecracker',
  'F26E54': 'royal-blush',
  'F28500': 'tangerine',
  'F2850D': 'lorange',
  'F2AB46': 'artisans-gold',
  'F2ABE1': 'hanami-pink',
  'F2AD62': 'goldfish',
  'F2B8CA': 'berries-n-cream',
  'F2BDCD': 'orchid-pink',
  'F2C3B2': 'mandys-pink',
  'F2C911': 'egg-toast',
  'F2C975': 'pastel-de-nata',
  'F2CFDC': 'ballerina',
  'F2D6DA': 'summer-crush',
  'F2D9A3': 'double-cream',
  'F2DEA4': 'north-star',
  'F2E0DA': 'fallen-petals',
  'F2E2A4': 'sugar-cookie',
  'F2E3B5': 'james-blonde',
  'F2E4F5': 'minute-mauve',
  'F2E5BF': 'creamy-vanilla',
  'F2E688': 'templars-gold',
  'F2E6E1': 'homoeopathic-orange',
  'F2E887': 'kings-field',
  'F2ECD9': 'labrador',
  'F2EDEC': 'vintage-porcelain',
  'F2F0E6': 'marble-white',
  'F2F0E7': 'whipped-cream',
  'F2F0E8': 'cotton-field',
  'F2F27A': 'sunny',
  'F2F2F2': 'concrete',
  'F2F2F4': 'errigal-white',
  'F2F3F4': 'anti-flash-white',
  'F2F6DB': 'sprig-of-sage',
  'F2F7FD': 'cotton-ball',
  'F34723': 'pomegranate',
  'F37A48': 'mandarin',
  'F38F39': 'spicy-paella',
  'F38FA9': 'vanilla-ice',
  'F3AD16': 'buttercup',
  'F3B68E': 'peach-taffy',
  'F3BC80': 'majestic-dune',
  'F3C090': 'dusty-boots',
  'F3C3D8': 'sweetheart',
  'F3C7B3': 'taco',
  'F3CA6C': 'golden-lion',
  'F3CFB7': 'apricot-freeze',
  'F3D085': 'macaroni',
  'F3D3BF': 'maidens-blush',
  'F3D48B': 'sprouted',
  'F3D69D': 'new-orleans',
  'F3DB00': 'banana-propaganda',
  'F3DD51': 'minions',
  'F3DFB6': 'belgian-waffle',
  'F3DFD7': 'angel-wing',
  'F3E0D8': 'peachy-milk',
  'F3E4B3': 'meringue',
  'F3E5AB': 'vanilla',
  'F3E7BB': 'sidecar',
  'F3E9D9': 'a-smell-of-bakery',
  'F3E9E5': 'dawn-pink',
  'F3E9F7': 'perfume-haze',
  'F3EDCF': 'wheatfield',
  'F3EFCD': 'clotted-cream',
  'F3F0DA': 'washed-canvas',
  'F3F2ED': 'pearl-white',
  'F3F4D9': 'praise-the-sun',
  'F3F4F4': 'lighthouse',
  'F3F4F5': 'chefs-hat',
  'F3FB62': 'canary',
  'F3FBD4': 'orinoco',
  'F3FFD8': 'carla',
  'F400A1': 'fashion-fuchsia',
  'F42C93': 'prickly-pink',
  'F4301C': 'primal-rage',
  'F44772': 'fuchsia-felicity',
  'F4581E': 'prometheus-orange',
  'F4706E': 'breeze-of-chilli',
  'F4711E': 'apocalyptic-orange',
  'F47983': 'momo-peach',
  'F48101': 'romesco',
  'F48B8B': 'vinaceous-cinnamon',
  'F49AC2': 'pastel-magenta',
  'F4A384': 'creamy-peach',
  'F4A460': 'sandy-brown',
  'F4A461': 'shrimp-cocktail',
  'F4A6A3': 'calabrese',
  'F4AA53': 'pani-puri',
  'F4ACB6': 'pink-blush',
  'F4B3C2': 'ibis',
  'F4B435': 'solar-power',
  'F4B6D1': 'pink-marshmallow',
  'F4BBFF': 'brilliant-lavender',
  'F4C2C2': 'tea-rose',
  'F4C430': 'saffron',
  'F4C4D0': 'in-the-pink',
  'F4C9B1': 'bellini',
  'F4CA16': 'jonquil',
  'F4CE74': 'golden-churro',
  'F4D493': 'instant-noodles',
  'F4D69A': 'igniting',
  'F4D81C': 'ripe-lemon',
  'F4DAF1': 'grape-taffy',
  'F4DBD9': 'fresco',
  'F4DEB3': 'pina-colada',
  'F4E0BB': 'butter-up',
  'F4E1B6': 'soft-butter',
  'F4E216': 'xanthic',
  'F4E25A': 'flame-seal',
  'F4E2CF': 'fondant',
  'F4E3DF': 'pearly',
  'F4E5E0': 'petal-pink',
  'F4E8E8': 'white-christmas',
  'F4EBD3': 'janna',
  'F4EDE4': 'angelic-white',
  'F4EFE1': 'divine-pleasure',
  'F4EFEE': 'angelic-wings',
  'F4F0DA': 'lotus-flower',
  'F4F0EC': 'isabelline',
  'F4F2E2': 'au-clair-de-la-lune',
  'F4F2EA': 'doves-wing',
  'F4F2EE': 'pampas',
  'F4F3E0': 'full-moon',
  'F4F4F4': 'wild-sand',
  'F4F8FF': 'zircon',
  'F4FF00': 'busy-bee',
  'F504C9': 'mademoiselle-pink',
  'F51360': 'pure-pleasure',
  'F5160B': 'sweet-chilli',
  'F5576C': 'ripe-malinka',
  'F56961': 'sriracha',
  'F56991': 'light-crimson',
  'F56FA1': 'cyclamen',
  'F57584': 'froly',
  'F58025': 'princeton-orange',
  'F59994': 'vinaceous',
  'F59997': 'peach-punch',
  'F5A8B2': 'pink-fit',
  'F5AD75': 'charming-peach',
  'F5B57B': 'sunburst',
  'F5B700': 'curry-bubbles',
  'F5B9D8': 'manga-pink',
  'F5C1D5': 'cherry-blossom',
  'F5C20B': 'sunshine-mellow',
  'F5C553': 'moms-pancake',
  'F5C71A': 'deep-lemon',
  'F5C85C': 'cream-can',
  'F5C999': 'manhattan',
  'F5CC23': 'golden-ticket',
  'F5CDD2': 'pleasing-pink',
  'F5CE9F': 'granola',
  'F5CED8': 'icy-pink',
  'F5D547': 'anna-banana',
  'F5D893': 'poached-egg',
  'F5DAB3': 'lions-roar',
  'F5DD98': 'sunbathed',
  'F5DEB3': 'wheat',
  'F5E050': 'minion-yellow',
  'F5E5AB': 'butter-honey',
  'F5E6D3': 'shortbread',
  'F5E7A2': 'sandwisp',
  'F5E7D2': 'pita',
  'F5E7E2': 'pot-pourri',
  'F5E9D3': 'albescent-white',
  'F5EBD8': 'white-sand',
  'F5EDB2': 'sunbeam',
  'F5EDEF': 'soft-peach',
  'F5EEC6': 'silk-star',
  'F5EEDF': 'vapour-trail',
  'F5EFE5': 'white-beach',
  'F5F0F1': 'plastic-clouds',
  'F5F1E5': 'open-book',
  'F5F3E5': 'ecru-white',
  'F5F3E6': 'dear-reader',
  'F5F3E9': 'engulfed-in-light',
  'F5F4ED': 'morning-snow',
  'F5F5DC': 'beige',
  'F5F5F5': 'white-smoke',
  'F5F9AD': 'yellow-chalk',
  'F5FB3D': 'golden-fizz',
  'F5FEFD': 'sparkling-snow',
  'F5FFBE': 'australian-mint',
  'F5FFFA': 'mint-cream',
  'F60206': 'assassins-red',
  'F64A8A': 'french-rose',
  'F65D20': 'plastic-carrot',
  'F6685A': 'camellia',
  'F69092': 'fruity-licious',
  'F6A09D': 'young-crab',
  'F6A374': 'flaming-cauldron',
  'F6A4C9': 'illusion',
  'F6AC00': 'spicy-sweetcorn',
  'F6AC17': 'sultan-gold',
  'F6ADC6': 'nadeshiko-pink',
  'F6BA25': 'glistening-dawn',
  'F6C362': 'sunset-gold',
  'F6C75E': 'deep-fried-sunrays',
  'F6C8C1': 'millennial-pink',
  'F6CBCA': 'happy-piglets',
  'F6CD23': 'pot-of-gold',
  'F6D263': 'golden-sprinkles',
  'F6D8BE': 'sabl',
  'F6DBD8': 'rosewater',
  'F6DCD2': 'air-kiss',
  'F6DD34': 'angels-trumpet',
  'F6DEE0': 'blowing-kisses',
  'F6DFB2': 'butter-muffin',
  'F6E19C': 'buttery-croissant',
  'F6E2EA': 'first-crush',
  'F6E3B4': 'flan',
  'F6E491': 'beekeeper',
  'F6E5B9': 'gentle-glow',
  'F6EABE': 'lemon-meringue',
  'F6EBA1': 'lazy-daisy',
  'F6EDB6': 'veiled-treasure',
  'F6EED1': 'mayonnaise',
  'F6EED5': 'moonlight',
  'F6EEDF': 'birch-white',
  'F6EEE2': 'fuji-peak',
  'F6EEED': 'grannies-pearls',
  'F6EFDF': 'paper-white',
  'F6EFE1': 'fresh-snow',
  'F6F0E6': 'merino',
  'F6F1E2': 'whiskers',
  'F6F1F4': 'grim-white',
  'F6F1FE': 'cloud-break',
  'F6F3A7': 'thunderdome',
  'F6F3E7': 'raptures-light',
  'F6F4F1': 'white-chalk',
  'F6F4F6': 'french-porcelain',
  'F6F677': 'hyper-beam',
  'F6F7F7': 'black-haze',
  'F6FDFA': 'everlasting-ice',
  'F6FFDC': 'spring-sun',
  'F6FFE8': 'milk-foam',
  'F70D1A': 'vivid-red',
  'F72305': 'spectacular-scarlet',
  'F7250B': 'reign-of-tomatoes',
  'F73D37': 'flamboyant',
  'F74480': 'flamboyant-flamingo',
  'F7504A': 'pumping-spice',
  'F75300': 'trout-caviar',
  'F75394': 'violet-red',
  'F771B3': 'pop-that-gum',
  'F7746B': 'ros',
  'F77511': 'liquid-lava',
  'F77703': 'chilean-fire',
  'F77F00': 'university-of-tennessee-orange',
  'F77FBE': 'persian-pink',
  'F78058': 'bonfire',
  'F78FA7': 'pink-sherbet',
  'F7B28B': 'peach-velour',
  'F7B565': 'peanut-butter-biscuit',
  'F7B731': 'nyc-taxi',
  'F7BC5C': 'fizzy-peach',
  'F7BFBE': 'spanish-pink',
  'F7BFC2': 'candy-cane',
  'F7C070': 'golden-opportunity',
  'F7C34C': 'creamy-sweet-corn',
  'F7C5A0': 'shrimp-toast',
  'F7C8DA': 'azalea',
  'F7CCCD': 'kendall-rose',
  'F7CDC8': 'veiled-rose',
  'F7CDCE': 'strawberry-ripple',
  'F7CF00': 'endless-summer',
  'F7CF26': 'dream-of-spring',
  'F7CFB4': 'royal-milk-tea',
  'F7D07A': 'popcorn',
  'F7D163': 'soaked-in-sun',
  'F7D5D4': 'ballet',
  'F7D788': 'pancake',
  'F7DA90': 'meadow-yellow',
  'F7DBE6': 'we-peep',
  'F7DDAA': 'dumpling',
  'F7DFAF': 'pasta',
  'F7E504': 'eternal-summer',
  'F7E7CE': 'champagne',
  'F7E7DD': 'grandmas-cameo',
  'F7E98E': 'flavescent',
  'F7EB73': 'limon',
  'F7EDCA': 'mothers-milk',
  'F7EEC8': 'banana-split',
  'F7EEE3': 'magnolia-petal',
  'F7F0D2': 'buttered-up',
  'F7F4DA': 'pineapple-sorbet',
  'F7F5C8': 'fizzy-and-dizzy',
  'F7F5F3': 'venerable-white',
  'F7F5FA': 'whisper',
  'F7F6D5': 'rising-star',
  'F7FAF7': 'snow-drift',
  'F7FCFF': 'heart-of-ice',
  'F81404': 'apple-cherry',
  'F83800': 'metroid-red',
  'F8611A': 'light-my-fire',
  'F878F8': 'princess-peach',
  'F87E63': 'slippery-salmon',
  'F88379': 'congo-pink',
  'F88435': 'peach-fury',
  'F88517': 'glorious-sunset',
  'F88605': 'atomic-orange',
  'F887C7': 'bubblegum-beam',
  'F89851': 'holland-tulip',
  'F89882': 'parma-ham',
  'F8A200': 'mad-for-mango',
  'F8B3FF': 'strawberry-buttercream',
  'F8B4C4': 'love-spell',
  'F8B500': 'waxy-corn',
  'F8B853': 'casablanca',
  'F8B878': 'mellow-apricot',
  'F8C3DF': 'chantilly',
  'F8C649': 'cakepop-sorbet',
  'F8D106': 'wu-tang-gold',
  'F8D568': 'orange-yellow',
  'F8D7D0': 'bloodthirsty-beige',
  'F8D9E9': 'cherub',
  'F8DB9D': 'marzipan',
  'F8DCBF': 'toes-in-the-sand',
  'F8DD5C': 'energy-yellow',
  'F8DE7E': 'jasmine',
  'F8DE7F': 'mellow-dandelion',
  'F8DEB8': 'pastry',
  'F8E0E7': 'pork-belly',
  'F8E2CA': 'acropolis',
  'F8E3AB': 'vanilla-cream',
  'F8E462': 'goldfinch',
  'F8E4BF': 'givry',
  'F8E6D9': 'hint-of-orange',
  'F8EDD3': 'polished-pearl',
  'F8F0D8': 'sunny-honey',
  'F8F0E8': 'white-linen',
  'F8F4D8': 'transcendence',
  'F8F4FF': 'magnolia',
  'F8F6DF': 'promenade',
  'F8F6E6': 'flickering-firefly',
  'F8F6F1': 'spring-wood',
  'F8F739': 'banana-bandanna',
  'F8F753': 'pilsener',
  'F8F7DC': 'coconut-cream',
  'F8F7FC': 'white-lilac',
  'F8F8F7': 'desert-storm',
  'F8F8FF': 'ghost-white',
  'F8F99C': 'texas',
  'F8FACD': 'corn-field',
  'F8FAEE': 'enoki',
  'F8FBEB': 'amnesiac-white',
  'F8FBF8': 'white-porcelain',
  'F8FDD3': 'mimosa',
  'F9429E': 'rose-bonbon',
  'F94D00': 'tangelo',
  'F95554': 'red-mana',
  'F95A61': 'carnation',
  'F97272': 'georgia-peach',
  'F9736E': 'sparkling-cosmo',
  'F984E5': 'pale-magenta',
  'F984EF': 'light-fuchsia-pink',
  'F98513': 'haba-ero',
  'F9906F': 'salmon-nigiri',
  'F9A4A4': 'her-majesty',
  'F9BF58': 'saffron-mango',
  'F9CBA0': 'chai-latte',
  'F9CEC6': 'cloud-number-nine',
  'F9D857': 'lemon-zest',
  'F9D8E4': 'lovely-breeze',
  'F9DCE3': 'marshmallow-heart',
  'F9DFE5': 'cake-frosting',
  'F9E0ED': 'carousel-pink',
  'F9E3B4': 'noodles',
  'F9E4BC': 'dairy-cream',
  'F9E663': 'portica',
  'F9E6F4': 'underage-pink',
  'F9E7C8': 'delightful-pastry',
  'F9E9D6': 'dwindling-dandelion',
  'F9EAF3': 'amour',
  'F9EBBF': 'candle-in-the-wind',
  'F9EDE2': 'alpaca',
  'F9EED6': 'flashlight',
  'F9F1DD': 'exclusive-elixir',
  'F9F2B3': 'casino-lights',
  'F9F2DE': 'painters-canvas',
  'F9F2E7': 'powdered',
  'F9F525': 'golden-ginkgo',
  'F9F59F': 'yippie-ya-yellow',
  'F9F5DB': 'thunder-and-lightning',
  'F9F8E4': 'rum-swizzle',
  'F9F9F9': 'doctor',
  'F9FF8B': 'dolly',
  'F9FFF6': 'sugar-cane',
  'FA005C': 'sizzling-watermelon',
  'FA427E': 'diva-pink',
  'FA5B3D': 'orange-soda',
  'FA6E79': 'begonia',
  'FA7069': 'flirty-salmon',
  'FA8072': 'salmon',
  'FA8383': 'strawberry-field',
  'FA9D5A': 'tan-hide',
  'FABFE4': 'pretty-in-pink',
  'FACF58': 'rubber-ducky',
  'FAD28F': 'sunbathed-beach',
  'FAD3A2': 'corvette',
  'FAD6A5': 'sunset',
  'FAD9DA': 'lucky-you',
  'FADA5E': 'naples-yellow',
  'FADADD': 'pale-pink',
  'FADDD5': 'pink-parfait',
  'FADE79': 'ravioli-al-limone',
  'FADFAD': 'peach-yellow',
  'FAE17F': 'pasta-luego',
  'FAE5BF': 'saturn',
  'FAE600': 'turbo',
  'FAE7B5': 'banana-mania',
  'FAEAB9': 'astra',
  'FAEAE2': 'dogwood',
  'FAEBD7': 'antique-white',
  'FAEDE6': 'frothy-milk',
  'FAEE66': 'yellowish',
  'FAEED7': 'happy-skeleton',
  'FAEFBE': 'moon-dance',
  'FAEFDF': 'long-beach',
  'FAF0BE': 'blond',
  'FAF0E6': 'linen',
  'FAF3A6': 'banan-appeal',
  'FAF3E6': 'milk-moustache',
  'FAF3F0': 'fantasy',
  'FAF5FA': 'walkie-chalkie',
  'FAF7D6': 'citrine-white',
  'FAFA37': 'maximum-yellow',
  'FAFAD2': 'light-goldenrod-yellow',
  'FAFAFA': 'alabaster',
  'FAFC5D': 'duckling-fluff',
  'FAFDE4': 'hint-of-yellow',
  'FAFFA4': 'milan',
  'FAFFED': 'pearl-powder',
  'FB0081': 'flickr-pink',
  'FB4D46': 'tart-orange',
  'FB4F14': 'orioles-orange',
  'FB5581': 'warm-pink',
  'FB5FFC': 'violet-pink',
  'FB607F': 'brink-pink',
  'FB7EFD': 'atomic-pink',
  'FB8989': 'geraldine',
  'FB9902': 'ryb-orange',
  'FBA0E3': 'lavender-rose',
  'FBA129': 'sea-buckthorn',
  'FBA52E': 'carona',
  'FBAA95': 'no-way-ros',
  'FBAB60': 'rajah',
  'FBAC13': 'sun',
  'FBAED2': 'lavender-pink',
  'FBB2A3': 'rose-bud',
  'FBB736': 'glowing-lantern',
  'FBB782': 'baltic-amber',
  'FBBEDA': 'cupid',
  'FBCCE7': 'classic-rose',
  'FBCD9F': 'apricot-sherbet',
  'FBCEB1': 'apricot',
  'FBD5A6': 'tuscan',
  'FBD8CC': 'twinkle-pink',
  'FBD9CD': 'yours-truly',
  'FBDDAF': 'such-a-peach',
  'FBE0E8': 'watermelon-mousse',
  'FBE870': 'marigold-yellow',
  'FBE8A8': 'bleached-sunflower',
  'FBE96C': 'festival',
  'FBE98E': 'chickery-chick',
  'FBEA8C': 'sweet-corn',
  'FBEAB8': 'solar',
  'FBEC5D': 'maize',
  'FBEC5E': 'maizena',
  'FBEDD7': 'beaches-of-cancun',
  'FBEDDA': 'mango-cheesecake',
  'FBF073': 'witch-hazel',
  'FBF3F1': 'ivory-tower',
  'FBF4D6': 'lunar-luxury',
  'FBF5F0': 'silver-bird',
  'FBF9F9': 'hint-of-red',
  'FBFB4C': 'biohazard-suit',
  'FBFF00': 'electric-banana',
  'FBFFBA': 'shalimar',
  'FC0FC0': 'shocking-pink',
  'FC4A14': 'dragons-fire',
  'FC5A1F': 'carrot-lava',
  'FC5A8D': 'strawberry',
  'FC6C85': 'wild-watermelon',
  'FC74FD': 'pink-flamingo',
  'FC7604': 'butternut-squash',
  'FC86AA': 'pinky',
  'FC89AC': 'tickle-me-pink',
  'FC8AAA': 'rocknrose',
  'FC8EAC': 'flamingo-pink',
  'FC9C1D': 'tree-poppy',
  'FCA044': 'double-dragon',
  'FCA2AD': 'ballet-slippers',
  'FCAA12': 'beer',
  'FCB4D5': 'lavender-candy',
  'FCC01E': 'lightning-yellow',
  'FCC200': 'golden-poppy',
  'FCC9B6': 'dolly-cheek',
  'FCCCF5': 'kissed-by-mist',
  'FCD2DF': 'creamy-strawberry',
  'FCD7BA': 'gentle-caress',
  'FCD8B5': 'young-apricot',
  'FCD917': 'candlelight',
  'FCD975': 'golden-coin',
  'FCDA98': 'cherokee',
  'FCDF39': 'fluffy-duckling',
  'FCDF63': 'here-comes-the-sun',
  'FCDF8A': 'daisy-desi',
  'FCDFA4': 'honey-bee',
  'FCE17C': 'silken-gold',
  'FCE6DB': 'slightly-in-love',
  'FCE883': 'crayola-yellow',
  'FCEAE6': 'pink-swirl',
  'FCEDE4': 'vanilla-blush',
  'FCEFD1': 'honied-white',
  'FCEFE0': 'silk-lining',
  'FCF0CA': 'vanilla-cake',
  'FCF4D0': 'double-pearl-lusta',
  'FCF4DC': 'pearl-lusta',
  'FCF679': 'straw-gold',
  'FCF6EB': 'dipped-in-cream',
  'FCF75E': 'icterine',
  'FCF8F7': 'vista-white',
  'FCFBEB': 'placebo-yellow',
  'FCFBF3': 'bianca',
  'FCFC5D': 'candy-corn',
  'FCFC9D': 'walking-on-sunshine',
  'FCFCDA': 'good-morning',
  'FCFDFC': 'emptiness',
  'FCFEDA': 'moon-glow',
  'FCFFE7': 'china-ivory',
  'FCFFF9': 'ceramic',
  'FCFFFF': 'polar-bear-in-a-blizzard',
  'FD0E35': 'tractor-red',
  'FD3A4A': 'red-salsa',
  'FD3C06': 'fire-opal',
  'FD3F92': 'french-fuchsia',
  'FD4659': 'watermelon',
  'FD5240': 'ogre-odor',
  'FD5800': 'willpower-orange',
  'FD5956': 'grapefruit',
  'FD5E53': 'sunset-orange',
  'FD6C9E': 'french-pink',
  'FD6F3B': 'carrot',
  'FD7B33': 'crusta',
  'FD7C07': 'sorbus',
  'FD7C6E': 'hipster-salmon',
  'FD8C23': 'mango-madness',
  'FD8F79': 'kissable',
  'FD9B88': 'peachs-daydream',
  'FD9FA2': 'sweet-pink',
  'FDAE44': 'safflower',
  'FDB147': 'butterscotch',
  'FDB251': 'salted-caramel-popcorn',
  'FDB2AB': 'peach-bud',
  'FDBCB4': 'melon',
  'FDBD27': 'sunflower-valley',
  'FDC5E3': 'sugarwinkle',
  'FDC675': 'liquid-gold',
  'FDCFA1': 'peach-beach',
  'FDD014': 'mamba-yellow',
  'FDD0D5': 'love-fumes',
  'FDD5B1': 'light-apricot',
  'FDD630': 'banana-pepper',
  'FDD792': 'evening-glow',
  'FDD7E4': 'pig-pink',
  'FDDC57': 'potato-chip',
  'FDDDE6': 'piggy-pink',
  'FDDE45': 'cheese-it-up',
  'FDDFDA': 'pink-glitter',
  'FDE1DC': 'cinderella',
  'FDE295': 'golden-glow',
  'FDE3B5': 'white-strawberry',
  'FDEA9F': 'eggnog',
  'FDEE00': 'aureolin',
  'FDEFAD': 'thunderbolt',
  'FDF200': 'marsupilami',
  'FDF3D5': 'satin-cream-white',
  'FDF5C4': 'fondue',
  'FDF5E6': 'old-lace',
  'FDF6D3': 'half-colonial-white',
  'FDF7AD': 'drover',
  'FDF901': 'delayed-yellow',
  'FDFCBF': 'yellow-mana',
  'FDFD96': 'pastel-yellow',
  'FDFDFD': 'brilliance',
  'FDFEB8': 'pale-prim',
  'FDFF00': 'lemon-glacier',
  'FDFFD5': 'cumulus',
  'FDFFF5': 'milk',
  'FE0002': 'fire-engine',
  'FE019A': 'neon-pink',
  'FE01B1': 'pink-hysteria',
  'FE0215': 'virtual-boy',
  'FE1493': 'fluorescent-pink',
  'FE1C06': 'thai-hot',
  'FE2712': 'ryb-red',
  'FE2713': 'red-riding-hood',
  'FE28A2': 'persian-rose',
  'FE2E2E': 'light-brilliant-red',
  'FE314B': 'cherry-paddle-pop',
  'FE4164': 'neon-fuchsia',
  'FE486C': 'infrared',
  'FE4EDA': 'purple-pizzazz',
  'FE5A1D': 'giants-orange',
  'FE6346': 'sweet-pimento',
  'FE653C': 'halloween',
  'FE6F5E': 'bittersweet',
  'FE6FFF': 'flamazing-pink',
  'FE7B7C': 'forbidden-fruit',
  'FE985C': 'papaya',
  'FE9D04': 'california',
  'FEA904': 'yellow-sea',
  'FEA993': 'frozen-salmon',
  'FEC615': 'orangina',
  'FECC36': 'golden-spell',
  'FECD82': 'deviled-eggs',
  'FECF3C': 'haba-ero-gold',
  'FED33C': 'bright-sun',
  'FED56F': 'quiche-lorraine',
  'FED67E': 'lemon-burst',
  'FED83A': 'exploding-star',
  'FEDB2D': 'golden-period',
  'FEDB8D': 'salomie',
  'FEDBB7': 'pandoras-box',
  'FEDC39': 'traffic-yellow',
  'FEDC57': 'glitter-is-not-gold',
  'FEDD7D': 'cup-noodles',
  'FEDE4F': 'royal-star',
  'FEDF00': 'pantone-yellow',
  'FEDFDC': 'dawn-patrol',
  'FEE5AC': 'cape-honey',
  'FEEBF3': 'remy',
  'FEEDCA': 'biscuit',
  'FEEEA5': 'cream-and-butter',
  'FEEEED': 'voracious-white',
  'FEEFCE': 'oasis',
  'FEF0DE': 'award-winning-white',
  'FEF0EC': 'bridesmaid',
  'FEF2C7': 'beeswax',
  'FEF3D8': 'bleach-white',
  'FEF4CC': 'pipi',
  'FEF4DB': 'half-spanish-white',
  'FEF4F8': 'wisp-pink',
  'FEF5F1': 'provincial-pink',
  'FEF7DE': 'half-dutch-white',
  'FEF8E2': 'solitaire',
  'FEF8FF': 'white-pointer',
  'FEF9E3': 'off-yellow',
  'FEFAFB': 'snowman',
  'FEFCED': 'orange-white',
  'FEFDFA': 'lotion',
  'FEFE33': 'ryb-yellow',
  'FEFEE7': 'wedding-dress',
  'FEFEFA': 'baby-powder',
  'FEFF00': 'bat-signal',
  'FEFF32': 'bee-yellow',
  'FF0000': 'red',
  'FF0008': 'marinara-red',
  'FF0015': 'british-phone-booth',
  'FF0022': 'incision',
  'FF0028': 'ruddy',
  'FF0033': 'hornet-sting',
  'FF0038': 'carmine-red',
  'FF003F': 'electric-crimson',
  'FF0044': 'cherry-soda',
  'FF004F': 'folly',
  'FF0051': 'hawaiian-raspberry',
  'FF0054': 'blazing-dragonfruit',
  'FF005D': 'flaming-hot-flamingoes',
  'FF006A': 'shocking-rose',
  'FF006C': 'vivid-raspberry',
  'FF0073': 'retro-pink-pop',
  'FF0077': 'guns-n-roses',
  'FF007C': 'winter-sky',
  'FF007E': 'pink-poison',
  'FF007F': 'rose',
  'FF0080': 'neon-rose',
  'FF0088': 'fancy-fuchsia',
  'FF0090': 'process-magenta',
  'FF0099': 'big-bang-pink',
  'FF00AA': 'ms-pac-man-kiss',
  'FF00AE': 'mean-girls-lipstick',
  'FF00BB': 'brutal-pink',
  'FF00FD': 'metal-pink',
  'FF00FF': 'fuchsia',
  'FF017F': 'berry-blast',
  'FF0303': 'left-on-red',
  'FF033E': 'american-rose',
  'FF0599': 'burning-raspberry',
  'FF073A': 'neon-red',
  'FF0800': 'candy-apple-red',
  'FF0D00': 'fire-hydrant',
  'FF0D04': 'shocking-crimson',
  'FF0E0E': 'danger',
  'FF0F0F': 'red-alert',
  'FF0FF3': 'barbara',
  'FF1100': 'furious-red',
  'FF1111': 'spicy',
  'FF1133': 'rage',
  'FF1155': 'golden-blood',
  'FF1166': 'burning-fireflies',
  'FF1177': 'pucker-up',
  'FF1199': 'forgiven-sin',
  'FF1414': 'little-ladybug',
  'FF1476': 'pink-ink',
  'FF1493': 'deep-pink',
  'FF1500': 'carolina-reaper',
  'FF1C1C': 'traffic-red',
  'FF1DCD': 'pink-glamour',
  'FF1DCE': 'hot-magenta',
  'FF2040': 'future-fuchsia',
  'FF2077': 'cyberpink',
  'FF2200': 'red-um',
  'FF2222': 'red-stop',
  'FF2233': 'in-the-red',
  'FF2244': 'red-flag',
  'FF22DD': 'cupids-eye',
  'FF2400': 'scarlet',
  'FF2600': 'maraschino',
  'FF2800': 'ferrari-red',
  'FF2F92': 'unicorn-dust',
  'FF3300': 'boiling-magma',
  'FF3333': 'pelati',
  'FF3344': 'devils-advocate',
  'FF3366': 'chinese-new-year',
  'FF3388': 'lilac-lotion',
  'FF33CC': 'razzle-dazzle-rose',
  'FF355E': 'radical-red',
  'FF3800': 'coquelicot',
  'FF3855': 'sizzling-red',
  'FF3F6A': 'laser-trap',
  'FF4040': 'coral-red',
  'FF404C': 'sunburnt-cyclops',
  'FF43A4': 'wild-strawberry',
  'FF4400': 'inferno-orange',
  'FF4411': 'coin-slot',
  'FF4422': 'dynamite',
  'FF4433': 'hotspot',
  'FF4466': 'magic-potion',
  'FF4500': 'orange-red',
  'FF4681': 'sasquatch-socks',
  'FF474C': 'blood-burst',
  'FF4D00': 'phaser-beam',
  'FF4E01': 'magma',
  'FF4F00': 'international-orange',
  'FF5349': 'red-orange',
  'FF5470': 'fiery-rose',
  'FF550E': 'orange-clown-fish',
  'FF5522': 'smashing-pumpkins',
  'FF5599': 'fuchsia-fever',
  'FF55A3': 'brilliant-rose',
  'FF55CC': 'drunken-flamingo',
  'FF55EE': 'pink-party',
  'FF5800': 'pantone-orange',
  'FF5A36': 'portland-orange',
  'FF5C8D': 'stellar-strawberry',
  'FF5CCD': 'light-deep-pink',
  'FF5EC4': 'eosin-pink',
  'FF5F00': 'vivid-orange',
  'FF6163': 'fusion-red',
  'FF616B': 'grenadine-pink',
  'FF6216': 'vibrant-orange',
  'FF6347': 'tomato',
  'FF63E9': 'candy-pink',
  'FF6666': 'pompelmo',
  'FF6677': 'kisses-and-hugs',
  'FF66BB': 'kisses',
  'FF66CC': 'rose-pink',
  'FF66EE': 'vaporwave',
  'FF6700': 'blaze-orange',
  'FF6961': 'pastel-red',
  'FF69B4': 'hot-pink',
  'FF6D3A': 'smashed-pumpkin',
  'FF6E1C': 'shocking-orange',
  'FF6E4A': 'outrageous-orange',
  'FF6EC7': 'nervous-neon-pink',
  'FF6F01': 'flush-orange',
  'FF6F91': 'blush-hour',
  'FF6FFF': 'ultra-pink',
  'FF7013': 'arancio',
  'FF7034': 'burning-orange',
  'FF7133': 'extreme-carrot',
  'FF7518': 'pumpkin',
  'FF7538': 'crayola-orange',
  'FF7733': 'temptatious-tangerine',
  'FF7744': 'precious-persimmon',
  'FF775E': 'peachy-pinky',
  'FF7777': 'embarrassment',
  'FF77BB': 'dream-setting',
  'FF77EE': 'avant-garde-pink',
  'FF77FF': 'fuchsia-pink',
  'FF7800': 'safety-orange',
  'FF7A00': 'heat-wave',
  'FF7A83': 'anime-blush',
  'FF7A8F': 'magical-girl',
  'FF7D07': 'flamenco',
  'FF7E00': 'sae-ece-amber',
  'FF7E79': 'salmon-sashimi',
  'FF7F00': 'orange',
  'FF7F50': 'coral',
  'FF7F7F': 'light-red',
  'FF8008': 'oriole',
  'FF80FF': 'hottest-of-pinks',
  'FF8243': 'mango-tango',
  'FF85CF': 'princess-perfume',
  'FF85FF': 'bubblegum',
  'FF8656': 'nectarine',
  'FF878D': 'tulip',
  'FF8833': 'wildfire',
  'FF8855': 'tiger-of-mysore',
  'FF88AA': 'strawberry-dreams',
  'FF88CC': 'shimmering-love',
  'FF8C00': 'dark-orange',
  'FF8C55': 'paradise-bird',
  'FF9000': 'pizazz',
  'FF910F': 'west-side',
  'FF917A': 'coralistic',
  'FF91A4': 'salmon-pink',
  'FF91AF': 'baker-miller-pink',
  'FF9613': 'cheese-please',
  'FF9900': 'vivid-gamboge',
  'FF9922': 'dragon-ball',
  'FF9933': 'deep-saffron',
  'FF9966': 'pink-orange',
  'FF9977': 'flash-in-the-pan',
  'FF9999': 'light-salmon-pink',
  'FF99CC': 'pale-magenta-pink',
  'FF99EE': 'pink-elephants',
  'FF99FF': 'pinkalicious',
  'FF9B87': 'candy',
  'FF9E2C': 'sunshade',
  'FF9E4B': 'tangerine-tango',
  'FF9F00': 'orange-peel',
  'FFA000': 'vivid-orange-peel',
  'FFA07A': 'light-salmon',
  'FFA089': 'vivid-tangerine',
  'FFA177': 'butternut',
  'FFA194': 'mona-lisa',
  'FFA343': 'neon-carrot',
  'FFA500': 'web-orange',
  'FFA600': 'cheese',
  'FFA601': 'orange-you-glad',
  'FFA62B': 'mango',
  'FFA6C9': 'carnation-pink',
  'FFA700': 'chrome-yellow',
  'FFA812': 'dark-tangerine',
  'FFA883': 'peach-fizz',
  'FFAA1D': 'bright-yellow',
  'FFAA4A': 'five-star',
  'FFAAAA': 'apricot-haze',
  'FFAADD': 'fresh-gum',
  'FFAAFF': 'jigglypuff',
  'FFAB81': 'hit-pink',
  'FFAD98': 'discreet-orange',
  'FFAE42': 'yellow-orange',
  'FFAEBB': 'poodle-skirt',
  'FFB0AC': 'cornflower-lilac',
  'FFB162': 'burning-flame',
  'FFB1B3': 'sundown',
  'FFB200': 'imperial-yellow',
  'FFB300': 'ucla-gold',
  'FFB31F': 'my-sin',
  'FFB347': 'pastel-orange',
  'FFB3DE': 'light-hot-pink',
  'FFB437': 'corona',
  'FFB49B': 'persicus',
  'FFB555': 'texas-rose',
  'FFB6B4': 'young-salmon',
  'FFB6C1': 'light-pink',
  'FFB700': 'sunflower-mango',
  'FFB737': 'soft-boiled',
  'FFB75F': 'peanut-butter-chicken',
  'FFB7C5': 'cherry-blossom-pink',
  'FFB7CE': 'baby-pink',
  'FFB7D5': 'candy-bar',
  'FFB800': 'king-nacho',
  'FFB81B': 'master-nacho',
  'FFBA00': 'selective-yellow',
  'FFBA24': 'beloved-sunflower',
  'FFBA6B': 'desert-dessert',
  'FFBA80': 'goose-bill',
  'FFBADF': 'bubblegum-heart',
  'FFBB00': 'nacho-cheese',
  'FFBB33': 'buddhas-love-handles',
  'FFBB4D': 'mango-latte',
  'FFBB77': 'nouveau-riche',
  'FFBB99': 'cream-puff',
  'FFBBBB': 'hard-candy',
  'FFBCBC': 'peach-scone',
  'FFBCD9': 'cotton-candy',
  'FFBD31': 'vibrant-honey',
  'FFBD5F': 'koromiko',
  'FFBD88': 'macaroni-and-cheese',
  'FFBEC8': 'love-affair',
  'FFBF00': 'amber',
  'FFBF6E': 'cinnamon-buff',
  'FFBF99': 'blushing-cinnamon',
  'FFC0A8': 'wax-flower',
  'FFC0C6': 'piglet',
  'FFC0CB': 'pink',
  'FFC12C': 'not-yo-cheese',
  'FFC16C': 'solar-storm',
  'FFC1CC': 'bubble-gum',
  'FFC283': 'buttery',
  'FFC355': 'orange-delight',
  'FFC3C0': 'your-pink',
  'FFC3CB': 'cotton-candy-comet',
  'FFC400': 'citrus-splash',
  'FFC40C': 'mikado-yellow',
  'FFC65F': 'mellow-drama',
  'FFC66E': 'chanterelle',
  'FFC72C': 'pineapple-gold',
  'FFC7B9': 'peach-fuzz',
  'FFC82A': 'bumblebee',
  'FFC863': 'honeypot',
  'FFC87C': 'topaz',
  'FFC901': 'supernova',
  'FFC962': 'smiley-face',
  'FFC985': 'torchlight',
  'FFCAA4': 'polly',
  'FFCB5D': 'nacho',
  'FFCBA4': 'peach',
  'FFCBEE': 'puff-of-pink',
  'FFCC00': 'tangerine-yellow',
  'FFCC04': 'plastic-cheese',
  'FFCC11': 'superstar',
  'FFCC33': 'sunglow',
  'FFCC55': 'angry-pasta',
  'FFCC5C': 'golden-tainoi',
  'FFCC77': 'cheesus',
  'FFCC99': 'peach-orange',
  'FFCCB6': 'peach-and-quiet',
  'FFCCBB': 'piggy-bank',
  'FFCCFF': 'sugar-chic',
  'FFCD01': 'sunflower-island',
  'FFCD8C': 'chardonnay',
  'FFCDB9': 'dainty-peach',
  'FFCE81': 'egg-yolk',
  'FFCF65': 'chickadee',
  'FFCF73': 'banana-bread',
  'FFCFF1': 'shampoo',
  'FFD182': 'bread-and-butter',
  'FFD2B7': 'romantic',
  'FFD300': 'cyber-yellow',
  'FFD301': 'inca-yellow',
  'FFD34E': 'golden-goose',
  'FFD38C': 'grandis',
  'FFD3CF': 'girlie',
  'FFD479': 'cantaloupe',
  'FFD59A': 'caramel-finish',
  'FFD678': 'yuma-gold',
  'FFD700': 'golden',
  'FFD766': 'yuzu-marmalade',
  'FFD800': 'school-bus-yellow',
  'FFD84D': 'tuscan-sun',
  'FFD8D9': 'cosmos',
  'FFD900': 'soviet-gold',
  'FFD9E6': 'pink-supremecy',
  'FFD9E7': 'strawberry-milk',
  'FFDA29': 'vibrant-yellow',
  'FFDAB9': 'peach-puff',
  'FFDADC': 'strawberry-blonde',
  'FFDAE2': 'its-a-girl',
  'FFDAE9': 'mimi-pink',
  'FFDB00': 'sizzling-sunrise',
  'FFDB58': 'mustard',
  'FFDBE9': 'strawberry-cheesecake',
  'FFDCBF': 'persian-melon',
  'FFDCCC': 'glazed-sugar',
  'FFDCD6': 'peach-schnapps',
  'FFDD00': 'super-saiyan',
  'FFDD22': 'gangsters-gold',
  'FFDD44': 'golden-boy',
  'FFDD66': 'lemon-tart',
  'FFDDAF': 'caramel',
  'FFDDC7': 'coral-kiss',
  'FFDDCA': 'unbleached-silk',
  'FFDDCD': 'tuft-bush',
  'FFDDCF': 'watusi',
  'FFDDF4': 'pink-lace',
  'FFDE34': 'emoji-yellow',
  'FFDEAD': 'navajo-white',
  'FFDEB3': 'frangipani',
  'FFDF00': 'golden-yellow',
  'FFDF46': 'gargoyle-gas',
  'FFDFE5': 'pink-pleasure',
  'FFE135': 'banana-yellow',
  'FFE1DF': 'pippin',
  'FFE1F2': 'pale-rose',
  'FFE292': 'banana-republic',
  'FFE29B': 'couscous',
  'FFE302': 'vivid-yellow',
  'FFE3F4': 'bunny-tail',
  'FFE4B5': 'moccasin',
  'FFE4C4': 'bisque',
  'FFE4CD': 'lumber',
  'FFE4E1': 'misty-rose',
  'FFE500': 'star',
  'FFE5A0': 'cream-brulee',
  'FFE5EF': 'sweetly',
  'FFE6C7': 'tequila',
  'FFE737': 'pac-man',
  'FFE772': 'kournikova',
  'FFE7EB': 'porcelain-skin',
  'FFE8BB': 'gold-buttercup',
  'FFE8BD': 'creamy-apricot',
  'FFE8C3': 'candle-glow',
  'FFE8F4': 'fairy-dust',
  'FFE989': 'quack-quack',
  'FFE9C5': 'chess-ivory',
  'FFEA70': 'fuzzy-duckling',
  'FFEAC8': 'sandy-beach',
  'FFEAD4': 'karry',
  'FFEAEB': 'pink-lemonade',
  'FFEBCD': 'blanched-almond',
  'FFEBEE': 'just-pink-enough',
  'FFEBFA': 'strawberry-bonbon',
  'FFEC13': 'broom',
  'FFEDBC': 'colonial-white',
  'FFEDEF': 'translucent-unicorn',
  'FFEDF1': 'sugar-coated',
  'FFEDF8': 'partial-pink',
  'FFEE00': 'sailor-moon',
  'FFEE11': 'lemon-curd',
  'FFEE15': 'pure-sunshine',
  'FFEE33': 'yellow-bellied',
  'FFEE44': 'hollandaise',
  'FFEE88': 'sp-tzle-yellow',
  'FFEEA5': 'sour-lemon',
  'FFEED8': 'derby',
  'FFEF00': 'canary-yellow',
  'FFEFA1': 'vis-vis',
  'FFEFC1': 'egg-white',
  'FFEFD5': 'papaya-whip',
  'FFEFD6': 'blank-canvas',
  'FFEFDD': 'delicate-seashell',
  'FFEFEC': 'fair-pink',
  'FFEFF3': 'powder-puff',
  'FFF000': 'yellow-rose',
  'FFF0A4': 'buttered-popcorn',
  'FFF0B2': 'creamy-lemon',
  'FFF0CF': 'walnut-milkies',
  'FFF0DB': 'peach-cream',
  'FFF0E1': 'sugar-glaze',
  'FFF0F5': 'lavender-blush',
  'FFF14F': 'gorse',
  'FFF1B5': 'buttermilk',
  'FFF1D8': 'pink-lady',
  'FFF1DC': 'flickering-light',
  'FFF1EE': 'forget-me-not',
  'FFF1F9': 'tutu',
  'FFF200': 'dorn-yellow',
  'FFF2D9': 'malibu-sun',
  'FFF39A': 'goldilocks',
  'FFF39D': 'picasso',
  'FFF3A1': 'firefly-glow',
  'FFF3D5': 'hazelwood',
  'FFF3F1': 'chardon',
  'FFF44F': 'lemon-yellow',
  'FFF46E': 'paris-daisy',
  'FFF49C': 'banana-cream',
  'FFF4CE': 'barley-white',
  'FFF4DD': 'egg-sour',
  'FFF4E0': 'sazerac',
  'FFF4E8': 'serenade',
  'FFF4F3': 'chablis',
  'FFF5CF': 'stereotypical-duck',
  'FFF5E0': 'creamy-cloud-dreams',
  'FFF5E7': 'soft-pillow',
  'FFF5EE': 'seashell',
  'FFF5F3': 'sauvignon',
  'FFF600': 'cadmium-yellow',
  'FFF6B9': 'glowlight',
  'FFF6D4': 'milk-punch',
  'FFF6D7': 'natural-wool',
  'FFF6D9': 'hot-beach',
  'FFF6DF': 'varden',
  'FFF6F5': 'rose-white',
  'FFF700': 'lemon',
  'FFF7AD': 'banana-milk',
  'FFF7DB': 'buttermelon',
  'FFF7ED': 'fatback',
  'FFF8D1': 'baja-white',
  'FFF8DC': 'cornsilk',
  'FFF8E7': 'cosmic-latte',
  'FFF917': 'sunny-yellow',
  'FFF9D8': 'warm-light',
  'FFF9E2': 'gin-fizz',
  'FFF9E6': 'early-dawn',
  'FFF9E7': 'down-feathers',
  'FFF9EB': 'toasted-marshmallow-fluff',
  'FFF9F5': 'sugar-milk',
  'FFFACD': 'lemon-chiffon',
  'FFFAF0': 'floral-white',
  'FFFAF4': 'bridal-heath',
  'FFFAFA': 'snow',
  'FFFB08': 'banana-king',
  'FFFBAB': 'bollywood-gold',
  'FFFBDC': 'scotch-mist',
  'FFFBF8': 'eyeball',
  'FFFBF9': 'soapstone',
  'FFFC79': 'banana',
  'FFFC99': 'witch-haze',
  'FFFCD7': 'sweet-butter',
  'FFFCDA': 'cheesecake',
  'FFFCEA': 'buttery-white',
  'FFFCEC': 'glamour-white',
  'FFFCEE': 'island-spice',
  'FFFDD0': 'cream',
  'FFFDE6': 'chilean-heath',
  'FFFDE8': 'travertine',
  'FFFDEB': 'sparkling-cider',
  'FFFDF3': 'orchid-white',
  'FFFE00': 'yell-for-yellow',
  'FFFE71': 'super-banana',
  'FFFED8': 'lit',
  'FFFED9': 'sun-city',
  'FFFEE1': 'half-and-half',
  'FFFEE5': 'wedding-in-white',
  'FFFEEC': 'apricot-white',
  'FFFEF6': 'black-white',
  'FFFEFD': 'romance',
  'FFFF00': 'yellow',
  'FFFF14': 'yellow-submarine',
  'FFFF31': 'daffodil',
  'FFFF33': 'electric-yellow',
  'FFFF44': 'peppy-pineapple',
  'FFFF66': 'unmellow-yellow',
  'FFFF77': 'hive',
  'FFFF81': 'butter',
  'FFFF99': 'pale-canary',
  'FFFFAA': 'ginger-lemon-tea',
  'FFFFB4': 'portafino',
  'FFFFBF': 'sour-veil',
  'FFFFD4': 'matt-white',
  'FFFFDD': 'parmesan',
  'FFFFE0': 'light-yellow',
  'FFFFE3': 'lambs-wool',
  'FFFFE5': 'la-luna',
  'FFFFEA': 'northern-star',
  'FFFFEB': 'vanilla-drop',
  'FFFFF0': 'ivory',
  'FFFFFF': 'white',
};

// HEX_CODES is the exact inverse of COLOR_NAMES (color name -> lowercase hex). It
// was previously a second ~6.5k-line hand-synced literal map; deriving it once at
// module load removes ~175 KB of duplicate source from the bundle. Verified to
// reproduce the former literal byte-for-byte: 6585 entries, no name collisions.
export const HEX_CODES: { [ name: string ]: string } = ( () => {
  const out: { [ name: string ]: string } = {};
  const names = COLOR_NAMES as { [ hex: string ]: string };
  for ( const hex of Object.keys( names ) ) {
    out[ names[ hex ] ] = hex.toLowerCase();
  }
  return out;
} )();
